/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date string ignorant of time and zone, such as 2007-12-03, compliant with the `date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates using the Gregorian calendar. */
  Date: { input: string; output: string; }
  /** A date string ignorant of time and zone, such as 2007-12-03, compliant with the `date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates using the Gregorian calendar.. DateLike allows full ISO 8601 DateTime stamps, trimming out the date during parsing. Mainly used for backward compatibility */
  DateLike: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: string; output: string; }
  /** An arbitrary-precision Decimal type. */
  Decimal: { input: number; output: number; }
  Json: { input: any; output: any; }
  /** Float/String for OrderMetric.value */
  MetricValue: { input: number | string; output: number | string; }
};

export type AcceptPlatformTermsOfUseInput = {
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  presentation: Scalars['String']['input'];
};

export enum AccessDirection {
  GrantedBy = 'GRANTED_BY',
  GrantedTo = 'GRANTED_TO'
}

export type AccountBalance = {
  __typename?: 'AccountBalance';
  accountCode: Scalars['String']['output'];
  credits: Scalars['Decimal']['output'];
  debits: Scalars['Decimal']['output'];
  net: Scalars['Decimal']['output'];
};

/** Accounting basis: accrual (default) or cash. */
export enum AccountingBasis {
  Accrual = 'accrual',
  Cash = 'cash'
}

export type AccountingConfig = {
  __typename?: 'AccountingConfig';
  accountingPeriodGranularity: PeriodGranularity;
  basis: AccountingBasis;
  isBasisLocked: Scalars['Boolean']['output'];
  isGranularityLocked: Scalars['Boolean']['output'];
  isTimezoneLocked: Scalars['Boolean']['output'];
  timezone: Scalars['String']['output'];
};

export type AccountingConfigInput = {
  accountingPeriodGranularity?: InputMaybe<PeriodGranularity>;
  basis?: InputMaybe<AccountingBasis>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type AccountingIntegration = {
  __typename?: 'AccountingIntegration';
  clearingAccount?: Maybe<ExternalAccountRef>;
  config?: Maybe<AccountingPostingConfig>;
  connected: Scalars['Boolean']['output'];
  mappings: Array<GlAccountMapping>;
  provider: AccountingIntegrationProvider;
  supportedDimensions: Array<GlDimensionKind>;
  unmappedAccountCodes: Array<Scalars['String']['output']>;
};

/** Accounting platform a tenant posts to. One per tenant. */
export enum AccountingIntegrationProvider {
  Netsuite = 'netsuite',
  QuickbooksOnline = 'quickbooks_online'
}

export type AccountingMutations = {
  __typename?: 'AccountingMutations';
  closePeriod: AccountingMutationsClosePeriodResponse;
  connectNetsuite?: Maybe<AccountingIntegration>;
  createRevenueMappingRule: RevenueMappingRule;
  deactivateRevenueMappingRule: RevenueMappingRule;
  exportLedger: AccountingMutationsExportLedgerResponse;
  generateLedgerReport: AccountingMutationsGenerateReportResponse;
  markInvoicesAsLegacy: AccountingMutationsMarkInvoicesAsLegacyResponse;
  prepareNetsuiteConnection: NetsuiteCertificate;
  provisionAccountingIntegration: AccountingPostingConfig;
  requestLedgerReport: AccountingMutationsRequestReportResponse;
  setNetsuiteSubsidiary: NetsuiteConnection;
  softPostPeriod: AccountingMutationsSoftPostPeriodResponse;
  updateRevenueMappingRule: RevenueMappingRule;
  upsertAccountingConfig: AccountingConfig;
  upsertAccountingPostingConfig: AccountingPostingConfig;
  upsertBankAccountGlMapping: BankAccountGlMapping;
  upsertGlAccountMapping: GlAccountMapping;
};


export type AccountingMutationsClosePeriodArgs = {
  periodId: Scalars['Int']['input'];
};


export type AccountingMutationsConnectNetsuiteArgs = {
  certificateId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
};


export type AccountingMutationsCreateRevenueMappingRuleArgs = {
  input: RevenueMappingRuleInput;
};


export type AccountingMutationsDeactivateRevenueMappingRuleArgs = {
  id: Scalars['Int']['input'];
};


export type AccountingMutationsExportLedgerArgs = {
  delta?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<LedgerEntriesFilterInput>;
  format?: InputMaybe<LedgerExportFormat>;
  periodId: Scalars['Int']['input'];
};


export type AccountingMutationsGenerateLedgerReportArgs = {
  reportId: Scalars['Int']['input'];
};


export type AccountingMutationsMarkInvoicesAsLegacyArgs = {
  invoiceIds: Array<Scalars['ID']['input']>;
};


export type AccountingMutationsPrepareNetsuiteConnectionArgs = {
  accountId: Scalars['String']['input'];
};


export type AccountingMutationsRequestLedgerReportArgs = {
  periodId: Scalars['Int']['input'];
};


export type AccountingMutationsSetNetsuiteSubsidiaryArgs = {
  subsidiaryId: Scalars['String']['input'];
};


export type AccountingMutationsSoftPostPeriodArgs = {
  periodId: Scalars['Int']['input'];
};


export type AccountingMutationsUpdateRevenueMappingRuleArgs = {
  id: Scalars['Int']['input'];
  input: RevenueMappingRuleInput;
};


export type AccountingMutationsUpsertAccountingConfigArgs = {
  input: AccountingConfigInput;
};


export type AccountingMutationsUpsertAccountingPostingConfigArgs = {
  input: AccountingPostingConfigInput;
};


export type AccountingMutationsUpsertBankAccountGlMappingArgs = {
  input: BankAccountGlMappingInput;
};


export type AccountingMutationsUpsertGlAccountMappingArgs = {
  input: GlAccountMappingInput;
};

export type AccountingMutationsClosePeriodResponse = {
  __typename?: 'AccountingMutationsClosePeriodResponse';
  period: AccountingPeriod;
  report: LedgerReport;
};

export type AccountingMutationsExportLedgerResponse = {
  __typename?: 'AccountingMutationsExportLedgerResponse';
  export: LedgerExport;
  filename: Scalars['String']['output'];
  rowCount: Scalars['Int']['output'];
};

export type AccountingMutationsGenerateReportResponse = {
  __typename?: 'AccountingMutationsGenerateReportResponse';
  report: LedgerReport;
};

export type AccountingMutationsMarkInvoicesAsLegacyResponse = {
  __typename?: 'AccountingMutationsMarkInvoicesAsLegacyResponse';
  count: Scalars['Int']['output'];
};

export type AccountingMutationsRequestReportResponse = {
  __typename?: 'AccountingMutationsRequestReportResponse';
  period: AccountingPeriod;
  report: LedgerReport;
};

export type AccountingMutationsSoftPostPeriodResponse = {
  __typename?: 'AccountingMutationsSoftPostPeriodResponse';
  previewStatus?: Maybe<LedgerReportStatus>;
  success: Scalars['Boolean']['output'];
};

export type AccountingPeriod = {
  __typename?: 'AccountingPeriod';
  canExport: Scalars['Boolean']['output'];
  canRegeneratePreview: Scalars['Boolean']['output'];
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  closedByActorGuid?: Maybe<Scalars['Int']['output']>;
  endDate: Scalars['DateTime']['output'];
  granularity: PeriodGranularity;
  id: Scalars['Int']['output'];
  isClosable: Scalars['Boolean']['output'];
  lastSoftPostAt?: Maybe<Scalars['DateTime']['output']>;
  latestReport?: Maybe<LedgerReport>;
  previewLastError?: Maybe<Scalars['String']['output']>;
  previewRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  previewStatus?: Maybe<LedgerReportStatus>;
  startDate: Scalars['DateTime']['output'];
  status: AccountingPeriodStatus;
};

export type AccountingPeriodOrderByInput = {
  startDate?: InputMaybe<SortOrderInput>;
};

export enum AccountingPeriodStatus {
  Closed = 'closed',
  Open = 'open'
}

export type AccountingPostingConfig = {
  __typename?: 'AccountingPostingConfig';
  clearingExternalAccountId?: Maybe<Scalars['String']['output']>;
  clearingExternalAccountName?: Maybe<Scalars['String']['output']>;
  defaultExternalEntityId?: Maybe<Scalars['String']['output']>;
  defaultExternalEntityName?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  ledgerPostingPolicy: LedgerPostingPolicy;
  postDeposits: Scalars['Boolean']['output'];
  provider: AccountingIntegrationProvider;
};

export type AccountingPostingConfigInput = {
  clearingExternalAccountId?: InputMaybe<Scalars['String']['input']>;
  clearingExternalAccountName?: InputMaybe<Scalars['String']['input']>;
  defaultExternalEntityId?: InputMaybe<Scalars['String']['input']>;
  defaultExternalEntityName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  ledgerPostingPolicy?: InputMaybe<LedgerPostingPolicy>;
  postDeposits?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<AccountingIntegrationProvider>;
};

export type AccountsReceivableReport = {
  __typename?: 'AccountsReceivableReport';
  accounts: Array<AccountsReceivableReportRow>;
};

export type AccountsReceivableReportBucket = {
  __typename?: 'AccountsReceivableReportBucket';
  amount: Scalars['Decimal']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type AccountsReceivableReportRow = {
  __typename?: 'AccountsReceivableReportRow';
  buckets: Array<AccountsReceivableReportBucket>;
  customer: Customer;
  overdue: Scalars['Decimal']['output'];
  total: Scalars['Decimal']['output'];
};

export type AccountsReceivableReportTransaction = {
  __typename?: 'AccountsReceivableReportTransaction';
  bucket: Scalars['String']['output'];
  date: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  openAmount: Scalars['Decimal']['output'];
  originalAmount: Scalars['Decimal']['output'];
  type: AccountsReceivableReportTransactionType;
};

export enum AccountsReceivableReportTransactionType {
  Invoice = 'invoice',
  UnappliedPayment = 'unapplied_payment'
}

export type AccountsReceivableReportTransactionsWhere = {
  date?: InputMaybe<Scalars['DateLike']['input']>;
};

export type AccountsReceivableReportWhere = {
  date?: InputMaybe<Scalars['DateLike']['input']>;
  includeUnappliedCredit?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AcknowledgeAssignmentInput = {
  id: Scalars['Int']['input'];
};

export type AcknowledgeMessageInput = {
  id: Scalars['Int']['input'];
};

export type ActivityAlert = {
  __typename?: 'ActivityAlert';
  actorName?: Maybe<Scalars['String']['output']>;
  branchId?: Maybe<Scalars['Int']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  /** Latest change-request text, on ORDER_CHANGE_REQUESTED alerts only. */
  detail?: Maybe<Scalars['String']['output']>;
  dueAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  kind: ActivityAlertKind;
  /** Operator behind the alert; null on ROUTE_UNDISPATCHED means no crew is assigned. */
  operatorId?: Maybe<Scalars['Int']['output']>;
  orders: Array<ActivityOrder>;
  /** Service on the order behind an order-targeted alert. */
  serviceName?: Maybe<Scalars['String']['output']>;
  target: ActivityTarget;
  title: Scalars['String']['output'];
};

export enum ActivityAlertKind {
  AssignmentUnacknowledged = 'ASSIGNMENT_UNACKNOWLEDGED',
  OrderChangeRequested = 'ORDER_CHANGE_REQUESTED',
  OrderUnconfirmed = 'ORDER_UNCONFIRMED',
  RouteUndispatched = 'ROUTE_UNDISPATCHED'
}

export type ActivityAlertsFilterInput = {
  /** Scope the alerts to a single branch. */
  branchId?: InputMaybe<Scalars['Int']['input']>;
  /** ISO-8601 datetime, inclusive lower bound on the alert due time. */
  dueAfter?: InputMaybe<Scalars['String']['input']>;
  /** ISO-8601 datetime, inclusive upper bound on the alert due time. */
  dueBefore?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityEvent = {
  __typename?: 'ActivityEvent';
  actorName?: Maybe<Scalars['String']['output']>;
  branchId?: Maybe<Scalars['Int']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  occurredAt: Scalars['DateTime']['output'];
  order?: Maybe<ActivityOrder>;
  summary: Scalars['String']['output'];
  target: ActivityTarget;
  type: ActivityEventType;
};

export enum ActivityEventType {
  ChangeRequested = 'CHANGE_REQUESTED'
}

export type ActivityEventsFilterInput = {
  /** Scope the feed to a single branch. */
  branchId?: InputMaybe<Scalars['Int']['input']>;
  /** yyyy-MM-dd, inclusive (UTC day). */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** yyyy-MM-dd, inclusive (UTC day). */
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityOrder = {
  __typename?: 'ActivityOrder';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ActivityTarget = {
  __typename?: 'ActivityTarget';
  branchId?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  kind: ActivityTargetKind;
};

export enum ActivityTargetKind {
  Order = 'ORDER',
  Schedule = 'SCHEDULE'
}

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  estimateTravelFrom?: Maybe<Array<TravelEstimate>>;
  estimateTravelTo?: Maybe<Array<TravelEstimate>>;
  geoArea?: Maybe<GeoArea>;
  id: Scalars['Int']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};


export type AddressEstimateTravelFromArgs = {
  addressIds: Array<Scalars['Int']['input']>;
};


export type AddressEstimateTravelToArgs = {
  addressIds: Array<Scalars['Int']['input']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type Aircall = {
  __typename?: 'Aircall';
  settings?: Maybe<AircallSettings>;
  token?: Maybe<IntegrationToken>;
};

export type AircallSettings = {
  __typename?: 'AircallSettings';
  enabled: Scalars['Boolean']['output'];
};

export enum AllocationType {
  CustomerCredit = 'customer_credit',
  FeeIncome = 'fee_income',
  Invoice = 'invoice',
  Refund = 'refund'
}

export enum AllocationTypeEnum {
  CustomerCredit = 'customer_credit',
  FeeIncome = 'fee_income',
  Invoice = 'invoice',
  Refund = 'refund'
}

export type AppFeatures = {
  __typename?: 'AppFeatures';
  /** @deprecated Use Organization.config (crew.*, modules.*, localization.*) instead */
  crew: CrewAppFeatures;
  /** @deprecated Use Organization.config + me.flags instead (BFF projection migrates with the payments rework) */
  customer: CustomerAppFeatures;
  /** @deprecated Use Organization.config + me.flags instead */
  dashboard: DashboardFeatures;
};

export type ApplyCreditMemoInput = {
  customerId: Scalars['Int']['input'];
  distributions: Array<DistributedCreditBalanceInput>;
};

export type Assignment = {
  __typename?: 'Assignment';
  acknowledged?: Maybe<Scalars['Boolean']['output']>;
  acknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  crewAddendumMarkdown?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  operator: Operator;
  operatorId: Scalars['Int']['output'];
  role: Scalars['String']['output'];
  roleDetails: AssignmentRole;
  route?: Maybe<Route>;
  updatedAt: Scalars['DateTime']['output'];
  usesOnsiteTimes: Scalars['Boolean']['output'];
};

export type AssignmentInput = {
  operatorId: Scalars['Int']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
};

export type AssignmentRole = {
  __typename?: 'AssignmentRole';
  active: Scalars['Boolean']['output'];
  billable: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AssignmentsInput = {
  set?: InputMaybe<Array<AssignmentInput>>;
};

export type Attachment = {
  __typename?: 'Attachment';
  bytes?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  metadata?: Maybe<Array<KeyValue>>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type AttachmentCreateInput = {
  bytes?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<KeyValuesInput>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type AttachmentWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type AttachmentsInput = {
  create?: InputMaybe<Array<AttachmentCreateInput>>;
  delete?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
};

export type AuthMutations = {
  __typename?: 'AuthMutations';
  issueLoginCode: AuthMutationsIssueLoginCodeResponse;
  login?: Maybe<AuthMutationsLoginResponse>;
  refresh?: Maybe<AuthMutationsRefreshResponse>;
  switchOrganization?: Maybe<AuthMutationsRefreshResponse>;
  verifyLoginCode: AuthMutationsVerifyLoginCodeResponse;
};


export type AuthMutationsIssueLoginCodeArgs = {
  data: AuthMutationsIssueLoginCodeDataInput;
};


export type AuthMutationsLoginArgs = {
  data: AuthMutationsLoginInput;
};


export type AuthMutationsRefreshArgs = {
  data?: InputMaybe<AuthMutationsRefreshInput>;
};


export type AuthMutationsSwitchOrganizationArgs = {
  data: AuthMutationsSwitchOrganizationInput;
};


export type AuthMutationsVerifyLoginCodeArgs = {
  data: AuthMutationsVerifyLoginCodeDataInput;
};

export type AuthMutationsIssueLoginCodeDataInput = {
  identity: Scalars['String']['input'];
};

export type AuthMutationsIssueLoginCodeResponse = {
  __typename?: 'AuthMutationsIssueLoginCodeResponse';
  expiresAt: Scalars['DateTime']['output'];
  loginKey: Scalars['String']['output'];
};

export type AuthMutationsLoginInput = {
  clientId: Scalars['String']['input'];
  /** auth.cretesuite.com identity jwt */
  jwt: Scalars['String']['input'];
};

export type AuthMutationsLoginResponse = {
  __typename?: 'AuthMutationsLoginResponse';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type AuthMutationsRefreshInput = {
  /** refreshToken returned from the auth.login Mutation */
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};

export type AuthMutationsRefreshResponse = {
  __typename?: 'AuthMutationsRefreshResponse';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type AuthMutationsSwitchOrganizationInput = {
  /** Fallback when the refresh token is not sent via the cs_refresh_token cookie (e.g. dev/http). */
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  /** Target organization ID. Must be in the token tids allow-list. */
  tid: Scalars['Int']['input'];
};

export type AuthMutationsVerifyLoginCodeDataInput = {
  code: Scalars['String']['input'];
  loginKey: Scalars['String']['input'];
};

export type AuthMutationsVerifyLoginCodeResponse = {
  __typename?: 'AuthMutationsVerifyLoginCodeResponse';
  token?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type Authorization = {
  __typename?: 'Authorization';
  /** jwt token granting access to api */
  token?: Maybe<Scalars['String']['output']>;
};

export type AutoAssignDefaultOperatorsInput = {
  /** Override existing assignments even for dispatched routes */
  forceOverride?: InputMaybe<Scalars['Boolean']['input']>;
  /** Order ID - will find the route from the order */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /** Route ID to update operator assignments for */
  routeId?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignDefaultOperatorsResult = {
  __typename?: 'AutoAssignDefaultOperatorsResult';
  /** Number of assignments that were created/updated */
  assignmentsUpdated: Scalars['Int']['output'];
  /** Name of the default operator assigned, if any */
  defaultOperatorName?: Maybe<Scalars['String']['output']>;
  /** Route ID that was updated */
  routeId?: Maybe<Scalars['Int']['output']>;
  /** Number of default operator assignments skipped because the operator has approved time off overlapping the route window */
  skippedTimeOffAssignments: Scalars['Int']['output'];
  /** Display names of operators whose assignment was skipped due to time off (same order as skipped count) */
  skippedTimeOffOperatorNames?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  /** Whether the route was in dispatched status at time of operation */
  wasDispatched?: Maybe<Scalars['Boolean']['output']>;
};

export type AvailableTeamWhereInput = {
  branchId?: InputMaybe<IntFilter>;
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type BankAccount = {
  __typename?: 'BankAccount';
  active: Scalars['Boolean']['output'];
  glMapping?: Maybe<BankAccountGlMapping>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BankAccountGlMapping = {
  __typename?: 'BankAccountGlMapping';
  externalAccountId: Scalars['String']['output'];
  externalAccountName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  provider: AccountingIntegrationProvider;
};

export type BankAccountGlMappingInput = {
  bankAccountId: Scalars['String']['input'];
  externalAccountId: Scalars['String']['input'];
  externalAccountName: Scalars['String']['input'];
};

export type BillingProfile = {
  __typename?: 'BillingProfile';
  address: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  documentTitle: Scalars['String']['output'];
  email: Scalars['String']['output'];
  extra: Array<Scalars['String']['output']>;
  footer: Array<Scalars['String']['output']>;
  geocodedAddress?: Maybe<Address>;
  header: Array<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  locale: Scalars['String']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  memo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BillingProfileInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  footer?: InputMaybe<Array<Scalars['String']['input']>>;
  header?: InputMaybe<Array<Scalars['String']['input']>>;
  memo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type Branch = {
  __typename?: 'Branch';
  active: Scalars['Boolean']['output'];
  additionalIds?: Maybe<Array<KeyValue>>;
  /** @deprecated DEPRECATED: use yards instead */
  address: Address;
  /** @deprecated DEPRECATED: use yards instead */
  addressId: Scalars['Int']['output'];
  alertPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  defaultPriceList?: Maybe<PriceList>;
  equipment: Array<Equipment>;
  id: Scalars['Int']['output'];
  integrations?: Maybe<BranchIntegrations>;
  inventory: Array<InventoryItem>;
  mainlinePhone?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  operators: Array<Operator>;
  organization: Organization;
  phones: Array<Phone>;
  priceLists: Array<PriceList>;
  suppliers: Array<Supplier>;
  timezone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  yards: Array<Yard>;
};

export type BranchInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  address?: InputMaybe<AddressInput>;
  alertPhone?: InputMaybe<Scalars['String']['input']>;
  defaultPriceList?: InputMaybe<PriceListWhereUniqueInput>;
  mainlinePhone?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<KeyValuesInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  priceLists?: InputMaybe<Array<PriceListWhereUniqueInput>>;
  yards?: InputMaybe<YardsInput>;
};

export type BranchIntegrations = {
  __typename?: 'BranchIntegrations';
  all: Array<KeyValue>;
};

export type BranchUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  address?: InputMaybe<AddressInput>;
  alertPhone?: InputMaybe<Scalars['String']['input']>;
  defaultPriceList?: InputMaybe<PriceListWhereUniqueInput>;
  mainlinePhone?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<KeyValuesInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  priceLists?: InputMaybe<Array<PriceListWhereUniqueInput>>;
  yards?: InputMaybe<YardsInput>;
};

export type BranchWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type CalculatePaymentFeesInput = {
  amount: Scalars['Decimal']['input'];
  customerId: Scalars['Int']['input'];
  /** If true, the provided amount is considered the total payment amount including fees. The base invoice amount will be calculated by reversing the fees. */
  includesFees?: Scalars['Boolean']['input'];
  paymentMethodType: PaymentMethodType;
};

export type Changelog = {
  __typename?: 'Changelog';
  entries: Array<ChangelogEntry>;
};

export type ChangelogEntry = {
  __typename?: 'ChangelogEntry';
  by?: Maybe<Scalars['String']['output']>;
  change: Scalars['Json']['output'];
  diff: Scalars['Json']['output'];
  event: Scalars['String']['output'];
  /** IP address recorded for the session */
  ip?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `by` instead */
  person?: Maybe<Person>;
  /** Session the change was made in, `${sessionEventId}-${refreshSequence}` */
  sid?: Maybe<Scalars['String']['output']>;
  /** User agent recorded for the session */
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type ChangelogWhereInput = {
  id: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
};

export type CheckOrdersFitInNewRouteInput = {
  equipmentId: Scalars['Int']['input'];
  orderIds: Array<Scalars['Int']['input']>;
};

export type CheckOrdersFitInRouteInput = {
  orderIds: Array<Scalars['Int']['input']>;
  routeId: Scalars['Int']['input'];
};

export type CollectOrderDetailsInput = {
  purchaseOrder?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<OrderSiteInput>;
};

export type CollectSignatureInput = {
  image: Scalars['String']['input'];
  metadata?: InputMaybe<KeyValuesInput>;
  personId?: InputMaybe<Scalars['Int']['input']>;
};

export type Comment = {
  __typename?: 'Comment';
  active: Scalars['Boolean']['output'];
  additionalIds: Array<KeyValue>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  metadata: Array<KeyValue>;
  person?: Maybe<Person>;
  personId?: Maybe<Scalars['Int']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CommentInput = {
  additionalIds?: InputMaybe<KeyValuesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<KeyValuesInput>;
  personId?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommentUpdateArgs = {
  data: CommentUpdateInput;
  where: CommentWhereUniqueInput;
};

export type CommentUpdateInput = {
  additionalIds?: InputMaybe<KeyValuesInput>;
  metadata?: InputMaybe<KeyValuesInput>;
  text: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommentWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type CommentsInput = {
  add?: InputMaybe<Array<CommentInput>>;
  connect?: InputMaybe<Array<Scalars['Int']['input']>>;
  create?: InputMaybe<Array<CommentInput>>;
  update?: InputMaybe<Array<CommentUpdateArgs>>;
};

export type Contact = PersonInterface & {
  __typename?: 'Contact';
  active: Scalars['Boolean']['output'];
  additionalIds?: Maybe<Array<KeyValue>>;
  appFeatures: AppFeatures;
  changelog?: Maybe<Changelog>;
  createdAt: Scalars['DateTime']['output'];
  customers: Array<Customer>;
  emails: Array<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** A single feature flag; null for keys not in the flag registry. */
  flag?: Maybe<Scalars['Boolean']['output']>;
  /** Viewer-scoped feature flags: the tenant bag with registry defaults applied for unset keys, plus viewer overlays. */
  flags: Scalars['Json']['output'];
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  messages: Array<Message>;
  notes?: Maybe<Scalars['String']['output']>;
  notificationRuleOverrides: Array<NotificationRuleOverride>;
  orders?: Maybe<Array<Order>>;
  organization: Organization;
  phones: Array<Phone>;
  preferences: ContactPreferences;
  roles: Array<ContactRole>;
  tags: Array<Tag>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type ContactFlagArgs = {
  key: Scalars['String']['input'];
};


export type ContactOrdersArgs = {
  orderBy?: InputMaybe<Array<QueryOrdersOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryOrdersWhereInput>;
};

export type ContactInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  customerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phones?: InputMaybe<Array<PhoneInput>>;
  preferences?: InputMaybe<ContactPreferencesInput>;
  roleIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tags?: InputMaybe<TagsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContactMutations = {
  __typename?: 'ContactMutations';
  create?: Maybe<ContactMutationsCreateResponse>;
  update?: Maybe<ContactMutationsUpdateResponse>;
  validatePhone?: Maybe<ContactMutationsValidatePhoneResponse>;
};


export type ContactMutationsCreateArgs = {
  data: ContactInput;
};


export type ContactMutationsUpdateArgs = {
  data: ContactUpdateInput;
  where: ContactWhereUniqueInput;
};


export type ContactMutationsValidatePhoneArgs = {
  data: ContactValidatePhoneInput;
};

export type ContactMutationsCreateResponse = {
  __typename?: 'ContactMutationsCreateResponse';
  contact: Contact;
  warnings?: Maybe<ContactMutationsResponseWarnings>;
};

export type ContactMutationsResponseWarnings = {
  __typename?: 'ContactMutationsResponseWarnings';
  invalidPhones: Array<Scalars['String']['output']>;
  landlinePhones: Array<Scalars['String']['output']>;
};

export type ContactMutationsUpdateResponse = {
  __typename?: 'ContactMutationsUpdateResponse';
  contact: Contact;
  warnings?: Maybe<ContactMutationsResponseWarnings>;
};

export type ContactMutationsValidatePhoneResponse = {
  __typename?: 'ContactMutationsValidatePhoneResponse';
  existingContact?: Maybe<Contact>;
  isValid: Scalars['Boolean']['output'];
};

export type ContactPreferences = {
  __typename?: 'ContactPreferences';
  messages: Array<MessagePreference>;
};

export type ContactPreferencesInput = {
  messages?: InputMaybe<MessagePreferencesInput>;
};

export type ContactRole = {
  __typename?: 'ContactRole';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ContactUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  customerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phones?: InputMaybe<Array<PhoneInput>>;
  preferences?: InputMaybe<ContactPreferencesInput>;
  roleIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tags?: InputMaybe<TagsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContactValidatePhoneInput = {
  phoneNumber: Scalars['String']['input'];
};

export type ContactWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCreditMemoInput = {
  amount: Scalars['Decimal']['input'];
  customerId: Scalars['Int']['input'];
  date: Scalars['DateLike']['input'];
  memo?: InputMaybe<Scalars['String']['input']>;
  txId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDepositDraftInput = {
  controlTotal?: InputMaybe<Scalars['Decimal']['input']>;
  depositDate: Scalars['DateLike']['input'];
  externalDepositRef?: InputMaybe<Scalars['String']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  paymentIds: Array<Scalars['String']['input']>;
};

export type CreateDigitalPaymentInput = {
  allocations: Array<PaymentAllocationInput>;
  amount: Scalars['Decimal']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  date?: InputMaybe<Scalars['DateLike']['input']>;
  paymentMethodId: Scalars['String']['input'];
  txId?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePaymentInput = {
  allocations: Array<PaymentAllocationInput>;
  amount: Scalars['Decimal']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  date?: InputMaybe<Scalars['DateLike']['input']>;
  /** Mobile fast path: also create and finalize a single-payment deposit for this payment */
  recordAsDeposit?: InputMaybe<Scalars['Boolean']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  sourceId: Scalars['String']['input'];
  txId?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePreparedPaymentInput = {
  customerId: Scalars['String']['input'];
  invoices?: InputMaybe<Array<PreparedPaymentInvoiceInput>>;
  lumpSumAmount?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CreateSinglePaymentDepositInput = {
  paymentId: Scalars['String']['input'];
  txId?: InputMaybe<Scalars['String']['input']>;
};

export type Credential = {
  __typename?: 'Credential';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  expirationDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  images: Array<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  pinned: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  typeDetails: CredentialType;
  updatedAt: Scalars['DateTime']['output'];
};

export type CredentialInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  number?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  typeName?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialType = {
  __typename?: 'CredentialType';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CredentialUpsertInput = {
  data: CredentialInput;
  where?: InputMaybe<CredentialWhereUniqueInput>;
};

export type CredentialWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type CredentialsInput = {
  delete?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  upsert?: InputMaybe<Array<CredentialUpsertInput>>;
};

export type CreditMemo = {
  __typename?: 'CreditMemo';
  amount: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  customer: Customer;
  date: Scalars['DateTime']['output'];
  memo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  processedDate: Scalars['DateTime']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CreditMemoMutations = {
  __typename?: 'CreditMemoMutations';
  create: CreditMemoMutationsCreateResponse;
  useCreditBalance: UseCreditBalanceResponse;
};


export type CreditMemoMutationsCreateArgs = {
  data: CreateCreditMemoInput;
};


export type CreditMemoMutationsUseCreditBalanceArgs = {
  data: ApplyCreditMemoInput;
};

export type CreditMemoMutationsCreateResponse = {
  __typename?: 'CreditMemoMutationsCreateResponse';
  creditMemo: CreditMemo;
};

export type CrewAppFeatures = {
  __typename?: 'CrewAppFeatures';
  /** @deprecated Use Organization.config.crew.assignmentHideDetailsTillAck instead */
  assignmentHideDetailsTillAcknowledgement: Scalars['Boolean']['output'];
  /** @deprecated Use Organization.config.crew.assignmentReportAtDuration instead */
  assignmentReportAtDuration: Scalars['Int']['output'];
  /** @deprecated Use Organization.config.localization.useCubicMeters instead */
  localeUseCubicMeters: Scalars['Boolean']['output'];
  /** @deprecated Use Organization.config.crew.orderAllowOperatorToCancel instead */
  orderAllowOperatorToCancel: Scalars['Boolean']['output'];
  /** @deprecated Use Organization.config.modules.timeclocks instead */
  timeclocksEnabled: Scalars['Boolean']['output'];
  /** @deprecated Use Organization.config.crew.workTicketRequireSignature instead */
  workTicketRequireSignature: Scalars['Boolean']['output'];
};

export type Customer = {
  __typename?: 'Customer';
  /** @deprecated use nickname instead */
  abbreviation: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  additionalIds?: Maybe<Array<KeyValue>>;
  balance: Scalars['Decimal']['output'];
  billingAddress?: Maybe<Address>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  billingSameAsPhysical?: Maybe<Scalars['Boolean']['output']>;
  changelog?: Maybe<Changelog>;
  contacts: Array<Contact>;
  createdAt: Scalars['DateTime']['output'];
  creditBalance: Scalars['Decimal']['output'];
  defaultPriceList?: Maybe<PriceList>;
  emails: Array<Scalars['String']['output']>;
  hasPaymentOnFile: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  includeWorkTicketWithInvoice: Scalars['Boolean']['output'];
  integrations?: Maybe<CustomerIntegrations>;
  isTaxExempt: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  name2?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  notificationRuleOverrides: Array<NotificationRuleOverride>;
  orderSettings?: Maybe<OrderSettings>;
  overdueBalance: Scalars['Decimal']['output'];
  paymentConfig: PaymentConfig;
  phones: Array<Phone>;
  physicalAddress?: Maybe<Address>;
  physicalAddressId?: Maybe<Scalars['Int']['output']>;
  priceLists: Array<PriceList>;
  sites: Array<Site>;
  tags: Array<Tag>;
  updatedAt: Scalars['DateTime']['output'];
};


export type CustomerContactsArgs = {
  where?: InputMaybe<CustomerContactsWhereInput>;
};


export type CustomerSitesArgs = {
  where?: InputMaybe<CustomerSitesWhereInput>;
};

export type CustomerAppFeatures = {
  __typename?: 'CustomerAppFeatures';
  /** @deprecated Interim flag me.flags['payments.canAcceptOnline'] until the payments rework builds the real predicate */
  canAcceptOnlinePayments: Scalars['Boolean']['output'];
  /** @deprecated Use Organization.config.currencyCode instead */
  currencyCode: Scalars['String']['output'];
  /** @deprecated Use Organization.config.localization.geocoderCountry instead */
  geocoderCountry: Scalars['String']['output'];
  /** @deprecated Use Organization.config.customerApp.hideOperatorContactInfo instead */
  hideOperatorContactInfo: Scalars['Boolean']['output'];
  /** @deprecated Use Organization.config.locale instead */
  locale: Scalars['String']['output'];
  /** @deprecated Use Organization.config.localization.useCubicMeters instead */
  localeUseCubicMeters: Scalars['Boolean']['output'];
  /** @deprecated Retired — always true */
  requestOrderDetails: Scalars['Boolean']['output'];
  /** @deprecated Use Organization.config.customerApp.requestPreWorkAuthorization instead */
  requestPreWorkAuthorization: Scalars['Boolean']['output'];
  /** @deprecated Use Organization.config.customerApp.requestWorkTicketSignature instead */
  requestWorkTicketSignature: Scalars['Boolean']['output'];
  /** @deprecated Derived (payments.csPayments OR QBO syncInvoices); moves with the payments rework */
  showInvoiceStatuses: Scalars['Boolean']['output'];
  /** @deprecated Retired — always true */
  showOrderDetailMenu: Scalars['Boolean']['output'];
};

export type CustomerContactsWhereInput = {
  active?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
};

export type CustomerInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  billingAddress?: InputMaybe<AddressInput>;
  billingSameAsPhysical?: InputMaybe<Scalars['Boolean']['input']>;
  defaultPriceList?: InputMaybe<PriceListWhereUniqueInput>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  includeWorkTicketWithInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxExempt?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  name2?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderSettings?: InputMaybe<OrderSettingsInput>;
  paymentConfig?: InputMaybe<PaymentConfigInput>;
  phones?: InputMaybe<Array<PhoneInput>>;
  physicalAddress?: InputMaybe<AddressInput>;
  priceLists?: InputMaybe<Array<PriceListWhereUniqueInput>>;
  tags?: InputMaybe<TagsInput>;
};

export type CustomerIntegrations = {
  __typename?: 'CustomerIntegrations';
  all: Array<KeyValue>;
  quickbooks?: Maybe<CustomerQuickbooksIntegration>;
};

export type CustomerMutations = {
  __typename?: 'CustomerMutations';
  sync: CustomerMutationsSyncResponse;
  validateExistence?: Maybe<CustomerMutationsValidateExistenceResponse>;
};


export type CustomerMutationsSyncArgs = {
  where: CustomerMutationsSyncWhereInput;
};


export type CustomerMutationsValidateExistenceArgs = {
  data: CustomerValidateExistenceInput;
};

export type CustomerMutationsSyncResponse = {
  __typename?: 'CustomerMutationsSyncResponse';
  customer?: Maybe<Customer>;
};

export type CustomerMutationsSyncWhereInput = {
  id: Scalars['Int']['input'];
};

export type CustomerMutationsValidateExistenceResponse = {
  __typename?: 'CustomerMutationsValidateExistenceResponse';
  existingCustomer?: Maybe<Customer>;
  isValid: Scalars['Boolean']['output'];
};

export type CustomerQuickbooksIntegration = {
  __typename?: 'CustomerQuickbooksIntegration';
  customer?: Maybe<QuickbooksCustomer>;
};

export type CustomerSitesWhereInput = {
  active?: InputMaybe<BoolFilter>;
  customerId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
};

export type CustomerUpdateInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  billingAddress?: InputMaybe<AddressInput>;
  billingSameAsPhysical?: InputMaybe<Scalars['Boolean']['input']>;
  defaultPriceList?: InputMaybe<PriceListWhereUniqueInput>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  includeWorkTicketWithInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxExempt?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name2?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderSettings?: InputMaybe<OrderSettingsInput>;
  paymentConfig?: InputMaybe<PaymentConfigInput>;
  phones?: InputMaybe<Array<PhoneInput>>;
  physicalAddress?: InputMaybe<AddressInput>;
  priceLists?: InputMaybe<Array<PriceListWhereUniqueInput>>;
  tags?: InputMaybe<TagsInput>;
};

export type CustomerValidateExistenceInput = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type DashboardBetaFeatures = {
  __typename?: 'DashboardBetaFeatures';
  activity_enabled?: Maybe<Scalars['Boolean']['output']>;
  contactSelect_showPhones_enabled?: Maybe<Scalars['Boolean']['output']>;
  invoicing_newWorkflowLabelsOnly_enabled?: Maybe<Scalars['Boolean']['output']>;
  invoicing_newWorkflow_enabled?: Maybe<Scalars['Boolean']['output']>;
  native_payments_enabled?: Maybe<Scalars['Boolean']['output']>;
  notificationRulesEngine_enabled?: Maybe<Scalars['Boolean']['output']>;
  order_site_copyPreviousOrderDetails_enabled?: Maybe<Scalars['Boolean']['output']>;
  payments_guaranteeGettingPaid?: Maybe<Scalars['Boolean']['output']>;
  pricing_peggedIndexes_enabled?: Maybe<Scalars['Boolean']['output']>;
  route_newJoinOrderToRoute_enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type DashboardFeatures = {
  __typename?: 'DashboardFeatures';
  /** @deprecated Use me.flags instead */
  beta: Scalars['Json']['output'];
  /** @deprecated Replaced by Support Access permission scopes (support/changelog) instead */
  changelog_enabled: Scalars['Boolean']['output'];
  /** @deprecated Retired — always false instead */
  customer_additionalIds_netsuite_enabled: Scalars['Boolean']['output'];
  /** @deprecated Mirrors me.flags['payments.stripe'] instead */
  customer_paymentConfig_enabled: Scalars['Boolean']['output'];
  /** @deprecated Replaced by Support Access permission scopes (support/equipmentTypesManagement) instead */
  equipmentTypes_management_enabled: Scalars['Boolean']['output'];
  /** @deprecated Use me.flags['equipment.defaultOperator'] instead */
  equipment_defaultOperator_enabled: Scalars['Boolean']['output'];
  /** @deprecated Retired — always false instead */
  equipment_scheduling_enabled: Scalars['Boolean']['output'];
  /** @deprecated Use Organization.config.integrations.aircall instead */
  integrations_aircall_enabled: Scalars['Boolean']['output'];
  /** @deprecated Use Organization.config.integrations.geotab instead */
  integrations_geotab_enabled: Scalars['Boolean']['output'];
  /** @deprecated Use Organization.config.integrations.paylocity instead */
  integrations_paylocity_enabled: Scalars['Boolean']['output'];
  /** @deprecated Use Organization.config.integrations.quickbooks instead */
  integrations_quickbooks_enabled: Scalars['Boolean']['output'];
  /** @deprecated Use Organization.config.integrations.samsara instead */
  integrations_samsara_enabled: Scalars['Boolean']['output'];
  /** @deprecated Use me.flags['integrations.samsaraPto'] instead */
  integrations_samsara_pto_enabled: Scalars['Boolean']['output'];
  /** @deprecated Replaced by Support Access permission scopes (support/inventoryAdmin) instead */
  inventory_admin_enabled: Scalars['Boolean']['output'];
  /** @deprecated Retired — always true instead */
  inventory_enabled: Scalars['Boolean']['output'];
  /** @deprecated Retired — always true instead */
  invoicing_enabled: Scalars['Boolean']['output'];
  /** @deprecated Replaced by Support Access permission scopes (support/invoicingManagement) instead */
  invoicing_management_enabled: Scalars['Boolean']['output'];
  /** @deprecated Use Organization.config.invoicing.versioning instead */
  invoicing_version_enabled: Scalars['Boolean']['output'];
  /** @deprecated Use Organization.config.localization.useCubicMeters instead */
  locale_useCubicMeters_enabled: Scalars['Boolean']['output'];
  /** @deprecated Retired — always false instead */
  maintenance_enabled: Scalars['Boolean']['output'];
  /** @deprecated Replaced by Support Access permission scopes (support/operatorsAvailability) instead */
  operators_availability_enabled: Scalars['Boolean']['output'];
  /** @deprecated Use Organization.config.order.defaultToPlannedTravel instead */
  order_defaultToPlannedTravel_enabled: Scalars['Boolean']['output'];
  /** @deprecated Retired — always true instead */
  order_requestDetailsToCustomer: Scalars['Boolean']['output'];
  /** @deprecated Use Organization.config.order.reviewDistance instead */
  order_review_distance_enabled: Scalars['Boolean']['output'];
  /** @deprecated Retired — always true instead */
  order_unsavedChangesPrompt_enabled: Scalars['Boolean']['output'];
  /** @deprecated Use Organization.config.payments.enabled instead */
  payments_enabled: Scalars['Boolean']['output'];
  /** @deprecated Retired — always true; pricing gates on the priceList* permission scopes instead */
  pricing_management_enabled: Scalars['Boolean']['output'];
  /** @deprecated Use Organization.config.salesTax.enabled instead */
  salesTax_enabled: Scalars['Boolean']['output'];
  /** @deprecated Use me.flags['schedule.bulkDispatch'] instead */
  schedule_bulk_dispatch_enabled: Scalars['Boolean']['output'];
  /** @deprecated Use Organization.config.schedule.orderSubbing instead */
  schedule_order_subbing_enabled: Scalars['Boolean']['output'];
  /** @deprecated Retired — always true instead */
  site_instructions_enabled: Scalars['Boolean']['output'];
  /** @deprecated Use Organization.config.site.jobId instead */
  site_jobId_enabled: Scalars['Boolean']['output'];
  /** @deprecated Retired — always false instead */
  site_requestPinViaSms_enabled: Scalars['Boolean']['output'];
  /** @deprecated Use Organization.config.site.unsafeCrossReferenceDistance instead */
  site_unsafeCrossReferenceDistance_enabled: Scalars['Boolean']['output'];
  /** @deprecated Use me.flags['payments.stripe'] instead */
  stripe_enabled: Scalars['Boolean']['output'];
  /** @deprecated Replaced by Support Access permission scopes (support/tagsManagement) instead */
  tags_management_enabled: Scalars['Boolean']['output'];
  /** @deprecated Replaced by Support Access permission scopes (support/termsAndConditions) instead */
  termsAndConditions_enabled: Scalars['Boolean']['output'];
  /** @deprecated Use Organization.config.modules.timeclocks instead */
  timeclocks_enabled: Scalars['Boolean']['output'];
  /** @deprecated Replaced by Support Access permission scopes (support/userRolesManagement) instead */
  userRoles_management_enabled: Scalars['Boolean']['output'];
  /** @deprecated Use Organization.config.workTicket.expanded instead */
  workticket_expanded_enabled: Scalars['Boolean']['output'];
};

export type DashboardPaymentSessionCaptureGuaranteeInput = {
  paymentSessionId: Scalars['String']['input'];
};

export type DashboardPaymentSessionCaptureGuaranteeResponse = {
  __typename?: 'DashboardPaymentSessionCaptureGuaranteeResponse';
  paymentSessions: Array<PaymentSession>;
};

export type DashboardPaymentSessionConfirmPaymentInput = {
  paymentSessionId: Scalars['ID']['input'];
};

export type DashboardPaymentSessionConfirmPaymentResponse = {
  __typename?: 'DashboardPaymentSessionConfirmPaymentResponse';
  paymentSession: PaymentSession;
};

export type DashboardPaymentSessionCreateInput = {
  invoiceIds: Array<Scalars['ID']['input']>;
};

export type DashboardPaymentSessionCreateResponse = {
  __typename?: 'DashboardPaymentSessionCreateResponse';
  paymentSession: PaymentSession;
};

export type DashboardPaymentSessionMutations = {
  __typename?: 'DashboardPaymentSessionMutations';
  captureGuarantee?: Maybe<DashboardPaymentSessionCaptureGuaranteeResponse>;
  confirmPayment?: Maybe<DashboardPaymentSessionConfirmPaymentResponse>;
  createForInvoices?: Maybe<DashboardPaymentSessionCreateResponse>;
  sendReceipt?: Maybe<DashboardPaymentSessionSendReceiptResponse>;
  updatePaymentMethod?: Maybe<DashboardPaymentSessionUpdatePaymentMethodResponse>;
};


export type DashboardPaymentSessionMutationsCaptureGuaranteeArgs = {
  data: DashboardPaymentSessionCaptureGuaranteeInput;
};


export type DashboardPaymentSessionMutationsConfirmPaymentArgs = {
  where: DashboardPaymentSessionConfirmPaymentInput;
};


export type DashboardPaymentSessionMutationsCreateForInvoicesArgs = {
  data: DashboardPaymentSessionCreateInput;
};


export type DashboardPaymentSessionMutationsSendReceiptArgs = {
  where: DashboardPaymentSessionSendReceiptInput;
};


export type DashboardPaymentSessionMutationsUpdatePaymentMethodArgs = {
  data: DashboardPaymentSessionUpdatePaymentMethodInput;
  where: DashboardPaymentSessionWhereUniqueInput;
};

export type DashboardPaymentSessionQueries = {
  __typename?: 'DashboardPaymentSessionQueries';
  invoiceAvailablePaymentMethods?: Maybe<ListInvoiceAvailablePaymentMethodsResponse>;
};


export type DashboardPaymentSessionQueriesInvoiceAvailablePaymentMethodsArgs = {
  invoiceId: Scalars['String']['input'];
};

export type DashboardPaymentSessionSendReceiptInput = {
  /** The Payment Session Id */
  id: Scalars['String']['input'];
};

export type DashboardPaymentSessionSendReceiptResponse = {
  __typename?: 'DashboardPaymentSessionSendReceiptResponse';
  success: Scalars['Boolean']['output'];
};

export type DashboardPaymentSessionUpdatePaymentMethodInput = {
  paymentMethodId: Scalars['ID']['input'];
};

export type DashboardPaymentSessionUpdatePaymentMethodResponse = {
  __typename?: 'DashboardPaymentSessionUpdatePaymentMethodResponse';
  paymentSession: PaymentSession;
};

export type DashboardPaymentSessionWhereUniqueInput = {
  paymentSessionId: Scalars['ID']['input'];
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type DeleteNotificationOverrideInput = {
  contactId?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  ruleSlug: NotificationRuleSlug;
};

export type Deposit = {
  __typename?: 'Deposit';
  bankAccountName: Scalars['String']['output'];
  controlTotal?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  depositDate: Scalars['Date']['output'];
  depositId: Scalars['String']['output'];
  externalDepositRef?: Maybe<Scalars['String']['output']>;
  isBackfill: Scalars['Boolean']['output'];
  kind: DepositKind;
  lines: Array<DepositLine>;
  memo?: Maybe<Scalars['String']['output']>;
  paymentCount: Scalars['Int']['output'];
  status: DepositStatus;
  stripePayoutId?: Maybe<Scalars['String']['output']>;
  stripePayoutStatus?: Maybe<Scalars['String']['output']>;
  totalAmount: Scalars['Decimal']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum DepositKind {
  Imported = 'imported',
  Manual = 'manual',
  StripePayout = 'stripe_payout'
}

export type DepositLine = {
  __typename?: 'DepositLine';
  amount: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  depositId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lineType: DepositLineType;
  payment?: Maybe<DepositLinePayment>;
};

export type DepositLinePayment = {
  __typename?: 'DepositLinePayment';
  customerName?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  paymentDate?: Maybe<Scalars['Date']['output']>;
  paymentId: Scalars['String']['output'];
  paymentSourceName?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
};

export enum DepositLineType {
  Adjustment = 'adjustment',
  DisputeContra = 'dispute_contra',
  FeeContra = 'fee_contra',
  Payment = 'payment',
  RefundContra = 'refund_contra'
}

export type DepositListWhereInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  kind?: InputMaybe<DepositKind>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DepositStatus>;
};

export type DepositMutations = {
  __typename?: 'DepositMutations';
  createDraft: DepositResponse;
  createSinglePaymentDeposit: DepositResponse;
  deleteDraft: DepositResponse;
  finalize: DepositResponse;
  generateSlip: DepositSlipResponse;
  recordExternalRef: DepositResponse;
  reopen: DepositResponse;
  updateDraft: DepositResponse;
  void: DepositResponse;
};


export type DepositMutationsCreateDraftArgs = {
  data: CreateDepositDraftInput;
};


export type DepositMutationsCreateSinglePaymentDepositArgs = {
  data: CreateSinglePaymentDepositInput;
};


export type DepositMutationsDeleteDraftArgs = {
  depositId: Scalars['String']['input'];
};


export type DepositMutationsFinalizeArgs = {
  data: FinalizeDepositInput;
};


export type DepositMutationsGenerateSlipArgs = {
  depositId: Scalars['String']['input'];
};


export type DepositMutationsRecordExternalRefArgs = {
  data: RecordExternalDepositRefInput;
};


export type DepositMutationsReopenArgs = {
  data: DepositTransitionInput;
};


export type DepositMutationsUpdateDraftArgs = {
  data: UpdateDepositDraftInput;
};


export type DepositMutationsVoidArgs = {
  data: DepositTransitionInput;
};

export type DepositResponse = {
  __typename?: 'DepositResponse';
  depositId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DepositSlipResponse = {
  __typename?: 'DepositSlipResponse';
  filename: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum DepositStatus {
  Draft = 'draft',
  Finalized = 'finalized',
  Voided = 'voided'
}

export type DepositTransitionInput = {
  depositId: Scalars['String']['input'];
  txId?: InputMaybe<Scalars['String']['input']>;
};

export type DepositsReportResult = {
  __typename?: 'DepositsReportResult';
  csv: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export type Dialpad = {
  __typename?: 'Dialpad';
  settings?: Maybe<DialpadSettings>;
  token?: Maybe<IntegrationToken>;
};

export type DialpadSettings = {
  __typename?: 'DialpadSettings';
  enabled: Scalars['Boolean']['output'];
};

export type DistributedCreditBalanceInput = {
  amount: Scalars['Decimal']['input'];
  invoiceId: Scalars['String']['input'];
};

export type DistributedPaymentInput = {
  amount: Scalars['Decimal']['input'];
  invoiceId: Scalars['String']['input'];
};

export type Document = {
  __typename?: 'Document';
  active: Scalars['Boolean']['output'];
  attachments?: Maybe<Scalars['Json']['output']>;
  createdAt: Scalars['DateTime']['output'];
  expirationDate?: Maybe<Scalars['Date']['output']>;
  fields: Array<KeyValue>;
  id: Scalars['Int']['output'];
  pinned: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  typeDetails: DocumentType;
  updatedAt: Scalars['DateTime']['output'];
};

export type DocumentInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  attachments?: InputMaybe<Scalars['Json']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  fields?: InputMaybe<Array<KeyValueInput>>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  typeName?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentType = {
  __typename?: 'DocumentType';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum DocumentTypeScope {
  Equipment = 'equipment'
}

export type DocumentTypesWhereInput = {
  active?: InputMaybe<BoolFilter>;
  scope?: InputMaybe<DocumentTypeScope>;
};

export type DocumentUpsertInput = {
  data: DocumentInput;
  where?: InputMaybe<DocumentWhereUniqueInput>;
};

export type DocumentWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentsInput = {
  delete?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  upsert?: InputMaybe<Array<DocumentUpsertInput>>;
};

export type EditDigitalPaymentInput = {
  allocations: Array<PaymentAllocationInput>;
  paymentId: Scalars['String']['input'];
  txId?: InputMaybe<Scalars['String']['input']>;
};

export type EditNonDigitalPaymentInput = {
  allocations: Array<PaymentAllocationInput>;
  date?: InputMaybe<Scalars['DateLike']['input']>;
  paymentId: Scalars['String']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  txId?: InputMaybe<Scalars['String']['input']>;
};

export type EmailDeliveryEventInput = {
  bounceType?: InputMaybe<Scalars['String']['input']>;
  detail?: InputMaybe<Scalars['Json']['input']>;
  eventType: EmailDeliveryEventType;
  messageId: Scalars['String']['input'];
  occurredAt?: InputMaybe<Scalars['DateTime']['input']>;
  recipients: Array<Scalars['String']['input']>;
};

export enum EmailDeliveryEventType {
  Bounce = 'bounce',
  Complaint = 'complaint',
  Delivery = 'delivery'
}

export type EmailForwardingTarget = {
  __typename?: 'EmailForwardingTarget';
  email: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
};

export type EmailMutations = {
  __typename?: 'EmailMutations';
  recordDeliveryEvent: EmailMutationsRecordDeliveryEventResponse;
  recordReply: EmailMutationsRecordReplyResponse;
};


export type EmailMutationsRecordDeliveryEventArgs = {
  data: EmailDeliveryEventInput;
};


export type EmailMutationsRecordReplyArgs = {
  data: EmailReplyInput;
};

export type EmailMutationsRecordDeliveryEventResponse = {
  __typename?: 'EmailMutationsRecordDeliveryEventResponse';
  message?: Maybe<Message>;
  ok: Scalars['Boolean']['output'];
};

export type EmailMutationsRecordReplyResponse = {
  __typename?: 'EmailMutationsRecordReplyResponse';
  message?: Maybe<Message>;
  ok: Scalars['Boolean']['output'];
};

export type EmailReplyInput = {
  from: Scalars['String']['input'];
  occurredAt?: InputMaybe<Scalars['DateTime']['input']>;
  replyToken: Scalars['String']['input'];
};

export type EmailSuppression = {
  __typename?: 'EmailSuppression';
  address: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  messageId?: Maybe<Scalars['Int']['output']>;
  reason: EmailSuppressionReason;
  updatedAt: Scalars['DateTime']['output'];
};

export enum EmailSuppressionReason {
  Bounce = 'bounce',
  Complaint = 'complaint'
}

export type EmailValidationResult = {
  __typename?: 'EmailValidationResult';
  reason?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type EnumEquipmentAvailabilityStatusFilter = {
  equals?: InputMaybe<EquipmentAvailabilityStatus>;
  in?: InputMaybe<Array<EquipmentAvailabilityStatus>>;
  not?: InputMaybe<NestedEnumEquipmentAvailabilityStatusFilter>;
  notIn?: InputMaybe<Array<EquipmentAvailabilityStatus>>;
};

export type EnumPersonAvailabilityStatusFilter = {
  equals?: InputMaybe<PersonAvailabilityStatus>;
  in?: InputMaybe<Array<PersonAvailabilityStatus>>;
  not?: InputMaybe<NestedEnumPersonAvailabilityStatusFilter>;
  notIn?: InputMaybe<Array<PersonAvailabilityStatus>>;
};

export type EnumTimeClockTaskScopeNullableListFilter = {
  equals?: InputMaybe<Array<TimeClockTaskScope>>;
  has?: InputMaybe<TimeClockTaskScope>;
  hasEvery?: InputMaybe<Array<TimeClockTaskScope>>;
  hasSome?: InputMaybe<Array<TimeClockTaskScope>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Equipment = {
  __typename?: 'Equipment';
  active: Scalars['Boolean']['output'];
  additionalIds?: Maybe<Array<KeyValue>>;
  availability: Array<EquipmentAvailability>;
  branch: Branch;
  branchId: Scalars['Int']['output'];
  cleanTime?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  defaultOperator?: Maybe<Operator>;
  defaultOperatorId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  documents: Array<Document>;
  group?: Maybe<EquipmentGroup>;
  groupId?: Maybe<Scalars['Int']['output']>;
  hourlyRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  integrations?: Maybe<EquipmentIntegrations>;
  /** @deprecated use service instead */
  invoiceTemplate?: Maybe<Service>;
  make?: Maybe<EquipmentMake>;
  makeId?: Maybe<Scalars['Int']['output']>;
  modelDetails?: Maybe<EquipmentModel>;
  modelId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  prepTime?: Maybe<Scalars['Int']['output']>;
  scheduleAlias?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Service>;
  /** @deprecated use service instead */
  serviceCategory?: Maybe<Service>;
  size?: Maybe<Scalars['Float']['output']>;
  sort: Scalars['Int']['output'];
  telematics: EquipmentTelematics;
  transmission?: Maybe<Transmission>;
  travelRate?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
  typeDetails: EquipmentType;
  updatedAt: Scalars['DateTime']['output'];
  vin?: Maybe<Scalars['String']['output']>;
  yardageRate?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};


export type EquipmentDocumentsArgs = {
  where?: InputMaybe<EquipmentDocumentsWhereInput>;
};

export type EquipmentAvailability = {
  __typename?: 'EquipmentAvailability';
  address: Address;
  branch: Branch;
  comments: Array<Comment>;
  createdAt: Scalars['DateTime']['output'];
  equipment: Equipment;
  id: Scalars['Int']['output'];
  reason?: Maybe<EquipmentAvailabilityReason>;
  status: EquipmentAvailabilityStatus;
  updatedAt: Scalars['DateTime']['output'];
  validFrom: Scalars['DateTime']['output'];
  validTo?: Maybe<Scalars['DateTime']['output']>;
};


export type EquipmentAvailabilityCommentsArgs = {
  cursor?: InputMaybe<CommentWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type EquipmentAvailabilityReason = {
  __typename?: 'EquipmentAvailabilityReason';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: EquipmentAvailabilityStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type EquipmentAvailabilityReasonInput = {
  name: Scalars['String']['input'];
};

export type EquipmentAvailabilitySnapshot = {
  __typename?: 'EquipmentAvailabilitySnapshot';
  availability: Array<EquipmentAvailability>;
  equipment: Equipment;
  id: Scalars['String']['output'];
};

export enum EquipmentAvailabilityStatus {
  Available = 'available',
  Unavailable = 'unavailable'
}

export type EquipmentAvailabilityUpdateInput = {
  comments?: InputMaybe<CommentsInput>;
  reason?: InputMaybe<EquipmentAvailabilityReasonInput>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EquipmentAvailabilityWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type EquipmentCancelAvailabilityDataInput = {
  /** Indicates what timeslot will merge with the gap being created by canceling the equipment schedule */
  fillGap?: InputMaybe<EquipmentCancelAvailabilityFillGapEnum>;
};

export enum EquipmentCancelAvailabilityFillGapEnum {
  Next = 'next',
  Previous = 'previous'
}

export type EquipmentCancelAvailabilityResponse = {
  __typename?: 'EquipmentCancelAvailabilityResponse';
  deleted: EquipmentAvailability;
  updated?: Maybe<EquipmentAvailability>;
};

export type EquipmentCancelAvailabilityWhereInput = {
  id: Scalars['Int']['input'];
};

export type EquipmentDocumentsWhereInput = {
  active?: InputMaybe<BoolFilter>;
  expirationDate?: InputMaybe<StringNullableFilter>;
  pinned?: InputMaybe<BoolFilter>;
};

export type EquipmentGeotabIntegration = {
  __typename?: 'EquipmentGeotabIntegration';
  vehicle?: Maybe<GeotabVehicle>;
};

export type EquipmentGroup = {
  __typename?: 'EquipmentGroup';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  locationAware: Scalars['Boolean']['output'];
  locationSort?: Maybe<Array<Scalars['Int']['output']>>;
  name: Scalars['String']['output'];
  /** @deprecated use locationAware instead */
  prefixWithYard?: Maybe<Scalars['Boolean']['output']>;
  sort: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EquipmentGroupDataCreateInput = {
  locationAware: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  sort: Scalars['Int']['input'];
};

export type EquipmentGroupDataUpdateInput = {
  locationAware?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type EquipmentGroupMutations = {
  __typename?: 'EquipmentGroupMutations';
  create: EquipmentGroupMutationsCreateResponse;
  update: EquipmentGroupMutationsUpdateResponse;
};


export type EquipmentGroupMutationsCreateArgs = {
  data: EquipmentGroupDataCreateInput;
};


export type EquipmentGroupMutationsUpdateArgs = {
  data: EquipmentGroupDataUpdateInput;
  where: EquipmentGroupWhereUpdateUniqueInput;
};

export type EquipmentGroupMutationsCreateResponse = {
  __typename?: 'EquipmentGroupMutationsCreateResponse';
  equipmentGroup: EquipmentGroup;
};

export type EquipmentGroupMutationsUpdateResponse = {
  __typename?: 'EquipmentGroupMutationsUpdateResponse';
  equipmentGroup: EquipmentGroup;
};

export type EquipmentGroupWhereUpdateUniqueInput = {
  id: Scalars['Int']['input'];
};

export type EquipmentInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  branchId: Scalars['Int']['input'];
  cleanTime?: InputMaybe<Scalars['Int']['input']>;
  defaultOperator?: InputMaybe<OperatorWhereUniqueInput>;
  defaultOperatorId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<DocumentsInput>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  invoiceTemplate?: InputMaybe<InvoiceTemplateWhereUniqueInput>;
  makeId?: InputMaybe<Scalars['Int']['input']>;
  modelId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  prepTime?: InputMaybe<Scalars['Int']['input']>;
  scheduleAlias?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<ServiceWhereUniqueInput>;
  serviceCategory?: InputMaybe<ServiceCategoryWhereUniqueInput>;
  size?: InputMaybe<Scalars['Float']['input']>;
  transmission?: InputMaybe<Transmission>;
  travelRate?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
  vin?: InputMaybe<Scalars['String']['input']>;
  yardageRate?: InputMaybe<Scalars['Float']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type EquipmentIntegrations = {
  __typename?: 'EquipmentIntegrations';
  all: Array<KeyValue>;
  geotab?: Maybe<EquipmentGeotabIntegration>;
  quickbooks?: Maybe<EquipmentQuickbooksIntegration>;
  samsara?: Maybe<EquipmentSamsaraIntegration>;
};

export type EquipmentMake = {
  __typename?: 'EquipmentMake';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EquipmentMakeDataCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type EquipmentMakeDataUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type EquipmentMakeMutations = {
  __typename?: 'EquipmentMakeMutations';
  create: EquipmentMakeMutationsCreateResponse;
  update: EquipmentMakeMutationsUpdateResponse;
};


export type EquipmentMakeMutationsCreateArgs = {
  data: EquipmentMakeDataCreateInput;
};


export type EquipmentMakeMutationsUpdateArgs = {
  data: EquipmentMakeDataUpdateInput;
  where: EquipmentMakeWhereUpdateUniqueInput;
};

export type EquipmentMakeMutationsCreateResponse = {
  __typename?: 'EquipmentMakeMutationsCreateResponse';
  equipmentMake: EquipmentMake;
};

export type EquipmentMakeMutationsUpdateResponse = {
  __typename?: 'EquipmentMakeMutationsUpdateResponse';
  equipmentMake: EquipmentMake;
};

export type EquipmentMakeWhereUpdateUniqueInput = {
  id: Scalars['Int']['input'];
};

export type EquipmentModel = {
  __typename?: 'EquipmentModel';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EquipmentModelDataCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type EquipmentModelDataUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type EquipmentModelMutations = {
  __typename?: 'EquipmentModelMutations';
  create: EquipmentModelMutationsCreateResponse;
  update: EquipmentModelMutationsUpdateResponse;
};


export type EquipmentModelMutationsCreateArgs = {
  data: EquipmentModelDataCreateInput;
};


export type EquipmentModelMutationsUpdateArgs = {
  data: EquipmentModelDataUpdateInput;
  where: EquipmentModelWhereUpdateUniqueInput;
};

export type EquipmentModelMutationsCreateResponse = {
  __typename?: 'EquipmentModelMutationsCreateResponse';
  equipmentModel: EquipmentModel;
};

export type EquipmentModelMutationsUpdateResponse = {
  __typename?: 'EquipmentModelMutationsUpdateResponse';
  equipmentModel: EquipmentModel;
};

export type EquipmentModelWhereUpdateUniqueInput = {
  id: Scalars['Int']['input'];
};

export type EquipmentMutations = {
  __typename?: 'EquipmentMutations';
  cancelAvailability: EquipmentCancelAvailabilityResponse;
  scheduleAvailability: EquipmentScheduleAvailabilityResponse;
};


export type EquipmentMutationsCancelAvailabilityArgs = {
  data?: InputMaybe<EquipmentCancelAvailabilityDataInput>;
  where: EquipmentCancelAvailabilityWhereInput;
};


export type EquipmentMutationsScheduleAvailabilityArgs = {
  data: EquipmentScheduleAvailabilityDataInput;
  where: EquipmentScheduleAvailabilityWhereInput;
};

export type EquipmentQuickbooksIntegration = {
  __typename?: 'EquipmentQuickbooksIntegration';
  cancellationRate?: Maybe<QuickbooksItem>;
  flatRate?: Maybe<QuickbooksItem>;
  hourlyRate?: Maybe<QuickbooksItem>;
  travelRate?: Maybe<QuickbooksItem>;
  yardageRate?: Maybe<QuickbooksItem>;
};

export type EquipmentSamsaraIntegration = {
  __typename?: 'EquipmentSamsaraIntegration';
  vehicle?: Maybe<SamsaraVehicle>;
};

export type EquipmentScheduleAvailabilityDataInput = {
  addressId: Scalars['Int']['input'];
  reasonName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EquipmentAvailabilityStatus>;
  validFrom: Scalars['DateTime']['input'];
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EquipmentScheduleAvailabilityResponse = {
  __typename?: 'EquipmentScheduleAvailabilityResponse';
  equipmentAvailability: Array<EquipmentAvailability>;
};

export type EquipmentScheduleAvailabilityWhereInput = {
  equipmentId: Scalars['Int']['input'];
};

export type EquipmentTelematics = {
  __typename?: 'EquipmentTelematics';
  gps?: Maybe<TelematicsGps>;
  stats?: Maybe<TelematicsStats>;
};

export type EquipmentType = {
  __typename?: 'EquipmentType';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EquipmentTypeDataCreateInput = {
  active: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  sort: Scalars['Int']['input'];
};

export type EquipmentTypeDataUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type EquipmentTypeMutations = {
  __typename?: 'EquipmentTypeMutations';
  create: EquipmentTypeMutationsCreateResponse;
  update: EquipmentTypeMutationsUpdateResponse;
};


export type EquipmentTypeMutationsCreateArgs = {
  data: EquipmentTypeDataCreateInput;
};


export type EquipmentTypeMutationsUpdateArgs = {
  data: EquipmentTypeDataUpdateInput;
  where: EquipmentTypeWhereUpdateUniqueInput;
};

export type EquipmentTypeMutationsCreateResponse = {
  __typename?: 'EquipmentTypeMutationsCreateResponse';
  equipmentType: EquipmentType;
};

export type EquipmentTypeMutationsUpdateResponse = {
  __typename?: 'EquipmentTypeMutationsUpdateResponse';
  equipmentType: EquipmentType;
};

export type EquipmentTypeWhereUpdateUniqueInput = {
  id: Scalars['Int']['input'];
};

export type EquipmentUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  branchId?: InputMaybe<Scalars['Int']['input']>;
  cleanTime?: InputMaybe<Scalars['Int']['input']>;
  defaultOperator?: InputMaybe<OperatorWhereUniqueInput>;
  defaultOperatorId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<DocumentsInput>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  invoiceTemplate?: InputMaybe<InvoiceTemplateWhereUniqueInput>;
  makeId?: InputMaybe<Scalars['Int']['input']>;
  modelId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  prepTime?: InputMaybe<Scalars['Int']['input']>;
  scheduleAlias?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<ServiceWhereUniqueInput>;
  serviceCategory?: InputMaybe<ServiceCategoryWhereUniqueInput>;
  size?: InputMaybe<Scalars['Float']['input']>;
  transmission?: InputMaybe<Transmission>;
  travelRate?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  vin?: InputMaybe<Scalars['String']['input']>;
  yardageRate?: InputMaybe<Scalars['Float']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type EquipmentWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type Event = {
  __typename?: 'Event';
  active: Scalars['Boolean']['output'];
  branch?: Maybe<Branch>;
  branchId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  endTime: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  maintenanceEvents: Array<MaintenanceEvent>;
  note?: Maybe<Note>;
  noteId?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['Int']['output']>;
  route?: Maybe<Route>;
  routeId?: Maybe<Scalars['Int']['output']>;
  startTime: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EventInput = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type EventsInput = {
  set?: InputMaybe<Array<EventInput>>;
};

export type ExternalAccountRef = {
  __typename?: 'ExternalAccountRef';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FileMutations = {
  __typename?: 'FileMutations';
  presignUploadUrl?: Maybe<FileUploadUrlResponse>;
};


export type FileMutationsPresignUploadUrlArgs = {
  data?: InputMaybe<UploadTypesWhereInput>;
};

export type FileUploadUrlResponse = {
  __typename?: 'FileUploadUrlResponse';
  s3ObjectUrl: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type FinalizeDepositInput = {
  depositId: Scalars['String']['input'];
  externalDepositRef?: InputMaybe<Scalars['String']['input']>;
  txId?: InputMaybe<Scalars['String']['input']>;
};

export type FitOrderIntoRouteInput = {
  route: OrderRouteInput;
};

export type GeneratePaymentReceiptInput = {
  paymentId: Scalars['String']['input'];
};

export type GenericResponse = {
  __typename?: 'GenericResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GeoArea = {
  __typename?: 'GeoArea';
  addressId: Scalars['Int']['output'];
  geometry: Scalars['Json']['output'];
  id: Scalars['Int']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  radius: Scalars['Float']['output'];
};

export type GeoAreaCreateInput = {
  geometry: Scalars['Json']['input'];
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  radius: Scalars['Float']['input'];
};

export type GeoAreaUpdateInput = {
  geometry?: InputMaybe<Scalars['Json']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
};

export type GeoFilter = {
  near?: InputMaybe<GeoNearFilter>;
};

export type GeoNearFilter = {
  lat: Scalars['Decimal']['input'];
  lng: Scalars['Decimal']['input'];
  radius: Scalars['Decimal']['input'];
};

export type Geolocation = {
  __typename?: 'Geolocation';
  accuracy?: Maybe<Scalars['Float']['output']>;
  altitude?: Maybe<Scalars['Float']['output']>;
  altitudeAccuracy?: Maybe<Scalars['Float']['output']>;
  geohash?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['Float']['output']>;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  speed?: Maybe<Scalars['Float']['output']>;
};

export type GeolocationInput = {
  accuracy?: InputMaybe<Scalars['Float']['input']>;
  altitude?: InputMaybe<Scalars['Float']['input']>;
  altitudeAccuracy?: InputMaybe<Scalars['Float']['input']>;
  heading?: InputMaybe<Scalars['Float']['input']>;
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  speed?: InputMaybe<Scalars['Float']['input']>;
};

export type Geotab = {
  __typename?: 'Geotab';
  credentials: GeotabCredentials;
  settings: GeotabSettings;
  vehicles: Array<GeotabVehicle>;
};


export type GeotabCredentialsArgs = {
  forceRefresh?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GeotabConnectCredentialsInput = {
  database: Scalars['String']['input'];
  password: Scalars['String']['input'];
  server?: InputMaybe<Scalars['String']['input']>;
  userName: Scalars['String']['input'];
};

export type GeotabCredentials = {
  __typename?: 'GeotabCredentials';
  createdAt: Scalars['DateTime']['output'];
  database: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  server: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type GeotabMutationNamespace = {
  __typename?: 'GeotabMutationNamespace';
  connect: GenericResponse;
  linkVehicle: Equipment;
};


export type GeotabMutationNamespaceConnectArgs = {
  credentials: GeotabConnectCredentialsInput;
};


export type GeotabMutationNamespaceLinkVehicleArgs = {
  equipment: EquipmentWhereUniqueInput;
  vehicleId?: InputMaybe<Scalars['String']['input']>;
};

export type GeotabSettings = {
  __typename?: 'GeotabSettings';
  database: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  server: Scalars['String']['output'];
};

export type GeotabVehicle = {
  __typename?: 'GeotabVehicle';
  activeFrom: Scalars['DateTime']['output'];
  activeTo: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
};

export type GlAccount = {
  __typename?: 'GlAccount';
  active: Scalars['Boolean']['output'];
  fullyQualifiedName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isBank: Scalars['Boolean']['output'];
  isReceivableOrPayable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  number?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type GlAccountMapping = {
  __typename?: 'GlAccountMapping';
  accountCode: Scalars['String']['output'];
  externalAccountId: Scalars['String']['output'];
  externalAccountName: Scalars['String']['output'];
  externalAccountType: Scalars['String']['output'];
  externalClassId?: Maybe<Scalars['String']['output']>;
  externalClassName?: Maybe<Scalars['String']['output']>;
  externalDepartmentId?: Maybe<Scalars['String']['output']>;
  externalDepartmentName?: Maybe<Scalars['String']['output']>;
  externalLocationId?: Maybe<Scalars['String']['output']>;
  externalLocationName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isReceivableOrPayable: Scalars['Boolean']['output'];
  provider: AccountingIntegrationProvider;
};

export type GlAccountMappingInput = {
  accountCode: Scalars['String']['input'];
  externalAccountId: Scalars['String']['input'];
  externalAccountName: Scalars['String']['input'];
  externalAccountType?: InputMaybe<Scalars['String']['input']>;
  externalClassId?: InputMaybe<Scalars['String']['input']>;
  externalClassName?: InputMaybe<Scalars['String']['input']>;
  externalDepartmentId?: InputMaybe<Scalars['String']['input']>;
  externalDepartmentName?: InputMaybe<Scalars['String']['input']>;
  externalLocationId?: InputMaybe<Scalars['String']['input']>;
  externalLocationName?: InputMaybe<Scalars['String']['input']>;
  isReceivableOrPayable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GlDimension = {
  __typename?: 'GlDimension';
  active: Scalars['Boolean']['output'];
  fullyQualifiedName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum GlDimensionKind {
  Class = 'class',
  Department = 'department',
  Location = 'location'
}

export type GlobalSearchAccess = {
  __typename?: 'GlobalSearchAccess';
  apiKey?: Maybe<Scalars['String']['output']>;
  collections: Array<Scalars['String']['output']>;
  entityTypes: Array<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  host: Scalars['String']['output'];
  port: Scalars['Int']['output'];
  protocol: Scalars['String']['output'];
};

export type InsightsDashboard = {
  __typename?: 'InsightsDashboard';
  createdAt: Scalars['DateTime']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isSelfService: Scalars['Boolean']['output'];
  metabaseId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  settings?: Maybe<InsightsDashboardSettings>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: InsightsDashboardType;
  updatedAt: Scalars['DateTime']['output'];
};

export type InsightsDashboardDataCreateInput = {
  isSelfService: Scalars['Boolean']['input'];
  metabaseId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  settings?: InputMaybe<InsightsDashboardSettingsDataInput>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: InsightsDashboardType;
};

export type InsightsDashboardDataUpdateInput = {
  isSelfService?: InputMaybe<Scalars['Boolean']['input']>;
  metabaseId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<InsightsDashboardSettingsDataInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<InsightsDashboardType>;
};

export type InsightsDashboardMutations = {
  __typename?: 'InsightsDashboardMutations';
  create: InsightsDashboardMutationsCreateResponse;
  update: InsightsDashboardMutationsUpdateResponse;
};


export type InsightsDashboardMutationsCreateArgs = {
  data: InsightsDashboardDataCreateInput;
};


export type InsightsDashboardMutationsUpdateArgs = {
  data: InsightsDashboardDataUpdateInput;
  where: InsightsDashboardWhereUpdateUniqueInput;
};

export type InsightsDashboardMutationsCreateResponse = {
  __typename?: 'InsightsDashboardMutationsCreateResponse';
  insightsDashboard: InsightsDashboard;
};

export type InsightsDashboardMutationsUpdateResponse = {
  __typename?: 'InsightsDashboardMutationsUpdateResponse';
  insightsDashboard: InsightsDashboard;
};

export enum InsightsDashboardPlacement {
  Report = 'report',
  Tab = 'tab'
}

export type InsightsDashboardResult = {
  __typename?: 'InsightsDashboardResult';
  expires: Scalars['DateTime']['output'];
  hidden: Scalars['Boolean']['output'];
  placement: InsightsDashboardPlacement;
  slug: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type InsightsDashboardSettings = {
  __typename?: 'InsightsDashboardSettings';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  insightsDashboardId: Scalars['Int']['output'];
  isGlobal: Scalars['Boolean']['output'];
  placement: InsightsDashboardPlacement;
  roles: Array<UserRole>;
  sort: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type InsightsDashboardSettingsRolesArgs = {
  cursor?: InputMaybe<UserRoleWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type InsightsDashboardSettingsDataInput = {
  isGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  placement?: InputMaybe<InsightsDashboardPlacement>;
  roleIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export enum InsightsDashboardType {
  Dashboard = 'dashboard',
  Question = 'question'
}

export type InsightsDashboardWhereUpdateUniqueInput = {
  id: Scalars['Int']['input'];
};

export type InsightsUrl = {
  __typename?: 'InsightsUrl';
  expires: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type InsightsUrlInput = {
  dashboard: Scalars['String']['input'];
};

export type IntArrayInput = {
  set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntegrationToken = {
  __typename?: 'IntegrationToken';
  createdAt: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  metadata?: Maybe<Scalars['Json']['output']>;
  token: Scalars['String']['output'];
};

export type Integrations = {
  __typename?: 'Integrations';
  aircall?: Maybe<Aircall>;
  dialpad?: Maybe<Dialpad>;
  geotab?: Maybe<Geotab>;
  paylocity?: Maybe<Paylocity>;
  quickbooks?: Maybe<Quickbooks>;
  samsara?: Maybe<Samsara>;
};

export type IntegrationsMutationNamespace = {
  __typename?: 'IntegrationsMutationNamespace';
  geotab?: Maybe<GeotabMutationNamespace>;
  paylocity?: Maybe<PaylocityMutationNamespace>;
  quickbooks?: Maybe<QuickbooksMutationNamespace>;
  samsara?: Maybe<SamsaraMutationNamespace>;
};

export type InventoryItem = {
  __typename?: 'InventoryItem';
  active: Scalars['Boolean']['output'];
  branch: Branch;
  branchId: Scalars['Int']['output'];
  category?: Maybe<Scalars['String']['output']>;
  consumable: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayMultiplier?: Maybe<Scalars['Float']['output']>;
  displayUnit?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  visibility: InventoryItemVisibilities;
};

export type InventoryItemCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  branchId: Scalars['Int']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayMultiplier?: InputMaybe<Scalars['Float']['input']>;
  displayUnit?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  visibility?: InputMaybe<InventoryItemVisibilitiesInput>;
};

export type InventoryItemUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  branchId?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayMultiplier?: InputMaybe<Scalars['Float']['input']>;
  displayUnit?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  visibility?: InputMaybe<InventoryItemVisibilitiesInput>;
};

export type InventoryItemVisibilities = {
  __typename?: 'InventoryItemVisibilities';
  customerConfirmation: InventoryItemVisibility;
  customerWorkTicket: InventoryItemVisibility;
  operatorAssignment: InventoryItemVisibility;
  operatorWorkTicket: InventoryItemVisibility;
  /** @deprecated use orderReview instead */
  orderBilling: InventoryItemVisibility;
  orderForm: InventoryItemVisibility;
  orderReview: InventoryItemVisibility;
};

export type InventoryItemVisibilitiesInput = {
  customerConfirmation?: InputMaybe<InventoryItemVisibility>;
  customerWorkTicket?: InputMaybe<InventoryItemVisibility>;
  operatorAssignment?: InputMaybe<InventoryItemVisibility>;
  operatorWorkTicket?: InputMaybe<InventoryItemVisibility>;
  orderForm?: InputMaybe<InventoryItemVisibility>;
  orderReview?: InputMaybe<InventoryItemVisibility>;
};

export enum InventoryItemVisibility {
  Always = 'always',
  Auto = 'auto',
  Hidden = 'hidden'
}

export type InventoryItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  activities: Array<InvoiceActivity>;
  additionalIds?: Maybe<Array<KeyValue>>;
  amountDue: Scalars['Decimal']['output'];
  amountPaid: Scalars['Decimal']['output'];
  assetsUsed: Array<Equipment>;
  balance: Scalars['Decimal']['output'];
  billTo?: Maybe<InvoiceBillTo>;
  billingProfile?: Maybe<BillingProfile>;
  branch: Branch;
  changelog?: Maybe<Changelog>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  customer?: Maybe<Customer>;
  defaultTaxCode?: Maybe<Scalars['String']['output']>;
  delivery: InvoiceDelivery;
  details: Array<InvoiceDetail>;
  draftCreditMemo?: Maybe<Scalars['Decimal']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  emails: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  integrations?: Maybe<InvoiceIntegrations>;
  invoiceDate?: Maybe<Scalars['Date']['output']>;
  lines: Array<InvoiceLine>;
  links: Array<Link>;
  memo?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Array<KeyValue>>;
  number: Scalars['String']['output'];
  orders: Array<Order>;
  payment: InvoicePayment;
  priceList?: Maybe<PriceList>;
  purchaseOrder?: Maybe<Scalars['String']['output']>;
  revision: Scalars['Int']['output'];
  site?: Maybe<Site>;
  status: Scalars['String']['output'];
  statusDetails: InvoiceStatus;
  tags: Array<Tag>;
  tid: Scalars['Int']['output'];
  title?: Maybe<InvoiceTitle>;
  transactionHistory?: Maybe<Array<TransactionHistory>>;
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['String']['output'];
};

export type InvoiceActivity = {
  __typename?: 'InvoiceActivity';
  amountDue?: Maybe<Scalars['Decimal']['output']>;
  by?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  emails?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  type: InvoiceActivityType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum InvoiceActivityType {
  Adjusted = 'adjusted',
  Created = 'created',
  DraftCreated = 'draft_created',
  EmailBlocked = 'emailBlocked',
  EmailBounced = 'emailBounced',
  EmailReplied = 'emailReplied',
  Emailed = 'emailed',
  Finalized = 'finalized',
  PaymentLinkSent = 'payment_link_sent',
  Printed = 'printed',
  Restored = 'restored',
  Revised = 'revised',
  StatementSent = 'statementSent',
  Texted = 'texted',
  Viewed = 'viewed',
  Voided = 'voided'
}

export type InvoiceBillTo = {
  __typename?: 'InvoiceBillTo';
  address: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type InvoiceBillToInput = {
  address?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceDelivery = {
  __typename?: 'InvoiceDelivery';
  channel?: Maybe<InvoiceDeliveryChannel>;
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  failureKind?: Maybe<InvoiceDeliveryFailureKind>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: InvoiceDeliveryStatus;
};

export enum InvoiceDeliveryChannel {
  Email = 'EMAIL',
  Print = 'PRINT',
  Sms = 'SMS'
}

export enum InvoiceDeliveryFailureKind {
  Bounce = 'BOUNCE',
  Complaint = 'COMPLAINT'
}

export enum InvoiceDeliveryStatus {
  NotSent = 'NOT_SENT',
  Sent = 'SENT',
  Undeliverable = 'UNDELIVERABLE'
}

export type InvoiceDetail = {
  __typename?: 'InvoiceDetail';
  label: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type InvoiceDetailInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceEstimate = {
  __typename?: 'InvoiceEstimate';
  id: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type InvoiceIntegrations = {
  __typename?: 'InvoiceIntegrations';
  all: Array<KeyValue>;
};

export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  active: Scalars['Boolean']['output'];
  category?: Maybe<Scalars['String']['output']>;
  changelog?: Maybe<Changelog>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  hasCustomDisplayName: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  integrations?: Maybe<InvoiceItemIntegrations>;
  name: Scalars['String']['output'];
  quantityResolver?: Maybe<QuantityResolver>;
  revision: Scalars['Int']['output'];
  step?: Maybe<Scalars['Decimal']['output']>;
  taxCode?: Maybe<Scalars['String']['output']>;
  type: InvoiceItemType;
  updatedAt: Scalars['DateTime']['output'];
};

export type InvoiceItemDataCreateInput = {
  active: Scalars['Boolean']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  quantityResolver?: InputMaybe<QuantityResolversItemInput>;
  taxCode?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceItemDataUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quantityResolver?: InputMaybe<QuantityResolversItemInput>;
  taxCode?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceItemIntegrations = {
  __typename?: 'InvoiceItemIntegrations';
  all: Array<KeyValue>;
};

export type InvoiceItemMutations = {
  __typename?: 'InvoiceItemMutations';
  create: InvoiceItemMutationsCreateResponse;
  update: InvoiceItemMutationsUpdateResponse;
};


export type InvoiceItemMutationsCreateArgs = {
  data: InvoiceItemDataCreateInput;
};


export type InvoiceItemMutationsUpdateArgs = {
  data: InvoiceItemDataUpdateInput;
  where: InvoiceItemWhereUniqueInput;
};

export type InvoiceItemMutationsCreateResponse = {
  __typename?: 'InvoiceItemMutationsCreateResponse';
  invoiceItem: InvoiceItem;
};

export type InvoiceItemMutationsUpdateResponse = {
  __typename?: 'InvoiceItemMutationsUpdateResponse';
  invoiceItem: InvoiceItem;
};

export enum InvoiceItemType {
  PlatformFee = 'platformFee',
  Standard = 'standard'
}

export type InvoiceItemWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type InvoiceLine = {
  __typename?: 'InvoiceLine';
  additionalIds?: Maybe<Array<KeyValue>>;
  amount?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customRate?: Maybe<Scalars['Decimal']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  item?: Maybe<InvoiceItem>;
  lineNumber: Scalars['Int']['output'];
  listPrice?: Maybe<Scalars['Decimal']['output']>;
  metadata?: Maybe<Array<KeyValue>>;
  price?: Maybe<Price>;
  quantity?: Maybe<Scalars['Decimal']['output']>;
  section: InvoiceLineSection;
  taxCode?: Maybe<Scalars['String']['output']>;
  type: InvoiceLineType;
  updatedAt: Scalars['DateTime']['output'];
};

export type InvoiceLineCreateInput = {
  additionalIds?: InputMaybe<KeyValuesInput>;
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  customRate?: InputMaybe<Scalars['Decimal']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  item?: InputMaybe<InvoiceItemWhereUniqueInput>;
  lineNumber: Scalars['Int']['input'];
  metadata?: InputMaybe<KeyValuesInput>;
  price?: InputMaybe<PriceWhereUniqueInput>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  section: InvoiceLineSection;
  taxCode?: InputMaybe<Scalars['String']['input']>;
  type: InvoiceLineType;
};

export enum InvoiceLineSection {
  Summary = 'summary',
  Table = 'table'
}

export enum InvoiceLineType {
  DescriptionOnly = 'descriptionOnly',
  Discount = 'discount',
  Item = 'item',
  PlatformFee = 'platformFee',
  SalesTax = 'salesTax',
  Subtotal = 'subtotal',
  Surcharge = 'surcharge'
}

export type InvoiceLinesInput = {
  set?: InputMaybe<Array<InvoiceLineCreateInput>>;
};

export type InvoiceMutations = {
  __typename?: 'InvoiceMutations';
  create: InvoiceMutationsCreateResponse;
  /** Derives a draft invoice's due date, saved or not, from its price list's payment terms (Net 30 when it has none); due on the invoice date when any of its orders is cash on delivery. Saves nothing. */
  dueDate: Scalars['Date']['output'];
  finalize: InvoiceMutationsFinalizeResponse;
  markAsPaid: InvoiceMutationsMarkAsPaidResponse;
  new: InvoiceMutationsNewResponse;
  regenerate: InvoiceMutationsRegenerateResponse;
  restore: InvoiceMutationsRestoreResponse;
  revise: InvoiceMutationsReviseResponse;
  saveDraft: InvoiceMutationsSaveDraftResponse;
  sendEmail?: Maybe<SendEmailResponse>;
  sendSms?: Maybe<SendSmsResponse>;
  setPrinted: GenericResponse;
  setViewed: GenericResponse;
  sync: InvoiceMutationsSyncResponse;
  update: InvoiceMutationsUpdateResponse;
  void: InvoiceMutationsVoidResponse;
};


export type InvoiceMutationsCreateArgs = {
  data?: InputMaybe<InvoiceNewInput>;
};


export type InvoiceMutationsDueDateArgs = {
  data: InvoiceUpdateInput;
};


export type InvoiceMutationsFinalizeArgs = {
  data: InvoiceUpdateInput;
  where: InvoiceMutationsUpdateWhereInput;
};


export type InvoiceMutationsMarkAsPaidArgs = {
  data: InvoiceUpdateInput;
  where: InvoiceMutationsUpdateWhereInput;
};


export type InvoiceMutationsNewArgs = {
  data?: InputMaybe<InvoiceNewInput>;
};


export type InvoiceMutationsRegenerateArgs = {
  data?: InputMaybe<InvoiceNewInput>;
};


export type InvoiceMutationsRestoreArgs = {
  data: InvoiceUpdateInput;
  where: InvoiceMutationsUpdateWhereInput;
};


export type InvoiceMutationsReviseArgs = {
  data: InvoiceUpdateInput;
  where: InvoiceMutationsUpdateWhereInput;
};


export type InvoiceMutationsSaveDraftArgs = {
  data: InvoiceUpdateInput;
  where: InvoiceMutationsUpdateWhereInput;
};


export type InvoiceMutationsSendEmailArgs = {
  data: SendEmailInput;
};


export type InvoiceMutationsSendSmsArgs = {
  data: SendSmsInput;
};


export type InvoiceMutationsSetPrintedArgs = {
  where: InvoiceMutationsSetPrintedWhereInput;
};


export type InvoiceMutationsSetViewedArgs = {
  where: InvoiceMutationsSetViewedWhereInput;
};


export type InvoiceMutationsSyncArgs = {
  where: InvoiceMutationsSyncWhereInput;
};


export type InvoiceMutationsUpdateArgs = {
  data: InvoiceUpdateInput;
  where: InvoiceMutationsUpdateWhereInput;
};


export type InvoiceMutationsVoidArgs = {
  data: VoidInvoiceInput;
  where: InvoiceMutationsUpdateWhereInput;
};

export type InvoiceMutationsCreateResponse = {
  __typename?: 'InvoiceMutationsCreateResponse';
  invoice: Invoice;
};

export type InvoiceMutationsFinalizeResponse = {
  __typename?: 'InvoiceMutationsFinalizeResponse';
  invoice: Invoice;
};

export type InvoiceMutationsMarkAsPaidResponse = {
  __typename?: 'InvoiceMutationsMarkAsPaidResponse';
  invoice: Invoice;
};

export type InvoiceMutationsNewResponse = {
  __typename?: 'InvoiceMutationsNewResponse';
  invoice: Invoice;
};

export type InvoiceMutationsRegenerateResponse = {
  __typename?: 'InvoiceMutationsRegenerateResponse';
  invoice: Invoice;
};

export type InvoiceMutationsRestoreResponse = {
  __typename?: 'InvoiceMutationsRestoreResponse';
  invoice: Invoice;
};

export type InvoiceMutationsReviseResponse = {
  __typename?: 'InvoiceMutationsReviseResponse';
  invoice: Invoice;
};

export type InvoiceMutationsSaveDraftResponse = {
  __typename?: 'InvoiceMutationsSaveDraftResponse';
  invoice: Invoice;
};

export type InvoiceMutationsSetPrintedWhereInput = {
  id: Scalars['String']['input'];
};

export type InvoiceMutationsSetViewedWhereInput = {
  id: Scalars['String']['input'];
};

export type InvoiceMutationsSyncResponse = {
  __typename?: 'InvoiceMutationsSyncResponse';
  invoice?: Maybe<Invoice>;
};

export type InvoiceMutationsSyncWhereInput = {
  id: Scalars['String']['input'];
};

export type InvoiceMutationsUpdateResponse = {
  __typename?: 'InvoiceMutationsUpdateResponse';
  invoice: Invoice;
};

export type InvoiceMutationsUpdateWhereInput = {
  id: Scalars['String']['input'];
  revision: Scalars['Int']['input'];
};

export type InvoiceMutationsVoidResponse = {
  __typename?: 'InvoiceMutationsVoidResponse';
  invoice: Invoice;
};

export type InvoiceNewInput = {
  orderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  priceListId?: InputMaybe<Scalars['Int']['input']>;
};

export type InvoicePayment = {
  __typename?: 'InvoicePayment';
  /** Amount that can be paid against this invoice right now: balance minus in-flight charges not yet reflected in it. Equals balance when native payments are disabled for the organization. 0 for draft/paid/voided invoices; never negative. */
  amountPayable: Scalars['Decimal']['output'];
  defaultPaymentMethod?: Maybe<PaymentMethod>;
  hasReceipt: Scalars['Boolean']['output'];
  isProcessing?: Maybe<Scalars['Boolean']['output']>;
  previewGuarantee?: Maybe<InvoicePaymentPreviewGuarantee>;
  sessions: Array<PaymentSession>;
  /** Computed status from the payment sessions */
  status?: Maybe<PaymentSessionStatus>;
  stripeId?: Maybe<Scalars['String']['output']>;
};

export type InvoicePaymentPreviewGuarantee = {
  __typename?: 'InvoicePaymentPreviewGuarantee';
  amountToCharge: Scalars['Decimal']['output'];
  remainingBalance: Scalars['Decimal']['output'];
  totalFees?: Maybe<Scalars['Decimal']['output']>;
};

export type InvoiceSourceDetail = {
  __typename?: 'InvoiceSourceDetail';
  amount: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  invoiceId: Scalars['String']['output'];
  invoiceNumber: Scalars['String']['output'];
};

export type InvoiceStatus = {
  __typename?: 'InvoiceStatus';
  active: Scalars['Boolean']['output'];
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InvoiceTemplate = {
  __typename?: 'InvoiceTemplate';
  active: Scalars['Boolean']['output'];
  changelog?: Maybe<Changelog>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  lines: Array<InvoiceTemplateLine>;
  metadata?: Maybe<Array<KeyValue>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type InvoiceTemplateInput = {
  lines?: InputMaybe<InvoiceTemplateLinesInput>;
};

export type InvoiceTemplateLine = {
  __typename?: 'InvoiceTemplateLine';
  createdAt: Scalars['DateTime']['output'];
  displayIfZero: Scalars['Boolean']['output'];
  group?: Maybe<InvoiceTemplateLineGroup>;
  id: Scalars['String']['output'];
  item?: Maybe<InvoiceItem>;
  lineNumber: Scalars['Int']['output'];
  section: InvoiceLineSection;
  type: InvoiceTemplateLineType;
  updatedAt: Scalars['DateTime']['output'];
};

export type InvoiceTemplateLineGroup = {
  __typename?: 'InvoiceTemplateLineGroup';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  lines: Array<InvoiceTemplateLine>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InvoiceTemplateLineGroupCreateInput = {
  lines?: InputMaybe<InvoiceTemplateLinesInput>;
  name: Scalars['String']['input'];
};

export type InvoiceTemplateLineGroupMutations = {
  __typename?: 'InvoiceTemplateLineGroupMutations';
  create: InvoiceTemplateLineGroupMutationsCreateResponse;
  update: InvoiceTemplateLineGroupMutationsUpdateResponse;
};


export type InvoiceTemplateLineGroupMutationsCreateArgs = {
  data: InvoiceTemplateLineGroupCreateInput;
};


export type InvoiceTemplateLineGroupMutationsUpdateArgs = {
  data: InvoiceTemplateLineGroupUpdateInput;
  where: InvoiceTemplateLineGroupWhereUniqueInput;
};

export type InvoiceTemplateLineGroupMutationsCreateResponse = {
  __typename?: 'InvoiceTemplateLineGroupMutationsCreateResponse';
  invoiceTemplateLineGroup: InvoiceTemplateLineGroup;
};

export type InvoiceTemplateLineGroupMutationsUpdateResponse = {
  __typename?: 'InvoiceTemplateLineGroupMutationsUpdateResponse';
  invoiceTemplateLineGroup: InvoiceTemplateLineGroup;
};

export type InvoiceTemplateLineGroupRelationInput = {
  connect?: InputMaybe<InvoiceTemplateLineGroupWhereUniqueInput>;
};

export type InvoiceTemplateLineGroupUpdateInput = {
  lines?: InputMaybe<InvoiceTemplateLinesInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceTemplateLineGroupWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type InvoiceTemplateLineInput = {
  displayIfZero?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<InvoiceTemplateLineGroupRelationInput>;
  id: Scalars['String']['input'];
  item?: InputMaybe<InvoiceItemWhereUniqueInput>;
  lineNumber?: InputMaybe<Scalars['Int']['input']>;
  section?: InputMaybe<InvoiceLineSection>;
  type?: InputMaybe<InvoiceTemplateLineType>;
};

export enum InvoiceTemplateLineType {
  Discount = 'discount',
  Group = 'group',
  Item = 'item',
  Subtotal = 'subtotal',
  Surcharge = 'surcharge'
}

export type InvoiceTemplateLineWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type InvoiceTemplateLinesInput = {
  delete?: InputMaybe<Array<InvoiceTemplateLineWhereUniqueInput>>;
  set?: InputMaybe<Array<InvoiceTemplateLineInput>>;
  upsert?: InputMaybe<Array<InvoiceTemplateLineInput>>;
};

export type InvoiceTemplateRelationInput = {
  upsert?: InputMaybe<InvoiceTemplateInput>;
};

export type InvoiceTemplateWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type InvoiceTerm = {
  __typename?: 'InvoiceTerm';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
};

export type InvoiceTermWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type InvoiceTitle = {
  __typename?: 'InvoiceTitle';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Array<Scalars['String']['output']>>;
};

export type InvoiceTitleInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InvoiceUpdateInput = {
  additionalIds?: InputMaybe<KeyValuesInput>;
  amountDue: Scalars['Decimal']['input'];
  billTo?: InputMaybe<InvoiceBillToInput>;
  branch: BranchWhereUniqueInput;
  comments?: InputMaybe<CommentsInput>;
  currency: Scalars['String']['input'];
  customer?: InputMaybe<CustomerWhereUniqueInput>;
  details?: InputMaybe<Array<InvoiceDetailInput>>;
  draftCreditMemo?: InputMaybe<Scalars['Decimal']['input']>;
  dueDate: Scalars['Date']['input'];
  emails: Array<Scalars['String']['input']>;
  invoiceDate: Scalars['Date']['input'];
  lines?: InputMaybe<InvoiceLinesInput>;
  memo?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<KeyValuesInput>;
  number: Scalars['String']['input'];
  orders?: InputMaybe<Array<OrderWhereUniqueInput>>;
  priceList?: InputMaybe<PriceListWhereUniqueInput>;
  purchaseOrder?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<SiteWhereUniqueInput>;
  status: Scalars['String']['input'];
  tags?: InputMaybe<TagsInput>;
  title?: InputMaybe<InvoiceTitleInput>;
};

export type InvoiceWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type KeyValue = {
  __typename?: 'KeyValue';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Json']['output']>;
};

export type KeyValueInput = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Json']['input']>;
};

export type KeyValuesInput = {
  create?: InputMaybe<Array<KeyValueInput>>;
  delete?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<KeyValueInput>>;
  update?: InputMaybe<Array<KeyValueInput>>;
  upsert?: InputMaybe<Array<KeyValueInput>>;
};

export type LedgerEntriesDateRangeInput = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type LedgerEntriesFilterInput = {
  accountCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  branchId?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  effectiveDateRange?: InputMaybe<LedgerEntriesDateRangeInput>;
};

export type LedgerEntriesPage = {
  __typename?: 'LedgerEntriesPage';
  entries: Array<LedgerEntryLineItem>;
  hasMore: Scalars['Boolean']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  period: AccountingPeriod;
  totals?: Maybe<LedgerEntryTotals>;
};

export type LedgerEntry = {
  __typename?: 'LedgerEntry';
  effectiveDate: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  memo?: Maybe<Scalars['String']['output']>;
  periodId?: Maybe<Scalars['Int']['output']>;
  postedAt: Scalars['DateTime']['output'];
  reversalOfId?: Maybe<Scalars['Int']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceType: LedgerEntrySourceType;
};

export type LedgerEntryLineItem = {
  __typename?: 'LedgerEntryLineItem';
  accountCode: Scalars['String']['output'];
  amount: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  direction: LedgerLineDirection;
  effectiveDate: Scalars['Date']['output'];
  entryId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isReversal: Scalars['Boolean']['output'];
  memo?: Maybe<Scalars['String']['output']>;
  sourceType: LedgerEntrySourceType;
};

export type LedgerEntryLineSourcesResult = {
  __typename?: 'LedgerEntryLineSourcesResult';
  actualAmount: Scalars['Decimal']['output'];
  expectedAmount: Scalars['Decimal']['output'];
  isBalanced: Scalars['Boolean']['output'];
  sources: Array<LedgerEntrySourceItem>;
};

export type LedgerEntrySourceItem = {
  __typename?: 'LedgerEntrySourceItem';
  contributedAmount: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  ledgerEntryLineId: Scalars['Int']['output'];
  sourceDetail?: Maybe<SourceDetail>;
  sourceId: Scalars['String']['output'];
  sourceType: LedgerSourceKind;
};

export enum LedgerEntrySourceType {
  HistoricalBackfill = 'historical_backfill',
  Manual = 'manual',
  PeriodClose = 'period_close',
  Reclassification = 'reclassification',
  Reversal = 'reversal',
  SoftPost = 'soft_post'
}

export type LedgerEntryTotals = {
  __typename?: 'LedgerEntryTotals';
  byAccount: Array<AccountBalance>;
  credits: Scalars['Decimal']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  debits: Scalars['Decimal']['output'];
};

export type LedgerExport = {
  __typename?: 'LedgerExport';
  createdAt: Scalars['DateTime']['output'];
  createdByActorGuid: Scalars['Int']['output'];
  downloadUrl?: Maybe<Scalars['String']['output']>;
  format: Scalars['String']['output'];
  highWaterMark: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  periodId?: Maybe<Scalars['Int']['output']>;
  previousExportId?: Maybe<Scalars['Int']['output']>;
};

export enum LedgerExportFormat {
  Csv = 'CSV'
}

export enum LedgerLineDirection {
  Credit = 'Credit',
  Debit = 'Debit'
}

/** When the period JournalEntry is pushed: only at close, or nightly while open and finalized at close. */
export enum LedgerPostingPolicy {
  NightlyUntilClose = 'nightly_until_close',
  OnCloseOnly = 'on_close_only'
}

export type LedgerReport = {
  __typename?: 'LedgerReport';
  canRegenerate: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  period: AccountingPeriod;
  periodId: Scalars['Int']['output'];
  requestedAt: Scalars['DateTime']['output'];
  requestedByActorGuid: Scalars['Int']['output'];
  status: LedgerReportStatus;
};

export enum LedgerReportStatus {
  Failed = 'failed',
  Generating = 'generating',
  Pending = 'pending',
  Ready = 'ready'
}

/** Discriminator for the entity a LedgerEntrySource row points at. */
export enum LedgerSourceKind {
  Invoice = 'Invoice',
  ManualLedgerEntry = 'ManualLedgerEntry',
  Payment = 'Payment',
  PaymentAllocation = 'PaymentAllocation',
  ProcessingFeeExpense = 'ProcessingFeeExpense',
  Refund = 'Refund'
}

export type Link = {
  __typename?: 'Link';
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type LinkedAccount = {
  __typename?: 'LinkedAccount';
  id: Scalars['Int']['output'];
  identities: Array<LinkedAccountIdentity>;
  invoices: LinkedAccountInvoices;
  isPossiblyAnOperator: Scalars['Boolean']['output'];
  metrics?: Maybe<LinkedAccountMetrics>;
  name: Scalars['String']['output'];
  needsNameUpdate: Scalars['Boolean']['output'];
  orderSharing: LinkedAccountOrderSharing;
  orders: LinkedAccountOrders;
  organizations: Array<Organization>;
  organizationsWithSharedAccess: Array<Organization>;
  paymentMethodRequest?: Maybe<LinkedAccountPaymentMethodRequest>;
  preparedPayment?: Maybe<LinkedAccountPreparedPayment>;
  wallet: Wallet;
};


export type LinkedAccountMetricsArgs = {
  where: LinkedAccountMetricsInput;
};


export type LinkedAccountPaymentMethodRequestArgs = {
  where: LinkedAccountPaymentMethodRequestWhereInput;
};


export type LinkedAccountPreparedPaymentArgs = {
  where: LinkedAccountPreparedPaymentWhereInput;
};

export type LinkedAccountIdentity = {
  __typename?: 'LinkedAccountIdentity';
  id: Scalars['Int']['output'];
  identity: Scalars['String']['output'];
  linkedAccountId: Scalars['Int']['output'];
  type: LinkedAccountIdentityType;
  verified: Scalars['Boolean']['output'];
};

export enum LinkedAccountIdentityType {
  Email = 'email',
  Phone = 'phone'
}

export type LinkedAccountInvoiceDetailsWhereInput = {
  id: Scalars['ID']['input'];
};

export type LinkedAccountInvoiceWhereInput = {
  tid?: InputMaybe<Scalars['Int']['input']>;
};

export type LinkedAccountInvoices = {
  __typename?: 'LinkedAccountInvoices';
  all: Array<Invoice>;
  details?: Maybe<Invoice>;
  open: Array<Invoice>;
  shortLinkDetails?: Maybe<Invoice>;
};


export type LinkedAccountInvoicesAllArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkedAccountInvoiceWhereInput>;
};


export type LinkedAccountInvoicesDetailsArgs = {
  where: LinkedAccountInvoiceDetailsWhereInput;
};


export type LinkedAccountInvoicesOpenArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkedAccountInvoiceWhereInput>;
};


export type LinkedAccountInvoicesShortLinkDetailsArgs = {
  where: LinkedAccountInvoiceDetailsWhereInput;
};

export type LinkedAccountMetrics = {
  __typename?: 'LinkedAccountMetrics';
  costPerYard: Scalars['Float']['output'];
  totalOrders: Scalars['Int']['output'];
  totalYardsPoured: Scalars['Float']['output'];
  yardsHistogram: Array<LinkedAccountMetricsYardsHistogramEntry>;
  yardsPerHour: Scalars['Float']['output'];
  yardsPerPour: Scalars['Float']['output'];
};

export type LinkedAccountMetricsInput = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  tid: Scalars['Int']['input'];
};

export type LinkedAccountMetricsYardsHistogramEntry = {
  __typename?: 'LinkedAccountMetricsYardsHistogramEntry';
  endDate: Scalars['Date']['output'];
  startDate: Scalars['Date']['output'];
  totalOrders: Scalars['Int']['output'];
  totalYardsPoured: Scalars['Float']['output'];
};

export type LinkedAccountOrder = {
  __typename?: 'LinkedAccountOrder';
  isOwner: Scalars['Boolean']['output'];
  order: Order;
  owner?: Maybe<LinkedAccount>;
};

export type LinkedAccountOrderDetailsWhereInput = {
  id: Scalars['Int']['input'];
  tid?: InputMaybe<Scalars['Int']['input']>;
};

export type LinkedAccountOrderSharing = {
  __typename?: 'LinkedAccountOrderSharing';
  active: Array<OrderSharing>;
  requestDetails?: Maybe<OrderSharingRequest>;
  requestsReceived: Array<OrderSharingRequest>;
  requestsSent: Array<OrderSharingRequest>;
};


export type LinkedAccountOrderSharingRequestDetailsArgs = {
  where: OrderSharingRequestDetailsInput;
};

export type LinkedAccountOrderWhereInput = {
  dateOfService?: InputMaybe<DateTimeNullableFilter>;
  tid?: InputMaybe<Scalars['Int']['input']>;
};

export type LinkedAccountOrders = {
  __typename?: 'LinkedAccountOrders';
  actionRequired: Array<LinkedAccountOrder>;
  completed: Array<LinkedAccountOrder>;
  details?: Maybe<LinkedAccountOrder>;
  onGoing: Array<LinkedAccountOrder>;
  open: Array<LinkedAccountOrder>;
};


export type LinkedAccountOrdersActionRequiredArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkedAccountOrderWhereInput>;
};


export type LinkedAccountOrdersCompletedArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkedAccountOrderWhereInput>;
};


export type LinkedAccountOrdersDetailsArgs = {
  where: LinkedAccountOrderDetailsWhereInput;
};


export type LinkedAccountOrdersOnGoingArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkedAccountOrderWhereInput>;
};


export type LinkedAccountOrdersOpenArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkedAccountOrderWhereInput>;
};

export type LinkedAccountPaymentMethodRequest = {
  __typename?: 'LinkedAccountPaymentMethodRequest';
  customerName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  organization: Organization;
  /** Method types the customer's payment config accepts */
  paymentMethodTypes: Array<PaymentMethodType>;
  /** Method types whose processing fee is passed to the customer when charged */
  processingFeeTypes: Array<PaymentMethodType>;
  status: PaymentMethodRequestStatus;
};

export type LinkedAccountPaymentMethodRequestWhereInput = {
  id: Scalars['ID']['input'];
};

export type LinkedAccountPreparedPayment = {
  __typename?: 'LinkedAccountPreparedPayment';
  currency: Scalars['String']['output'];
  /** Highest customer-facing processing fee for the payable total; 0 when fees are not passed to the customer. Estimation failures propagate as a field error rather than a null — a null must never be rendered as a zero fee. */
  estimatedFee?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['String']['output'];
  invoices: Array<LinkedAccountPreparedPaymentInvoice>;
  organization: Organization;
  /** Live-recomputed payable total; 0 when nothing is left to pay */
  total: Scalars['Decimal']['output'];
};

export type LinkedAccountPreparedPaymentInvoice = {
  __typename?: 'LinkedAccountPreparedPaymentInvoice';
  dueDate?: Maybe<Scalars['Date']['output']>;
  invoiceId: Scalars['String']['output'];
  /** A charge covering this invoice is in flight (processing or settling) */
  isProcessing: Scalars['Boolean']['output'];
  number: Scalars['String']['output'];
  /** min(requested ?? balance, live payable balance); 0 when not payable */
  payableAmount: Scalars['Decimal']['output'];
  /** Requested partial amount; null means pay the full balance */
  requestedAmount?: Maybe<Scalars['Decimal']['output']>;
  status: Scalars['String']['output'];
};

export type LinkedAccountPreparedPaymentWhereInput = {
  id: Scalars['ID']['input'];
};

export type ListInvoiceAvailablePaymentMethodsResponse = {
  __typename?: 'ListInvoiceAvailablePaymentMethodsResponse';
  availablePaymentMethods: Array<PaymentMethod>;
};

export type MaintenanceEvent = {
  __typename?: 'MaintenanceEvent';
  active: Scalars['Boolean']['output'];
  comments: Array<Comment>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Person>;
  createdById?: Maybe<Scalars['Int']['output']>;
  equipment: Equipment;
  equipmentId: Scalars['Int']['output'];
  event: Event;
  id: Scalars['Int']['output'];
  tags: Array<Tag>;
  title: Scalars['String']['output'];
  type: MaintenanceEventType;
  typeId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MaintenanceEventCreateDataInput = {
  comments?: InputMaybe<CommentsInput>;
  date: Scalars['Date']['input'];
  equipmentId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  typeId: Scalars['Int']['input'];
};

export type MaintenanceEventCreateResponse = {
  __typename?: 'MaintenanceEventCreateResponse';
  maintenanceEvent: MaintenanceEvent;
};

export type MaintenanceEventMutations = {
  __typename?: 'MaintenanceEventMutations';
  create: MaintenanceEventCreateResponse;
  update: MaintenanceEventUpdateResponse;
};


export type MaintenanceEventMutationsCreateArgs = {
  data: MaintenanceEventCreateDataInput;
};


export type MaintenanceEventMutationsUpdateArgs = {
  data: MaintenanceEventUpdateDataInput;
  where: MaintenanceEventUpdateWhereInput;
};

export type MaintenanceEventQueryWhereInput = {
  id: Scalars['Int']['input'];
};

export type MaintenanceEventType = {
  __typename?: 'MaintenanceEventType';
  active: Scalars['Boolean']['output'];
  category?: Maybe<MaintenanceEventType>;
  categoryId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isCategory: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MaintenanceEventUpdateDataInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  comments?: InputMaybe<CommentsInput>;
  date?: InputMaybe<Scalars['Date']['input']>;
  equipmentId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['Int']['input']>;
};

export type MaintenanceEventUpdateResponse = {
  __typename?: 'MaintenanceEventUpdateResponse';
  maintenanceEvent: MaintenanceEvent;
};

export type MaintenanceEventUpdateWhereInput = {
  id: Scalars['Int']['input'];
};

/** Reason associated with a ManualLedgerEntry source row. */
export enum ManualLedgerEntryReason {
  BadDebt = 'bad_debt',
  Correction = 'correction',
  OpeningBalance = 'opening_balance',
  Other = 'other',
  Reclassification = 'reclassification',
  WriteOff = 'write_off'
}

export type ManualLedgerEntrySourceDetail = {
  __typename?: 'ManualLedgerEntrySourceDetail';
  ledgerEntryId: Scalars['Int']['output'];
  manualEntryId: Scalars['Int']['output'];
  memo?: Maybe<Scalars['String']['output']>;
  reason: ManualLedgerEntryReason;
};

export type MatchInput = {
  accountingDate: Scalars['DateTime']['input'];
  allocationTargetType?: InputMaybe<Scalars['String']['input']>;
  branchId?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  invoiceLineType?: InputMaybe<Scalars['String']['input']>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  itemId?: InputMaybe<Scalars['Int']['input']>;
  ledgerLegType?: InputMaybe<Scalars['String']['input']>;
  paymentTypeCategory?: InputMaybe<PaymentTypeCategory>;
  paymentTypeSlug?: InputMaybe<Scalars['String']['input']>;
  processingFeeExpenseType?: InputMaybe<Scalars['String']['input']>;
  refundTypeCategory?: InputMaybe<RefundTypeCategory>;
  refundTypeSlug?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type MergeCustomerResponse = {
  __typename?: 'MergeCustomerResponse';
  customer: Customer;
  deleted: Array<Scalars['Int']['output']>;
};

export type Message = {
  __typename?: 'Message';
  ackedAt?: Maybe<Scalars['DateTime']['output']>;
  additionalIds?: Maybe<Array<KeyValue>>;
  assignments: Array<Assignment>;
  body: Scalars['String']['output'];
  changelog?: Maybe<Changelog>;
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  extras?: Maybe<Scalars['Json']['output']>;
  from: Scalars['String']['output'];
  handler: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  invoices: Array<Invoice>;
  orders: Array<Order>;
  recipient?: Maybe<Person>;
  recipientId?: Maybe<Scalars['Int']['output']>;
  routes: Array<Route>;
  sender?: Maybe<Person>;
  senderId?: Maybe<Scalars['Int']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: MessageStatus;
  subject: Scalars['String']['output'];
  to: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  typeDetails?: Maybe<MessageType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MessagePreference = {
  __typename?: 'MessagePreference';
  description?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  optedIn?: Maybe<Scalars['Boolean']['output']>;
  path: Scalars['String']['output'];
};

export type MessagePreferenceInput = {
  optedIn: Scalars['Boolean']['input'];
  path: Scalars['String']['input'];
};

export type MessagePreferencesInput = {
  upsert?: InputMaybe<Array<MessagePreferenceInput>>;
};

export type MessageScope = {
  __typename?: 'MessageScope';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum MessageStatus {
  Bounced = 'bounced',
  Cancelled = 'cancelled',
  Complained = 'complained',
  Delivered = 'delivered',
  Failed = 'failed',
  Queued = 'queued',
  Scheduled = 'scheduled',
  Sending = 'sending',
  Sent = 'sent',
  Skipped = 'skipped'
}

export type MessageType = {
  __typename?: 'MessageType';
  active: Scalars['Boolean']['output'];
  allowResend: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  defaultOptedIn: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MessageUpdateInput = {
  ackedAt?: InputMaybe<Scalars['DateTime']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  metadata?: InputMaybe<KeyValuesInput>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<MessageStatus>;
};

export type MessageWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
};

export type Messaging = {
  __typename?: 'Messaging';
  dailyConfirmationTime: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptPlatformTermsOfUse: PlatformTermsOfUseStatus;
  accounting?: Maybe<AccountingMutations>;
  acknowledgeAssignment?: Maybe<Assignment>;
  acknowledgeMessage?: Maybe<Message>;
  auth?: Maybe<AuthMutations>;
  /** Exchange auth.cretesuite.com JWT for an api access JWT */
  authorize?: Maybe<Authorization>;
  autoAssignDefaultOperators?: Maybe<AutoAssignDefaultOperatorsResult>;
  cacheOrderEstimatedRevenue?: Maybe<Order>;
  /** Cancel (delete) a Person Time Off */
  cancelPersonTimeOff: PersonTimeOff;
  collectOrderSignature?: Maybe<Signature>;
  connectTags?: Maybe<UpdateTagsRelationsResponse>;
  contact?: Maybe<ContactMutations>;
  createBranch?: Maybe<Branch>;
  createContact?: Maybe<Contact>;
  createInventoryItem?: Maybe<InventoryItem>;
  createNote?: Maybe<Note>;
  createOneCustomer?: Maybe<Customer>;
  createOneEquipment?: Maybe<Equipment>;
  createOperator?: Maybe<Operator>;
  createOrder?: Maybe<Order>;
  createPourType?: Maybe<PourType>;
  createReportingEntity?: Maybe<ReportingEntity>;
  createSite?: Maybe<Site>;
  createSupplier?: Maybe<Supplier>;
  createUser?: Maybe<User>;
  creditMemo?: Maybe<CreditMemoMutations>;
  customer?: Maybe<CustomerMutations>;
  dashboardPaymentSession?: Maybe<DashboardPaymentSessionMutations>;
  deleteNotificationOverride: Scalars['Boolean']['output'];
  deposit?: Maybe<DepositMutations>;
  disconnectTags?: Maybe<UpdateTagsRelationsResponse>;
  dispatchRoute?: Maybe<Route>;
  email?: Maybe<EmailMutations>;
  equipment?: Maybe<EquipmentMutations>;
  equipmentGroup?: Maybe<EquipmentGroupMutations>;
  equipmentMake?: Maybe<EquipmentMakeMutations>;
  equipmentModel?: Maybe<EquipmentModelMutations>;
  equipmentType?: Maybe<EquipmentTypeMutations>;
  file?: Maybe<FileMutations>;
  fitIntoRoute?: Maybe<Order>;
  insightsDashboard?: Maybe<InsightsDashboardMutations>;
  integrations?: Maybe<IntegrationsMutationNamespace>;
  invoice?: Maybe<InvoiceMutations>;
  invoiceItem?: Maybe<InvoiceItemMutations>;
  invoiceTemplateLineGroup?: Maybe<InvoiceTemplateLineGroupMutations>;
  maintenanceEvent?: Maybe<MaintenanceEventMutations>;
  mergeCustomers: MergeCustomerResponse;
  myAccount?: Maybe<MyAccountMutations>;
  notification?: Maybe<NotificationMutations>;
  notifyAssignment?: Maybe<Message>;
  operator?: Maybe<OperatorMutations>;
  orderPhoto?: Maybe<OrderPhotoMutations>;
  payment?: Maybe<PaymentMutations>;
  person?: Maybe<PersonMutations>;
  priceList?: Maybe<PriceListMutations>;
  priceListSchedule?: Maybe<PriceListScheduleMutations>;
  requestOrderChange?: Maybe<RequestChangesResponse>;
  requestSiteLocation?: Maybe<Message>;
  route?: Maybe<RouteMutations>;
  /** Schedule Time Off for a Person */
  schedulePersonTimeOff: PersonTimeOff;
  sendOrderMessage?: Maybe<Message>;
  service?: Maybe<ServiceMutations>;
  /** Set the approval status of a Person Time Off */
  setPersonTimeOffApproval: PersonTimeOff;
  site?: Maybe<SiteMutations>;
  statement?: Maybe<StatementMutations>;
  statements?: Maybe<StatementsMutations>;
  stripe?: Maybe<StripeMutations>;
  subRequest?: Maybe<SubRequestMutations>;
  sweepScheduledMessages: SweepScheduledMessagesResult;
  tag?: Maybe<TagMutations>;
  timeClock?: Maybe<TimeClockMutations>;
  timeClockShift?: Maybe<TimeClockShiftMutations>;
  updateBranch?: Maybe<Branch>;
  updateContact?: Maybe<Contact>;
  updateEquipmentAvailability?: Maybe<EquipmentAvailability>;
  updateInventoryItem?: Maybe<InventoryItem>;
  updateMessage?: Maybe<Message>;
  updateNote?: Maybe<Note>;
  updateOneCustomer?: Maybe<Customer>;
  updateOneEquipment?: Maybe<Equipment>;
  updateOperator?: Maybe<Operator>;
  updateOrder?: Maybe<Order>;
  updateOrganization?: Maybe<Organization>;
  updateOrganizationConfig: OrganizationConfigUpdateResult;
  /** Update a Person Time Off */
  updatePersonTimeOff: PersonTimeOff;
  updatePourType?: Maybe<PourType>;
  updateReportingEntity?: Maybe<ReportingEntity>;
  updateRoute?: Maybe<Route>;
  updateRouteWaypoint?: Maybe<RouteWaypoint>;
  updateSite?: Maybe<Site>;
  updateSupplier?: Maybe<Supplier>;
  updateTerms?: Maybe<Terms>;
  updateUser?: Maybe<User>;
  upsertNotificationOverride: NotificationRuleOverride;
  upsertNotificationRuleConfig: NotificationRuleConfig;
  userRole?: Maybe<UserRoleMutations>;
};


export type MutationAcceptPlatformTermsOfUseArgs = {
  data: AcceptPlatformTermsOfUseInput;
};


export type MutationAcknowledgeAssignmentArgs = {
  where: AcknowledgeAssignmentInput;
};


export type MutationAcknowledgeMessageArgs = {
  where: AcknowledgeMessageInput;
};


export type MutationAuthorizeArgs = {
  jwt: Scalars['String']['input'];
  scope?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAutoAssignDefaultOperatorsArgs = {
  data: AutoAssignDefaultOperatorsInput;
};


export type MutationCacheOrderEstimatedRevenueArgs = {
  where: OrderWhereUniqueInput;
};


export type MutationCancelPersonTimeOffArgs = {
  where: PersonCancelTimeOffWhereInput;
};


export type MutationCollectOrderSignatureArgs = {
  data: CollectSignatureInput;
  where: OrderWhereUniqueInput;
};


export type MutationConnectTagsArgs = {
  data: UpdateTagsRelationsDataInput;
  where: Array<TagWhereUniqueInput>;
};


export type MutationCreateBranchArgs = {
  data: BranchInput;
};


export type MutationCreateContactArgs = {
  data: ContactInput;
};


export type MutationCreateInventoryItemArgs = {
  data: InventoryItemCreateInput;
};


export type MutationCreateNoteArgs = {
  data: NoteInput;
};


export type MutationCreateOneCustomerArgs = {
  data: CustomerInput;
};


export type MutationCreateOneEquipmentArgs = {
  data: EquipmentInput;
};


export type MutationCreateOperatorArgs = {
  data: OperatorInput;
};


export type MutationCreateOrderArgs = {
  data: OrderCreateInput;
};


export type MutationCreatePourTypeArgs = {
  data: PourTypeInput;
};


export type MutationCreateReportingEntityArgs = {
  data: ReportingEntityInput;
};


export type MutationCreateSiteArgs = {
  data: SiteInput;
};


export type MutationCreateSupplierArgs = {
  data: SupplierInput;
};


export type MutationCreateUserArgs = {
  data: UserInput;
};


export type MutationDeleteNotificationOverrideArgs = {
  input: DeleteNotificationOverrideInput;
};


export type MutationDisconnectTagsArgs = {
  data: UpdateTagsRelationsDataInput;
  where: Array<TagWhereUniqueInput>;
};


export type MutationDispatchRouteArgs = {
  where: RouteWhereUniqueInput;
};


export type MutationFitIntoRouteArgs = {
  data: FitOrderIntoRouteInput;
  where: OrderWhereUniqueInput;
};


export type MutationMergeCustomersArgs = {
  customers: Array<CustomerWhereUniqueInput>;
};


export type MutationNotifyAssignmentArgs = {
  data: NotifyAssignmentInput;
};


export type MutationRequestOrderChangeArgs = {
  data: RequestOrderChangeInput;
  where: OrderWhereUniqueInput;
};


export type MutationRequestSiteLocationArgs = {
  data: RequestSiteLocationInput;
  where: SiteWhereUniqueInput;
};


export type MutationSchedulePersonTimeOffArgs = {
  data: PersonScheduleTimeOffDataInput;
  where: PersonScheduleTimeOffWhereInput;
};


export type MutationSendOrderMessageArgs = {
  data: SendOrderMessageInput;
  where: OrderWhereUniqueInput;
};


export type MutationSetPersonTimeOffApprovalArgs = {
  approval: TimeOffApproval;
  where: PersonUpdateTimeOffWhereInput;
};


export type MutationUpdateBranchArgs = {
  data: BranchUpdateInput;
  where: BranchWhereUniqueInput;
};


export type MutationUpdateContactArgs = {
  data: ContactUpdateInput;
  where: ContactWhereUniqueInput;
};


export type MutationUpdateEquipmentAvailabilityArgs = {
  data: EquipmentAvailabilityUpdateInput;
  where: EquipmentAvailabilityWhereUniqueInput;
};


export type MutationUpdateInventoryItemArgs = {
  data: InventoryItemUpdateInput;
  where: InventoryItemWhereUniqueInput;
};


export type MutationUpdateMessageArgs = {
  data: MessageUpdateInput;
  where: MessageWhereUniqueInput;
};


export type MutationUpdateNoteArgs = {
  data: NoteUpdateInput;
  where: NoteWhereUniqueInput;
};


export type MutationUpdateOneCustomerArgs = {
  data: CustomerUpdateInput;
  where: CustomerWhereUniqueInput;
};


export type MutationUpdateOneEquipmentArgs = {
  data: EquipmentUpdateInput;
  where: EquipmentWhereUniqueInput;
};


export type MutationUpdateOperatorArgs = {
  data: OperatorUpdateInput;
  where: OperatorWhereUniqueInput;
};


export type MutationUpdateOrderArgs = {
  data: OrderUpdateInput;
  where: OrderWhereUniqueInput;
};


export type MutationUpdateOrganizationArgs = {
  data: OrganizationUpdateInput;
  where: OrganizationWhereUniqueInput;
};


export type MutationUpdateOrganizationConfigArgs = {
  input: OrganizationConfigInput;
};


export type MutationUpdatePersonTimeOffArgs = {
  data: PersonScheduleTimeOffDataInput;
  where: PersonUpdateTimeOffWhereInput;
};


export type MutationUpdatePourTypeArgs = {
  data: PourTypeUpdateInput;
  where: PourTypeWhereUniqueInput;
};


export type MutationUpdateReportingEntityArgs = {
  data: ReportingEntityUpdateInput;
  where: ReportingEntityWhereUniqueInput;
};


export type MutationUpdateRouteArgs = {
  data: RouteUpdateInput;
  where: RouteWhereUniqueInput;
};


export type MutationUpdateRouteWaypointArgs = {
  data: RouteWaypointInput;
  where: RouteWaypointWhereUniqueInput;
};


export type MutationUpdateSiteArgs = {
  data: SiteUpdateInput;
  where: SiteWhereUniqueInput;
};


export type MutationUpdateSupplierArgs = {
  data: SupplierUpdateInput;
  where: SupplierWhereUniqueInput;
};


export type MutationUpdateTermsArgs = {
  data: TermsUpdateInput;
};


export type MutationUpdateUserArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpsertNotificationOverrideArgs = {
  input: UpsertNotificationOverrideInput;
};


export type MutationUpsertNotificationRuleConfigArgs = {
  input: UpsertNotificationRuleConfigInput;
};

export type MyAccountIdentityAddDataInput = {
  forceSend?: InputMaybe<Scalars['Boolean']['input']>;
  identity: Scalars['String']['input'];
  type: LinkedAccountIdentityType;
};

export type MyAccountIdentityAddResponse = {
  __typename?: 'MyAccountIdentityAddResponse';
  isValid: Scalars['Boolean']['output'];
  verificationKey?: Maybe<Scalars['String']['output']>;
};

export type MyAccountIdentityMutations = {
  __typename?: 'MyAccountIdentityMutations';
  add: MyAccountIdentityAddResponse;
  verify: MyAccountVerifyIdentityResponse;
};


export type MyAccountIdentityMutationsAddArgs = {
  data: MyAccountIdentityAddDataInput;
};


export type MyAccountIdentityMutationsVerifyArgs = {
  data: MyAccountVerifyIdentityDataInput;
};

export type MyAccountMutations = {
  __typename?: 'MyAccountMutations';
  identity?: Maybe<MyAccountIdentityMutations>;
  order?: Maybe<MyAccountOrderMutations>;
  orderSharing?: Maybe<OrderSharingMutations>;
  paymentSession?: Maybe<MyAccountPaymentSessionMutations>;
  update?: Maybe<LinkedAccount>;
  wallet?: Maybe<MyAccountWalletMutations>;
};


export type MyAccountMutationsUpdateArgs = {
  data: MyAccountUpdateDataInput;
};

export type MyAccountOrderMutations = {
  __typename?: 'MyAccountOrderMutations';
  attachPaymentMethod?: Maybe<OrderAttachPaymentMethodResponse>;
  collectOrderDetails?: Maybe<Order>;
};


export type MyAccountOrderMutationsAttachPaymentMethodArgs = {
  data: OrderAttachPaymentMethodInput;
  where: OrderWhereUniqueInput;
};


export type MyAccountOrderMutationsCollectOrderDetailsArgs = {
  data: CollectOrderDetailsInput;
  where: OrderWhereUniqueInput;
};

export type MyAccountPaymentSessionCaptureGuaranteeInput = {
  /** use another payment method if a second charge is needed */
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  paymentSessionId: Scalars['String']['input'];
};

export type MyAccountPaymentSessionCaptureGuaranteeResponse = {
  __typename?: 'MyAccountPaymentSessionCaptureGuaranteeResponse';
  paymentSessions: Array<PaymentSession>;
};

export type MyAccountPaymentSessionCreateForInvoicesInput = {
  invoiceIds: Array<Scalars['String']['input']>;
};

export type MyAccountPaymentSessionCreateForOrderGuaranteeInput = {
  orderId: Scalars['Int']['input'];
  paymentMethodId: Scalars['String']['input'];
};

export type MyAccountPaymentSessionCreateFromPreparedPaymentInput = {
  preparedPaymentId: Scalars['String']['input'];
};

export type MyAccountPaymentSessionCreateResponse = {
  __typename?: 'MyAccountPaymentSessionCreateResponse';
  paymentSession: PaymentSession;
};

export type MyAccountPaymentSessionGenerateReceiptResponse = {
  __typename?: 'MyAccountPaymentSessionGenerateReceiptResponse';
  paymentSession: PaymentSession;
  receipt: PaymentSessionReceipt;
};

export type MyAccountPaymentSessionMutations = {
  __typename?: 'MyAccountPaymentSessionMutations';
  captureGuarantee?: Maybe<MyAccountPaymentSessionCaptureGuaranteeResponse>;
  createForInvoices?: Maybe<MyAccountPaymentSessionCreateResponse>;
  createFromPreparedPayment?: Maybe<MyAccountPaymentSessionCreateResponse>;
  generateReceipt?: Maybe<MyAccountPaymentSessionGenerateReceiptResponse>;
  guaranteeOrderPayment?: Maybe<MyAccountPaymentSessionCreateResponse>;
  refresh?: Maybe<MyAccountPaymentSessionRefreshResponse>;
  updatePaymentMethod?: Maybe<MyAccountPaymentSessionUpdatePaymentMethodResponse>;
};


export type MyAccountPaymentSessionMutationsCaptureGuaranteeArgs = {
  data: MyAccountPaymentSessionCaptureGuaranteeInput;
};


export type MyAccountPaymentSessionMutationsCreateForInvoicesArgs = {
  data: MyAccountPaymentSessionCreateForInvoicesInput;
};


export type MyAccountPaymentSessionMutationsCreateFromPreparedPaymentArgs = {
  data: MyAccountPaymentSessionCreateFromPreparedPaymentInput;
};


export type MyAccountPaymentSessionMutationsGenerateReceiptArgs = {
  where: PaymentSessionGenerateReceiptInput;
};


export type MyAccountPaymentSessionMutationsGuaranteeOrderPaymentArgs = {
  data: MyAccountPaymentSessionCreateForOrderGuaranteeInput;
};


export type MyAccountPaymentSessionMutationsRefreshArgs = {
  where: PaymentSessionWhereUniqueInput;
};


export type MyAccountPaymentSessionMutationsUpdatePaymentMethodArgs = {
  data: MyAccountPaymentSessionUpdatePaymentMethodInput;
  where: PaymentSessionWhereUniqueInput;
};

export type MyAccountPaymentSessionRefreshResponse = {
  __typename?: 'MyAccountPaymentSessionRefreshResponse';
  paymentSession: PaymentSession;
};

export type MyAccountPaymentSessionUpdatePaymentMethodInput = {
  paymentMethodId: Scalars['String']['input'];
};

export type MyAccountPaymentSessionUpdatePaymentMethodResponse = {
  __typename?: 'MyAccountPaymentSessionUpdatePaymentMethodResponse';
  paymentSession: PaymentSession;
};

export type MyAccountUpdateDataInput = {
  name: Scalars['String']['input'];
};

export type MyAccountVerifyIdentityDataInput = {
  code: Scalars['String']['input'];
  identity: Scalars['String']['input'];
  type: LinkedAccountIdentityType;
  verificationKey: Scalars['String']['input'];
};

export type MyAccountVerifyIdentityResponse = {
  __typename?: 'MyAccountVerifyIdentityResponse';
  accountIdentity?: Maybe<LinkedAccountIdentity>;
};

export type MyAccountWalletCompletePaymentMethodRequestDataInput = {
  allowOthersToUse?: InputMaybe<Scalars['Boolean']['input']>;
  setupIntentId: Scalars['String']['input'];
};

export type MyAccountWalletCompletePaymentMethodRequestResponse = {
  __typename?: 'MyAccountWalletCompletePaymentMethodRequestResponse';
  /** The method as saved to the customer's wallet */
  paymentMethod: PaymentMethod;
  request: LinkedAccountPaymentMethodRequest;
};

export type MyAccountWalletCompletePaymentMethodRequestWhereInput = {
  id: Scalars['String']['input'];
};

export type MyAccountWalletConfirmSetupIntentDataInput = {
  allowOthersToUse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MyAccountWalletConfirmSetupIntentResponse = {
  __typename?: 'MyAccountWalletConfirmSetupIntentResponse';
  paymentMethod?: Maybe<PaymentMethod>;
  setupIntent: SetupIntent;
};

export type MyAccountWalletConfirmSetupIntentWhereInput = {
  id: Scalars['String']['input'];
};

export type MyAccountWalletCreateSetupIntentInput = {
  /** Scope the SetupIntent to a payment method request's customer config; requires its short-link grant */
  paymentMethodRequestId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodTypes?: InputMaybe<Array<PaymentMethodType>>;
  paymentSessionId?: InputMaybe<Scalars['String']['input']>;
};

export type MyAccountWalletCreateSetupIntentResponse = {
  __typename?: 'MyAccountWalletCreateSetupIntentResponse';
  setupIntent: SetupIntent;
};

export type MyAccountWalletMutations = {
  __typename?: 'MyAccountWalletMutations';
  completePaymentMethodRequest?: Maybe<MyAccountWalletCompletePaymentMethodRequestResponse>;
  confirmSetupIntent?: Maybe<MyAccountWalletConfirmSetupIntentResponse>;
  createSetupIntent?: Maybe<MyAccountWalletCreateSetupIntentResponse>;
};


export type MyAccountWalletMutationsCompletePaymentMethodRequestArgs = {
  data: MyAccountWalletCompletePaymentMethodRequestDataInput;
  where: MyAccountWalletCompletePaymentMethodRequestWhereInput;
};


export type MyAccountWalletMutationsConfirmSetupIntentArgs = {
  data?: InputMaybe<MyAccountWalletConfirmSetupIntentDataInput>;
  where: MyAccountWalletConfirmSetupIntentWhereInput;
};


export type MyAccountWalletMutationsCreateSetupIntentArgs = {
  data?: InputMaybe<MyAccountWalletCreateSetupIntentInput>;
};

export type NavigableAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type NestedEnumEquipmentAvailabilityStatusFilter = {
  equals?: InputMaybe<EquipmentAvailabilityStatus>;
  in?: InputMaybe<Array<EquipmentAvailabilityStatus>>;
  not?: InputMaybe<NestedEnumEquipmentAvailabilityStatusFilter>;
  notIn?: InputMaybe<Array<EquipmentAvailabilityStatus>>;
};

export type NestedEnumPersonAvailabilityStatusFilter = {
  equals?: InputMaybe<PersonAvailabilityStatus>;
  in?: InputMaybe<Array<PersonAvailabilityStatus>>;
  not?: InputMaybe<NestedEnumPersonAvailabilityStatusFilter>;
  notIn?: InputMaybe<Array<PersonAvailabilityStatus>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NetsuiteCertificate = {
  __typename?: 'NetsuiteCertificate';
  accountId: Scalars['String']['output'];
  certificatePem: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
};

export type NetsuiteConnection = {
  __typename?: 'NetsuiteConnection';
  accountId: Scalars['String']['output'];
  certificateExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  certificateId?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  connected: Scalars['Boolean']['output'];
  pendingCertificateExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  pendingCertificatePem?: Maybe<Scalars['String']['output']>;
  subsidiaryChoices?: Maybe<Array<GlDimension>>;
  subsidiaryId?: Maybe<Scalars['String']['output']>;
  subsidiaryName?: Maybe<Scalars['String']['output']>;
};

export type NonDigitalFullRefundInput = {
  paymentId: Scalars['String']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  refundDate?: InputMaybe<Scalars['DateLike']['input']>;
  refundTypeId: Scalars['Int']['input'];
};

export type Note = {
  __typename?: 'Note';
  active: Scalars['Boolean']['output'];
  additionalIds?: Maybe<Array<KeyValue>>;
  comments: Array<Comment>;
  contact?: Maybe<Contact>;
  contactId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['Int']['output']>;
  equipment?: Maybe<Equipment>;
  equipmentId?: Maybe<Scalars['Int']['output']>;
  event?: Maybe<Event>;
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type NoteInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  comments?: InputMaybe<CommentsInput>;
  contactId?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  equipmentId?: InputMaybe<Scalars['Int']['input']>;
  event?: InputMaybe<EventInput>;
  title: Scalars['String']['input'];
};

export type NoteUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  comments?: InputMaybe<CommentsInput>;
  contactId?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  equipmentId?: InputMaybe<Scalars['Int']['input']>;
  event?: InputMaybe<EventInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NoteWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type NotificationMutations = {
  __typename?: 'NotificationMutations';
  trigger: NotificationMutationsTriggerResponse;
};


export type NotificationMutationsTriggerArgs = {
  input: NotificationTrigger;
};

export type NotificationMutationsTriggerResponse = {
  __typename?: 'NotificationMutationsTriggerResponse';
  ok: Scalars['Boolean']['output'];
};

export type NotificationRuleConfig = {
  __typename?: 'NotificationRuleConfig';
  createdAt: Scalars['DateTime']['output'];
  defaultEnabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  params?: Maybe<Scalars['Json']['output']>;
  ruleSlug: NotificationRuleSlug;
  updatedAt: Scalars['DateTime']['output'];
};

export type NotificationRuleOverride = {
  __typename?: 'NotificationRuleOverride';
  contactId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerId?: Maybe<Scalars['Int']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  params?: Maybe<Scalars['Json']['output']>;
  ruleSlug: NotificationRuleSlug;
  updatedAt: Scalars['DateTime']['output'];
};

export enum NotificationRuleSlug {
  EarlyConfirmation = 'early_confirmation',
  PostPourVerification = 'post_pour_verification',
  PreWorkAuthorization = 'pre_work_authorization',
  UnconfirmedReminder = 'unconfirmed_reminder'
}

export type NotificationTrigger = {
  orderId: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type NotifyAssignmentInput = {
  id: Scalars['Int']['input'];
};

export type Operator = PersonInterface & {
  __typename?: 'Operator';
  active: Scalars['Boolean']['output'];
  additionalIds?: Maybe<Array<KeyValue>>;
  appFeatures: AppFeatures;
  assignments: Array<Assignment>;
  availabilities: Array<OperatorAvailability>;
  availability?: Maybe<OperatorAvailability>;
  branches: Array<Branch>;
  changelog?: Maybe<Changelog>;
  createdAt: Scalars['DateTime']['output'];
  credentials: Array<Credential>;
  emails: Array<Scalars['String']['output']>;
  equipment: Array<Equipment>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** A single feature flag; null for keys not in the flag registry. */
  flag?: Maybe<Scalars['Boolean']['output']>;
  /** Viewer-scoped feature flags: the tenant bag with registry defaults applied for unset keys, plus viewer overlays. */
  flags: Scalars['Json']['output'];
  id: Scalars['Int']['output'];
  integrations?: Maybe<OperatorIntegrations>;
  lastName?: Maybe<Scalars['String']['output']>;
  messages: Array<Message>;
  organization: Organization;
  phones: Array<Phone>;
  preferences: OperatorPreferences;
  timeClock?: Maybe<TimeClock>;
  timeSheet?: Maybe<TimeSheet>;
  updatedAt: Scalars['DateTime']['output'];
};


export type OperatorAssignmentsArgs = {
  orderBy?: InputMaybe<Array<OperatorAssignmentsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OperatorAssignmentsWhereInput>;
};


export type OperatorCredentialsArgs = {
  orderBy?: InputMaybe<Array<OperatorCredentialsOrderByInput>>;
  where?: InputMaybe<OperatorCredentialsWhereInput>;
};


export type OperatorFlagArgs = {
  key: Scalars['String']['input'];
};


export type OperatorTimeSheetArgs = {
  includeVoided?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PersonTimeSheetWhereInput>;
};

export type OperatorAssignmentsOrderByInput = {
  id?: InputMaybe<SortOrder>;
};

export type OperatorAssignmentsWhereInput = {
  active?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  visible?: InputMaybe<BoolFilter>;
};

export type OperatorAvailability = PersonAvailability & {
  __typename?: 'OperatorAvailability';
  additionalInfo?: Maybe<Array<KeyValue>>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  locations: Array<PersonAvailabilityLocation>;
  note?: Maybe<Scalars['String']['output']>;
  operator: Operator;
  person: Person;
  personId: Scalars['Int']['output'];
  status: PersonAvailabilityStatus;
  updatedAt: Scalars['DateTime']['output'];
  validFrom: Scalars['DateTime']['output'];
  validTo?: Maybe<Scalars['DateTime']['output']>;
};

export type OperatorCancelAvailabilityDataInput = {
  /** Indicates what timeslot will merge with the gap being created by canceling the person schedule */
  fillGap: OperatorCancelAvailabilityFillGapEnum;
};

export enum OperatorCancelAvailabilityFillGapEnum {
  Next = 'next',
  Previous = 'previous'
}

export type OperatorCancelAvailabilityResponse = {
  __typename?: 'OperatorCancelAvailabilityResponse';
  deleted: OperatorAvailability;
  updated?: Maybe<OperatorAvailability>;
};

export type OperatorCancelAvailabilityWhereInput = {
  id: Scalars['Int']['input'];
};

export type OperatorCredentialsOrderByInput = {
  expirationDate?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
};

export type OperatorCredentialsWhereInput = {
  active?: InputMaybe<BoolFilter>;
  expirationDate?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
};

export type OperatorInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  branchIds?: InputMaybe<IntArrayInput>;
  credentials?: InputMaybe<CredentialsInput>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<OperatorScheduleLocationInput>>;
  phones?: InputMaybe<Array<PhoneInput>>;
};

export type OperatorIntegrations = {
  __typename?: 'OperatorIntegrations';
  all: Array<KeyValue>;
  paylocity?: Maybe<OperatorPaylocityIntegration>;
  samsara?: Maybe<OperatorSamsaraIntegration>;
};

export type OperatorMutations = {
  __typename?: 'OperatorMutations';
  cancelAvailability: OperatorCancelAvailabilityResponse;
  inviteToCrewApp?: Maybe<Message>;
  scheduleAvailability: OperatorScheduleAvailabilityResponse;
};


export type OperatorMutationsCancelAvailabilityArgs = {
  data: OperatorCancelAvailabilityDataInput;
  where: OperatorCancelAvailabilityWhereInput;
};


export type OperatorMutationsInviteToCrewAppArgs = {
  where: OperatorWhereUniqueInput;
};


export type OperatorMutationsScheduleAvailabilityArgs = {
  data: OperatorScheduleAvailabilityDataInput;
  where: OperatorScheduleAvailabilityWhereInput;
};

export type OperatorPaylocityIntegration = {
  __typename?: 'OperatorPaylocityIntegration';
  employee?: Maybe<PaylocityEmployee>;
};

export type OperatorPreferences = {
  __typename?: 'OperatorPreferences';
  messages: Array<MessagePreference>;
};

export type OperatorSamsaraIntegration = {
  __typename?: 'OperatorSamsaraIntegration';
  driver?: Maybe<SamsaraDriver>;
};

export type OperatorScheduleAvailabilityDataInput = {
  locations: Array<OperatorScheduleLocationInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  selectedTimezone: Scalars['String']['input'];
  status: PersonAvailabilityStatus;
  validFrom: Scalars['DateTime']['input'];
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OperatorScheduleAvailabilityResponse = {
  __typename?: 'OperatorScheduleAvailabilityResponse';
  operatorAvailability: Array<OperatorAvailability>;
};

export type OperatorScheduleAvailabilityWhereInput = {
  operatorId: Scalars['Int']['input'];
};

export type OperatorScheduleLocationInput = {
  branchId: Scalars['Int']['input'];
  yardIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type OperatorUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  branchIds?: InputMaybe<IntArrayInput>;
  credentials?: InputMaybe<CredentialsInput>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<OperatorScheduleLocationInput>>;
  phones?: InputMaybe<Array<PhoneInput>>;
};

export type OperatorWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type Order = {
  __typename?: 'Order';
  active: Scalars['Boolean']['output'];
  activities: Array<OrderActivity>;
  actuals: Array<OrderDetails>;
  additionalIds?: Maybe<Array<KeyValue>>;
  appliesToPowerLineSafety: Scalars['Boolean']['output'];
  approximateTime: Scalars['Boolean']['output'];
  assignments?: Maybe<Array<Assignment>>;
  billable?: Maybe<OrderDetails>;
  bookingFeeDisclaimer?: Maybe<Scalars['String']['output']>;
  branch?: Maybe<Branch>;
  branchId?: Maybe<Scalars['Int']['output']>;
  bulletinToCustomer?: Maybe<Scalars['String']['output']>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancellationReasonDetails?: Maybe<OrderCancellationReason>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  cashOnDelivery: Scalars['Boolean']['output'];
  changelog?: Maybe<Changelog>;
  comments: Array<Comment>;
  commentsCount: Scalars['Int']['output'];
  /** Indicates whether the order can be confirmed by the contact */
  confirmable: Scalars['Boolean']['output'];
  contacts: Array<OrderContact>;
  createdAt: Scalars['DateTime']['output'];
  crewAddendumMarkdown?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['Int']['output']>;
  dateOfService?: Maybe<Scalars['DateTime']['output']>;
  dateOfServiceLocal?: Maybe<Scalars['DateTime']['output']>;
  /** Indicates whether the order can be edited by the contact */
  editableByContact: Scalars['Boolean']['output'];
  estimatedRevenue?: Maybe<Scalars['Decimal']['output']>;
  flatRate: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  integrations?: Maybe<OrderIntegrations>;
  invoice?: Maybe<Invoice>;
  /** @deprecated use service instead */
  invoiceTemplate?: Maybe<Service>;
  /** @deprecated use serviceId instead */
  invoiceTemplateId?: Maybe<Scalars['Int']['output']>;
  linesOnSite: Scalars['Boolean']['output'];
  messages: Array<Message>;
  missingDetails: OrderMissingDetails;
  name: Scalars['String']['output'];
  originalDateOfService?: Maybe<Scalars['DateTime']['output']>;
  payment: OrderPayment;
  photos: Array<OrderPhoto>;
  planned?: Maybe<OrderDetails>;
  powerLineAck?: Maybe<Scalars['Boolean']['output']>;
  powerLineAckedAt?: Maybe<Scalars['DateTime']['output']>;
  powerLineAckedByContactId?: Maybe<Scalars['Int']['output']>;
  powerLineReportedAt?: Maybe<Scalars['DateTime']['output']>;
  powerLineSource?: Maybe<PowerLineSource>;
  purchaseOrder?: Maybe<Scalars['String']['output']>;
  requiresPowerLineReport: Scalars['Boolean']['output'];
  restrictions?: Maybe<OrderRestrictions>;
  revision: Scalars['Int']['output'];
  route?: Maybe<Route>;
  routeWaypoint?: Maybe<RouteWaypoint>;
  routeWaypointId?: Maybe<Scalars['Int']['output']>;
  service?: Maybe<Service>;
  /** @deprecated use service instead */
  serviceCategory?: Maybe<Service>;
  /** @deprecated use serviceId instead */
  serviceCategoryId?: Maybe<Scalars['Int']['output']>;
  serviceId?: Maybe<Scalars['Int']['output']>;
  signature?: Maybe<Signature>;
  signatureId?: Maybe<Scalars['Int']['output']>;
  /** Per-purpose signature status for this order, derived from its OrderSignature rows */
  signatures: Array<OrderSignatureStatus>;
  site?: Maybe<Site>;
  siteId?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  statusDetails: OrderStatus;
  subbingDetails?: Maybe<OrderSubDetail>;
  supplier?: Maybe<Supplier>;
  supplierId?: Maybe<Scalars['Int']['output']>;
  tags: Array<Tag>;
  terms: OrderTerms;
  tid: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type OrderMessagesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderActivity = {
  __typename?: 'OrderActivity';
  by: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type OrderActualsInput = {
  upsert?: InputMaybe<Array<OrderActualsUpsertInput>>;
};

export type OrderActualsUpsertInput = {
  data: OrderDetailsUpsertInput;
  where?: InputMaybe<OrderActualsWhereUniqueInput>;
};

export type OrderActualsWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  subType?: InputMaybe<Scalars['String']['input']>;
};

export type OrderAttachPaymentMethodInput = {
  allowOthersToUse?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethodId: Scalars['String']['input'];
};

export type OrderAttachPaymentMethodResponse = {
  __typename?: 'OrderAttachPaymentMethodResponse';
  order: Order;
  paymentMethod: PaymentMethod;
};

export type OrderCancellationReason = {
  __typename?: 'OrderCancellationReason';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderContact = {
  __typename?: 'OrderContact';
  contact: Contact;
  contactId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  default: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  role?: Maybe<ContactRole>;
  roleId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderContactInput = {
  contactId: Scalars['Int']['input'];
  default?: InputMaybe<Scalars['Boolean']['input']>;
  roleId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderContactsInput = {
  set?: InputMaybe<Array<OrderContactInput>>;
};

export type OrderCreateInput = {
  actuals?: InputMaybe<OrderActualsInput>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  approximateTime?: InputMaybe<Scalars['Boolean']['input']>;
  billable?: InputMaybe<OrderDetailsUpsertInput>;
  branchId?: InputMaybe<Scalars['Int']['input']>;
  bulletinToCustomer?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  cashOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  comments?: InputMaybe<CommentsInput>;
  contacts?: InputMaybe<OrderContactsInput>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  flatRate?: InputMaybe<Scalars['Boolean']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  invoiceTemplateId?: InputMaybe<Scalars['Int']['input']>;
  linesOnSite?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  planned?: InputMaybe<OrderDetailsUpsertInput>;
  powerLineAck?: InputMaybe<Scalars['Boolean']['input']>;
  powerLineAckedAt?: InputMaybe<Scalars['DateTime']['input']>;
  powerLineAckedByContactId?: InputMaybe<Scalars['Int']['input']>;
  powerLineReportedAt?: InputMaybe<Scalars['DateTime']['input']>;
  powerLineSource?: InputMaybe<PowerLineSource>;
  purchaseOrder?: InputMaybe<Scalars['String']['input']>;
  restrictions?: InputMaybe<OrderRestrictionsInput>;
  route?: InputMaybe<OrderRouteInput>;
  serviceCategoryId?: InputMaybe<Scalars['Int']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
  signatureId?: InputMaybe<Scalars['Int']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  status: Scalars['String']['input'];
  supplierId?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<TagsInput>;
};

export type OrderDetails = {
  __typename?: 'OrderDetails';
  createdAt: Scalars['DateTime']['output'];
  equipment?: Maybe<Equipment>;
  equipmentId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  inventory: Array<OrderInventoryItem>;
  metrics: Array<OrderMetric>;
  schedule: Array<OrderScheduleEntry>;
  subType?: Maybe<Scalars['String']['output']>;
  type: OrderDetailsType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum OrderDetailsType {
  Actual = 'actual',
  Billable = 'billable',
  Planned = 'planned'
}

export type OrderDetailsUpsertInput = {
  equipmentId?: InputMaybe<Scalars['Int']['input']>;
  inventory?: InputMaybe<OrderInventoryInput>;
  metrics?: InputMaybe<OrderMetricsInput>;
  schedule?: InputMaybe<OrderScheduleInput>;
};

export type OrderIntegrations = {
  __typename?: 'OrderIntegrations';
  quickbooks?: Maybe<OrderQuickbooksIntegration>;
};

export type OrderInventoryInput = {
  set?: InputMaybe<Array<OrderInventoryItemInput>>;
};

export type OrderInventoryItem = {
  __typename?: 'OrderInventoryItem';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  item: InventoryItem;
  itemId: Scalars['Int']['output'];
  orderDetails: OrderDetails;
  orderDetailsId: Scalars['Int']['output'];
  quantity?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderInventoryItemInput = {
  itemId: Scalars['Int']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type OrderMetric = {
  __typename?: 'OrderMetric';
  createdAt: Scalars['DateTime']['output'];
  key: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['MetricValue']['output']>;
  valueFloat?: Maybe<Scalars['Float']['output']>;
  valueString?: Maybe<Scalars['String']['output']>;
};

export type OrderMetricInput = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['MetricValue']['input']>;
};

export type OrderMetricsInput = {
  upsert?: InputMaybe<Array<OrderMetricInput>>;
};

export type OrderMissingDetails = {
  __typename?: 'OrderMissingDetails';
  purchaseOrder: Scalars['Boolean']['output'];
  siteLocation: Scalars['Boolean']['output'];
};

export type OrderPayment = {
  __typename?: 'OrderPayment';
  currency: Scalars['String']['output'];
  defaultPaymentMethod?: Maybe<PaymentMethod>;
  preAuthAmount: Scalars['Decimal']['output'];
  requirements: OrderPaymentRequirements;
  /** Whether the `confirmed` requirement is already satisfied, so confirming the order needs no payment step. `onFile` is met by a payment method attached to the order or, on csPayments tenants, by a chargeable payment method in the customer wallet. `preAuth` is met once the order holds an authorization (an `onHold` payment session). */
  requirementsMet: Scalars['Boolean']['output'];
  sessions: Array<PaymentSession>;
  /** Computed status from the payment sessions */
  status?: Maybe<PaymentSessionStatus>;
};

export type OrderPaymentRequirement = {
  __typename?: 'OrderPaymentRequirement';
  requires: OrderPaymentRequires;
};

export type OrderPaymentRequirementInput = {
  requires: OrderPaymentRequires;
};

export type OrderPaymentRequirements = {
  __typename?: 'OrderPaymentRequirements';
  confirmed?: Maybe<OrderPaymentRequirement>;
};

export type OrderPaymentRequirementsInput = {
  confirmed?: InputMaybe<OrderPaymentRequirementInput>;
};

export enum OrderPaymentRequires {
  None = 'none',
  OnFile = 'onFile',
  PreAuth = 'preAuth'
}

export type OrderPhoto = {
  __typename?: 'OrderPhoto';
  clientId: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  downloadUrl: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  sizeBytes?: Maybe<Scalars['Int']['output']>;
  takenAt?: Maybe<Scalars['DateTime']['output']>;
  thumbUrl: Scalars['String']['output'];
  uploadedById?: Maybe<Scalars['Int']['output']>;
  uploadedByName?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type OrderPhotoCreateInput = {
  clientId: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Int']['input']>;
  takenAt?: InputMaybe<Scalars['DateTime']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderPhotoMutations = {
  __typename?: 'OrderPhotoMutations';
  create: OrderPhoto;
  presignUpload: OrderPhotoPresignResponse;
};


export type OrderPhotoMutationsCreateArgs = {
  data: OrderPhotoCreateInput;
  where: OrderWhereUniqueInput;
};


export type OrderPhotoMutationsPresignUploadArgs = {
  data: OrderPhotoPresignInput;
  where: OrderWhereUniqueInput;
};

export type OrderPhotoPresignInput = {
  clientId: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
};

export type OrderPhotoPresignResponse = {
  __typename?: 'OrderPhotoPresignResponse';
  photoUploadUrl: Scalars['String']['output'];
  thumbUploadUrl: Scalars['String']['output'];
};

export type OrderPour = {
  __typename?: 'OrderPour';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PourType>;
  typeId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderPourInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderQuickbooksIntegration = {
  __typename?: 'OrderQuickbooksIntegration';
  invoice?: Maybe<QuickbooksInvoice>;
};

export type OrderRestrictions = {
  __typename?: 'OrderRestrictions';
  maxSize?: Maybe<Scalars['Float']['output']>;
  minSize?: Maybe<Scalars['Float']['output']>;
};

export type OrderRestrictionsInput = {
  maxSize?: InputMaybe<Scalars['Float']['input']>;
  minSize?: InputMaybe<Scalars['Float']['input']>;
};

export type OrderRouteConnectInput = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  ignoreOverlaps?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderRouteInput = {
  connect?: InputMaybe<OrderRouteConnectInput>;
  create?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Keep a schedule change that overlaps another order on the same route ("Keep Conflict"). Only read when the order stays on its current route. */
  ignoreOverlaps?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderScheduleEntry = {
  __typename?: 'OrderScheduleEntry';
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Duration of this step in seconds */
  duration?: Maybe<Scalars['Int']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  endTimezone?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  metrics: Array<OrderMetric>;
  orderDetails: OrderDetails;
  orderDetailsId: Scalars['Int']['output'];
  pour?: Maybe<OrderPour>;
  scheduleIndex: Scalars['Int']['output'];
  startTime?: Maybe<Scalars['DateTime']['output']>;
  startTimezone?: Maybe<Scalars['String']['output']>;
  step: Scalars['String']['output'];
  stepDetails: ScheduleStep;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderScheduleEntryInput = {
  address?: InputMaybe<AddressInput>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  metrics?: InputMaybe<OrderMetricsInput>;
  pour?: InputMaybe<OrderPourInput>;
  scheduleIndex?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  step?: InputMaybe<Scalars['String']['input']>;
};

export type OrderScheduleInput = {
  /** Replace all OrderScheduleEntries with list provided here. */
  set?: InputMaybe<Array<OrderScheduleUpsertInput>>;
};

export type OrderScheduleUpsertInput = {
  data: OrderScheduleEntryInput;
  where?: InputMaybe<OrderScheduleWhereUniqueInput>;
};

export type OrderScheduleWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderSettings = {
  __typename?: 'OrderSettings';
  requirePurchaseOrder: Scalars['Boolean']['output'];
};

export type OrderSettingsInput = {
  requirePurchaseOrder?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderSharing = {
  __typename?: 'OrderSharing';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  sharedBy: LinkedAccount;
  sharedById: Scalars['Int']['output'];
  sharedWith: LinkedAccount;
  sharedWithId: Scalars['Int']['output'];
  type: SharingType;
};

export type OrderSharingMutations = {
  __typename?: 'OrderSharingMutations';
  requestAccessToAll?: Maybe<RequestAccessToAllResponse>;
  respondToSharingRequest?: Maybe<RespondToSharingRequestResponse>;
  revokeAccessToAll?: Maybe<RevokeAccessToAllResponse>;
  shareAccessToAll?: Maybe<ShareAccessToAllResponse>;
  withdrawnSharingRequest?: Maybe<WithdrawnSharingRequestResponse>;
};


export type OrderSharingMutationsRequestAccessToAllArgs = {
  data: RequestAccessToAllInput;
};


export type OrderSharingMutationsRespondToSharingRequestArgs = {
  data: RespondToSharingRequestInput;
};


export type OrderSharingMutationsRevokeAccessToAllArgs = {
  data: RevokeAccessToAllInput;
};


export type OrderSharingMutationsShareAccessToAllArgs = {
  data: ShareAccessToAllInput;
};


export type OrderSharingMutationsWithdrawnSharingRequestArgs = {
  data: WithdrawnSharingRequestInput;
};

export type OrderSharingRequest = {
  __typename?: 'OrderSharingRequest';
  createdAt: Scalars['DateTime']['output'];
  direction: SharingDirection;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  requestedBy: LinkedAccount;
  requestedById: Scalars['Int']['output'];
  requestedTo: LinkedAccount;
  requestedToId: Scalars['Int']['output'];
  respondedAt?: Maybe<Scalars['DateTime']['output']>;
  status: SharingRequestStatus;
};

export type OrderSharingRequestDetailsInput = {
  id: Scalars['Int']['input'];
};

export enum OrderSharingRequestStatusEnum {
  Accepted = 'accepted',
  Rejected = 'rejected'
}

/** Purpose a signature was collected for against an order. */
export enum OrderSignaturePurpose {
  OrderConfirmation = 'order_confirmation',
  PostPourVerification = 'post_pour_verification',
  PreWorkAuthorization = 'pre_work_authorization',
  WorkTicket = 'work_ticket'
}

export type OrderSignatureStatus = {
  __typename?: 'OrderSignatureStatus';
  purpose: OrderSignaturePurpose;
  required: Scalars['Boolean']['output'];
  /** Full Signature row backing this purpose (image, signer person, metadata), or null when unsigned */
  signature?: Maybe<Signature>;
  signed: Scalars['Boolean']['output'];
};

export type OrderSiteInput = {
  address: AddressInput;
  status: SiteStatus;
};

export type OrderStatus = {
  __typename?: 'OrderStatus';
  active: Scalars['Boolean']['output'];
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderSubDetail = {
  __typename?: 'OrderSubDetail';
  request: SubRequest;
};

export type OrderTerms = {
  __typename?: 'OrderTerms';
  accepted: Scalars['Boolean']['output'];
  content: Terms;
  id: Scalars['Int']['output'];
  needsAcceptance: Scalars['Boolean']['output'];
  signatures: Array<Signature>;
};

export type OrderUpdateInput = {
  actuals?: InputMaybe<OrderActualsInput>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  approximateTime?: InputMaybe<Scalars['Boolean']['input']>;
  billable?: InputMaybe<OrderDetailsUpsertInput>;
  branchId?: InputMaybe<Scalars['Int']['input']>;
  bulletinToCustomer?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  cashOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  comments?: InputMaybe<CommentsInput>;
  contacts?: InputMaybe<OrderContactsInput>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  flatRate?: InputMaybe<Scalars['Boolean']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  invoiceTemplateId?: InputMaybe<Scalars['Int']['input']>;
  linesOnSite?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  planned?: InputMaybe<OrderDetailsUpsertInput>;
  powerLineAck?: InputMaybe<Scalars['Boolean']['input']>;
  powerLineAckedAt?: InputMaybe<Scalars['DateTime']['input']>;
  powerLineAckedByContactId?: InputMaybe<Scalars['Int']['input']>;
  powerLineReportedAt?: InputMaybe<Scalars['DateTime']['input']>;
  powerLineSource?: InputMaybe<PowerLineSource>;
  purchaseOrder?: InputMaybe<Scalars['String']['input']>;
  restrictions?: InputMaybe<OrderRestrictionsInput>;
  revision: Scalars['Int']['input'];
  route?: InputMaybe<OrderRouteInput>;
  serviceCategoryId?: InputMaybe<Scalars['Int']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
  signatureId?: InputMaybe<Scalars['Int']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<TagsInput>;
};

export type OrderWhereUniqueInput = {
  id: Scalars['Int']['input'];
  revision?: InputMaybe<Scalars['Int']['input']>;
};

export type OrdersFitCheck = {
  __typename?: 'OrdersFitCheck';
  results?: Maybe<Array<OrdersFitCheckResult>>;
  routeTimeline: Array<RouteTimelineItem>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OrdersFitCheckResult = {
  __typename?: 'OrdersFitCheckResult';
  incomingTravelDuration?: Maybe<Scalars['Int']['output']>;
  invalidCode?: Maybe<Scalars['String']['output']>;
  invalidDuration?: Maybe<Scalars['Int']['output']>;
  invalidReason?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  outgoingTravelDuration?: Maybe<Scalars['Int']['output']>;
  overlappedWithOrderId?: Maybe<Scalars['Int']['output']>;
};

export type OrgConfigCrew = {
  __typename?: 'OrgConfigCrew';
  /** Hide assignment details until the operator acknowledges it. */
  assignmentHideDetailsTillAck: Scalars['Boolean']['output'];
  /** Seconds after which crew must report on an active assignment. */
  assignmentReportAtDuration: Scalars['Int']['output'];
  /** Allow operators to cancel orders from the crew app. */
  orderAllowOperatorToCancel: Scalars['Boolean']['output'];
  /** Require a signature on work tickets in the crew app. */
  workTicketRequireSignature: Scalars['Boolean']['output'];
};

export type OrgConfigCustomerApp = {
  __typename?: 'OrgConfigCustomerApp';
  /** Hide operator contact info from customers. */
  hideOperatorContactInfo: Scalars['Boolean']['output'];
  /** Request pre-work authorization from customers. */
  requestPreWorkAuthorization: Scalars['Boolean']['output'];
  /** Request a work-ticket signature from customers. */
  requestWorkTicketSignature: Scalars['Boolean']['output'];
};

export type OrgConfigEmail = {
  __typename?: 'OrgConfigEmail';
  /** Omit the PDF attachment from invoice emails. */
  disableInvoicePdf: Scalars['Boolean']['output'];
};

export type OrgConfigIntegrations = {
  __typename?: 'OrgConfigIntegrations';
  /** The aircall integration is configured (computed presence — never stored). */
  aircall: Scalars['Boolean']['output'];
  /** The geotab integration is configured (computed presence — never stored). */
  geotab: Scalars['Boolean']['output'];
  /** The paylocity integration is configured (computed presence — never stored). */
  paylocity: Scalars['Boolean']['output'];
  /** The quickbooks integration is configured (computed presence — never stored). */
  quickbooks: Scalars['Boolean']['output'];
  /** The samsara integration is configured (computed presence — never stored). */
  samsara: Scalars['Boolean']['output'];
};

export type OrgConfigInvoicing = {
  __typename?: 'OrgConfigInvoicing';
  /** V2 invoice workflow. Plain column: materialized once by the backfill (explicit-or-payments.csPayments) and support-portal-owned thereafter — it no longer tracks payments.csPayments. */
  newWorkflow: Scalars['Boolean']['output'];
  /** Invoice versioning workflow (formerly invoicing_version_enabled). */
  versioning: Scalars['Boolean']['output'];
};

export type OrgConfigLocalization = {
  __typename?: 'OrgConfigLocalization';
  /** ISO country code biasing geocoder results. */
  geocoderCountry: Scalars['String']['output'];
  /** Display and compute volumes in cubic meters instead of cubic yards. */
  useCubicMeters: Scalars['Boolean']['output'];
};

export type OrgConfigModules = {
  __typename?: 'OrgConfigModules';
  /** Timeclocks module (merged dashboard timeclocks_enabled + crew timeclocksEnabled). */
  timeclocks: Scalars['Boolean']['output'];
};

export type OrgConfigOrder = {
  __typename?: 'OrgConfigOrder';
  /** Seconds of prep time prefilled on new orders when the equipment has none. */
  defaultPrepTime: Scalars['Int']['output'];
  /** Default new orders to planned-travel timing. */
  defaultToPlannedTravel: Scalars['Boolean']['output'];
  /** Allow customer contacts to edit orders after confirmation. */
  editableByContactIfConfirmed: Scalars['Boolean']['output'];
  /** Surface distance review when scheduling orders. */
  reviewDistance: Scalars['Boolean']['output'];
};

export type OrgConfigOrderInput = {
  /** Seconds of prep time prefilled on new orders when the equipment has none. */
  defaultPrepTime?: InputMaybe<Scalars['Int']['input']>;
};

export type OrgConfigPayments = {
  __typename?: 'OrgConfigPayments';
  /** CreteSuite native payments (formerly cs-payments.enabled / native_payments_enabled). */
  csPayments: Scalars['Boolean']['output'];
  /** Show the payments surface in the dashboard. */
  enabled: Scalars['Boolean']['output'];
};

export type OrgConfigSalesTax = {
  __typename?: 'OrgConfigSalesTax';
  /** Sales-tax calculation on invoices and orders. */
  enabled: Scalars['Boolean']['output'];
};

export type OrgConfigSchedule = {
  __typename?: 'OrgConfigSchedule';
  /** Enable subbing orders out to other branches. */
  orderSubbing: Scalars['Boolean']['output'];
};

export type OrgConfigSite = {
  __typename?: 'OrgConfigSite';
  /** Show the job-ID field on sites. */
  jobId: Scalars['Boolean']['output'];
  /** Warn when a site cross-references another at an unsafe distance. */
  unsafeCrossReferenceDistance: Scalars['Boolean']['output'];
};

export type OrgConfigTerms = {
  __typename?: 'OrgConfigTerms';
  /** Always require a signature on terms, regardless of order state. */
  signatureAlwaysRequire: Scalars['Boolean']['output'];
};

export type OrgConfigWorkTicket = {
  __typename?: 'OrgConfigWorkTicket';
  /** Use the expanded work-ticket layout. */
  expanded: Scalars['Boolean']['output'];
};

export type Organization = {
  __typename?: 'Organization';
  appFeatures: AppFeatures;
  billingProfile?: Maybe<BillingProfile>;
  /** The name for SMS and other casual communications: `shortName` when set, otherwise `name`. Formal documents keep `name`. */
  casualName: Scalars['String']['output'];
  config: OrganizationConfig;
  dashboardPrimaryColor: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isDemo: Scalars['Boolean']['output'];
  /** The newest config version, including one saved but not yet live. For settings editors — everything that CONSUMES config wants `config`. */
  latestConfig: OrganizationConfig;
  logo?: Maybe<Scalars['String']['output']>;
  messaging: Messaging;
  name: Scalars['String']['output'];
  paymentConfig: PaymentConfig;
  phones: Array<Phone>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  subscription: Subscription;
};

export type OrganizationConfig = {
  __typename?: 'OrganizationConfig';
  crew: OrgConfigCrew;
  currencyCode: Scalars['String']['output'];
  customerApp: OrgConfigCustomerApp;
  email: OrgConfigEmail;
  integrations: OrgConfigIntegrations;
  invoicing: OrgConfigInvoicing;
  locale: Scalars['String']['output'];
  localization: OrgConfigLocalization;
  modules: OrgConfigModules;
  order: OrgConfigOrder;
  payments: OrgConfigPayments;
  salesTax: OrgConfigSalesTax;
  schedule: OrgConfigSchedule;
  site: OrgConfigSite;
  terms: OrgConfigTerms;
  workTicket: OrgConfigWorkTicket;
};

export type OrganizationConfigInput = {
  order?: InputMaybe<OrgConfigOrderInput>;
};

export type OrganizationConfigUpdateResult = {
  __typename?: 'OrganizationConfigUpdateResult';
  goLiveAt: Scalars['DateTime']['output'];
  /** Its `config` still reflects the CURRENT version until `goLiveAt`. */
  organization: Organization;
};

export type OrganizationInput = {
  additionalIds?: InputMaybe<KeyValuesInput>;
  billingProfile?: InputMaybe<BillingProfileInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<KeyValuesInput>;
  name: Scalars['String']['input'];
  phones?: InputMaybe<Array<PhoneInput>>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  /** Casual name for SMS and other short communications. Trimmed; blank clears it (falls back to `name`). Max 31 characters. */
  shortName?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};

export type OrganizationUpdateInput = {
  additionalIds?: InputMaybe<KeyValuesInput>;
  billingProfile?: InputMaybe<BillingProfileInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<KeyValuesInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  phones?: InputMaybe<Array<PhoneInput>>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  /** Casual name for SMS and other short communications. Trimmed; blank clears it (falls back to `name`). Max 31 characters. */
  shortName?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type OverlappingWaypoints = {
  __typename?: 'OverlappingWaypoints';
  overlappingDuration: Scalars['Int']['output'];
  waypoints: Array<RouteWaypoint>;
};

export type Paylocity = {
  __typename?: 'Paylocity';
  accessToken?: Maybe<IntegrationToken>;
  employees: Array<PaylocityEmployee>;
  settings?: Maybe<PaylocitySettings>;
};

export type PaylocityEmployee = {
  __typename?: 'PaylocityEmployee';
  active?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PaylocityMutationNamespace = {
  __typename?: 'PaylocityMutationNamespace';
  connect: GenericResponse;
  linkEmployee: Person;
};


export type PaylocityMutationNamespaceConnectArgs = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  companyId?: InputMaybe<Scalars['String']['input']>;
};


export type PaylocityMutationNamespaceLinkEmployeeArgs = {
  employeeId?: InputMaybe<Scalars['String']['input']>;
  person: PersonWhereUniqueInput;
};

export type PaylocitySettings = {
  __typename?: 'PaylocitySettings';
  clientId: Scalars['String']['output'];
  companyId?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
};

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  customer: Customer;
  date: Scalars['Date']['output'];
  distributions: Array<PaymentDistribution>;
  id: Scalars['Int']['output'];
  memo?: Maybe<Scalars['String']['output']>;
  processedDate: Scalars['DateTime']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  type: PaymentType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
};

export type PaymentAllocationInput = {
  amount: Scalars['Decimal']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  feeType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  targetType: AllocationTypeEnum;
};

export type PaymentAllocationSourceDetail = {
  __typename?: 'PaymentAllocationSourceDetail';
  allocationId: Scalars['String']['output'];
  amount: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  paymentId: Scalars['String']['output'];
};

export type PaymentConfig = {
  __typename?: 'PaymentConfig';
  id: Scalars['Int']['output'];
  methodTypes: Array<PaymentConfigMethodType>;
  orderRequirements: OrderPaymentRequirements;
  processingFees: Array<PaymentConfigProcessingFee>;
};

export type PaymentConfigInput = {
  methodTypes?: InputMaybe<Array<PaymentConfigMethodTypeInput>>;
  orderRequirements?: InputMaybe<OrderPaymentRequirementsInput>;
  processingFees?: InputMaybe<Array<PaymentConfigProcessingFeeInput>>;
};

export type PaymentConfigMethodType = {
  __typename?: 'PaymentConfigMethodType';
  type: PaymentMethodType;
};

export type PaymentConfigMethodTypeInput = {
  type: PaymentMethodType;
};

export type PaymentConfigProcessingFee = {
  __typename?: 'PaymentConfigProcessingFee';
  type: ProcessingFeeType;
};

export type PaymentConfigProcessingFeeInput = {
  type: ProcessingFeeType;
};

export type PaymentDepositInfo = {
  __typename?: 'PaymentDepositInfo';
  depositDate: Scalars['Date']['output'];
  depositId: Scalars['String']['output'];
  status: DepositStatus;
};

export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  allocations: Array<PaymentDetailsAllocation>;
  currency: Scalars['String']['output'];
  customer: PaymentDetailsCustomer;
  deposit?: Maybe<PaymentDepositInfo>;
  depositStatus?: Maybe<DepositStatus>;
  hasDispute: Scalars['Boolean']['output'];
  isDigital: Scalars['Boolean']['output'];
  number?: Maybe<Scalars['String']['output']>;
  paymentDate?: Maybe<Scalars['Date']['output']>;
  paymentId: Scalars['String']['output'];
  paymentSource: PaymentDetailsPaymentSource;
  processedDate?: Maybe<Scalars['Date']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  revision: Scalars['Int']['output'];
  status: PaymentStatus;
  timeline: Array<PaymentDetailsTimeline>;
  totalPaymentReceived: Scalars['Decimal']['output'];
  transactionDetails: PaymentDetailsTransactionDetails;
};

export type PaymentDetailsActor = {
  __typename?: 'PaymentDetailsActor';
  guid: Scalars['Int']['output'];
  kind: PaymentDetailsActorKind;
  name?: Maybe<Scalars['String']['output']>;
};

export enum PaymentDetailsActorKind {
  Api = 'api',
  Customer = 'customer',
  System = 'system',
  User = 'user'
}

export type PaymentDetailsAllocation = {
  __typename?: 'PaymentDetailsAllocation';
  currency: Scalars['String']['output'];
  feeIncomeId?: Maybe<Scalars['String']['output']>;
  invoice?: Maybe<PaymentDetailsInvoice>;
  paidAmount: Scalars['Decimal']['output'];
  refund?: Maybe<PaymentDetailsRefund>;
  targetType: Scalars['String']['output'];
};

export type PaymentDetailsCustomer = {
  __typename?: 'PaymentDetailsCustomer';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type PaymentDetailsInvoice = {
  __typename?: 'PaymentDetailsInvoice';
  amountDue: Scalars['Decimal']['output'];
  /** Charges payment sessions already hold against this invoice that its balance does not reflect yet. Editing a payment must cap at balance + its own allocation - this. */
  amountInFlight: Scalars['Decimal']['output'];
  amountPaid: Scalars['Decimal']['output'];
  /** Amount that can be allocated to this invoice right now: its available balance minus in-flight charges not yet reflected in it. 0 for draft/paid/voided invoices; never negative. */
  amountPayable: Scalars['Decimal']['output'];
  balance: Scalars['Decimal']['output'];
  dueDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  number: Scalars['String']['output'];
  purchaseOrder?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type PaymentDetailsPaymentSource = {
  __typename?: 'PaymentDetailsPaymentSource';
  bankLast4?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  cardBrand?: Maybe<Scalars['String']['output']>;
  cardLast4?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  methodType?: Maybe<PaymentMethodType>;
  name: Scalars['String']['output'];
  paymentTypeId: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
};

export type PaymentDetailsRefund = {
  __typename?: 'PaymentDetailsRefund';
  amount: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  method?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  status: RefundStatus;
};

export type PaymentDetailsTimeline = {
  __typename?: 'PaymentDetailsTimeline';
  actor?: Maybe<PaymentDetailsActor>;
  date: Scalars['DateTime']['output'];
  details?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  refundId?: Maybe<Scalars['String']['output']>;
  refundStatus?: Maybe<RefundStatus>;
  revision: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  txId: Scalars['String']['output'];
};

export type PaymentDetailsTransactionDetails = {
  __typename?: 'PaymentDetailsTransactionDetails';
  availableToApply: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  processingFees: Scalars['Decimal']['output'];
  totalReceived: Scalars['Decimal']['output'];
  unappliedAmount: Scalars['Decimal']['output'];
};

export type PaymentDistribution = {
  __typename?: 'PaymentDistribution';
  amount: Scalars['Decimal']['output'];
  invoice: Invoice;
};

export type PaymentFeesSummary = {
  __typename?: 'PaymentFeesSummary';
  amount: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  passToCustomer?: Maybe<Scalars['Boolean']['output']>;
  paymentMethodType: PaymentMethodType;
};

export type PaymentFullRefundInput = {
  /** When true (default), the full refund includes processing fees. Used for non-digital full refunds. */
  includeProcessingFees?: InputMaybe<Scalars['Boolean']['input']>;
  paymentId: Scalars['String']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  /** Required for non-digital full refund. Refund source type (e.g. Cash, Check). */
  refundTypeId?: InputMaybe<Scalars['Int']['input']>;
};

export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  amount: Scalars['Decimal']['output'];
  clientSecret?: Maybe<Scalars['String']['output']>;
  created: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  livemode: Scalars['Boolean']['output'];
  publishableKey: Scalars['String']['output'];
  status: Scalars['String']['output'];
  stripeAccountId: Scalars['String']['output'];
};

export type PaymentListWhereInput = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Show only payments with an outstanding unapplied amount */
  hasUnappliedAmount?: InputMaybe<Scalars['Boolean']['input']>;
  maxAmount?: InputMaybe<Scalars['Decimal']['input']>;
  minAmount?: InputMaybe<Scalars['Decimal']['input']>;
  paymentSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter by partial payment ID, reference, or invoice number */
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  active: Scalars['Boolean']['output'];
  allowOthersToUse: Scalars['Boolean']['output'];
  card?: Maybe<PaymentMethodCardDetails>;
  createdAt: Scalars['DateTime']['output'];
  fingerprint: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isAttachedToCustomer: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  setupStatus: PaymentMethodSetupStatus;
  type: PaymentMethodType;
  updatedAt: Scalars['DateTime']['output'];
  usBankAccount?: Maybe<PaymentMethodUsBankAccountDetails>;
};

export type PaymentMethodCardDetails = {
  __typename?: 'PaymentMethodCardDetails';
  brand: Scalars['String']['output'];
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
  last4: Scalars['String']['output'];
};

export enum PaymentMethodRequestStatus {
  Completed = 'completed',
  Expired = 'expired',
  Open = 'open'
}

export enum PaymentMethodSetupStatus {
  Canceled = 'canceled',
  Processing = 'processing',
  RequiresAction = 'requires_action',
  Succeeded = 'succeeded',
  Unknown = 'unknown'
}

export enum PaymentMethodType {
  Card = 'card',
  UsBankAccount = 'us_bank_account'
}

export type PaymentMethodUsBankAccountDetails = {
  __typename?: 'PaymentMethodUSBankAccountDetails';
  accountType?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
};

export type PaymentMutations = {
  __typename?: 'PaymentMutations';
  createDigitalPayment?: Maybe<GenericResponse>;
  createPayment?: Maybe<GenericResponse>;
  createPreparedPayment?: Maybe<PreparedPayment>;
  editDigitalPayment?: Maybe<GenericResponse>;
  editNonDigitalPayment?: Maybe<GenericResponse>;
  fullRefund?: Maybe<GenericResponse>;
  fullRefundNonDigital?: Maybe<GenericResponse>;
  generatePaymentReceipt: PaymentSessionReceipt;
  receiveInvoicePayment: ReceiveInvoicePaymentResponse;
  refundProcessingFees?: Maybe<GenericResponse>;
  refundUnappliedFunds?: Maybe<GenericResponse>;
  sendPaymentMethodRequest?: Maybe<SendPaymentMethodRequestResponse>;
  sendPaymentReceipt: GenericResponse;
  sendPreparedPaymentByEmail?: Maybe<SendPreparedPaymentResponse>;
  sendPreparedPaymentBySms?: Maybe<SendPreparedPaymentResponse>;
  voidPayment: GenericResponse;
  voidRefund: GenericResponse;
};


export type PaymentMutationsCreateDigitalPaymentArgs = {
  data: CreateDigitalPaymentInput;
};


export type PaymentMutationsCreatePaymentArgs = {
  data: CreatePaymentInput;
};


export type PaymentMutationsCreatePreparedPaymentArgs = {
  data: CreatePreparedPaymentInput;
};


export type PaymentMutationsEditDigitalPaymentArgs = {
  data: EditDigitalPaymentInput;
};


export type PaymentMutationsEditNonDigitalPaymentArgs = {
  data: EditNonDigitalPaymentInput;
};


export type PaymentMutationsFullRefundArgs = {
  data: PaymentFullRefundInput;
};


export type PaymentMutationsFullRefundNonDigitalArgs = {
  data: NonDigitalFullRefundInput;
};


export type PaymentMutationsGeneratePaymentReceiptArgs = {
  data: GeneratePaymentReceiptInput;
};


export type PaymentMutationsReceiveInvoicePaymentArgs = {
  data: ReceivePaymentInput;
};


export type PaymentMutationsRefundProcessingFeesArgs = {
  data: RefundProcessingFeesInput;
};


export type PaymentMutationsRefundUnappliedFundsArgs = {
  data: RefundUnappliedFundsInput;
};


export type PaymentMutationsSendPaymentMethodRequestArgs = {
  data: SendPaymentMethodRequestInput;
};


export type PaymentMutationsSendPaymentReceiptArgs = {
  data: SendPaymentReceiptInput;
};


export type PaymentMutationsSendPreparedPaymentByEmailArgs = {
  data: SendPreparedPaymentByEmailInput;
};


export type PaymentMutationsSendPreparedPaymentBySmsArgs = {
  data: SendPreparedPaymentBySmsInput;
};


export type PaymentMutationsVoidPaymentArgs = {
  data: VoidPaymentInput;
};


export type PaymentMutationsVoidRefundArgs = {
  data: VoidRefundInput;
};

export type PaymentRefundDetails = {
  __typename?: 'PaymentRefundDetails';
  amount: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  paymentNumber: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  refundDate: Scalars['Date']['output'];
  refundId: Scalars['String']['output'];
  refundOption: RefundOption;
  refundProcessingFees: Scalars['Boolean']['output'];
  refundSource: PaymentRefundSource;
  status: RefundStatus;
};

export type PaymentRefundOption = {
  __typename?: 'PaymentRefundOption';
  amount: Scalars['Decimal']['output'];
  available: Scalars['Boolean']['output'];
  option: RefundOption;
};

export type PaymentRefundPreview = {
  __typename?: 'PaymentRefundPreview';
  appliedAmount: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  customer: PaymentDetailsCustomer;
  isDigitalPayment: Scalars['Boolean']['output'];
  paymentId: Scalars['String']['output'];
  paymentMethod?: Maybe<PaymentMethod>;
  paymentNumber: Scalars['String']['output'];
  paymentSource: PaymentDetailsPaymentSource;
  processingFees: Scalars['Decimal']['output'];
  refundOptions: Array<PaymentRefundOption>;
  refundProcessingFees: Scalars['Boolean']['output'];
  refundSources: Array<PaymentRefundSource>;
  status: PaymentStatus;
  totalAvailableForRefund: Scalars['Decimal']['output'];
  totalRefundedAmount: Scalars['Decimal']['output'];
  unappliedAmount: Scalars['Decimal']['output'];
};

export type PaymentRefundSource = {
  __typename?: 'PaymentRefundSource';
  bankLast4?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  cardBrand?: Maybe<Scalars['String']['output']>;
  cardLast4?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isDigital: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
};

export type PaymentSession = {
  __typename?: 'PaymentSession';
  amount: Scalars['Decimal']['output'];
  amountHeld?: Maybe<Scalars['Decimal']['output']>;
  capturedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  fee: Scalars['Decimal']['output'];
  fees: PaymentSessionFees;
  id: Scalars['String']['output'];
  invoices: Array<Invoice>;
  /** Null if the payment does not require pre authorization */
  isExpired?: Maybe<Scalars['Boolean']['output']>;
  paymentIntent?: Maybe<PaymentIntent>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentMethodTypes: Array<PaymentMethodType>;
  paymentMethods: Array<PaymentMethod>;
  status: PaymentSessionStatus;
  subtotal: Scalars['Decimal']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentSessionFees = {
  __typename?: 'PaymentSessionFees';
  current?: Maybe<PaymentFeesSummary>;
  possible: Array<PaymentFeesSummary>;
};

export type PaymentSessionGenerateReceiptInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentSessionReceipt = {
  __typename?: 'PaymentSessionReceipt';
  filename: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum PaymentSessionStatus {
  Cancelled = 'cancelled',
  Failed = 'failed',
  OnHold = 'onHold',
  Pending = 'pending',
  Processing = 'processing',
  Succeeded = 'succeeded'
}

export type PaymentSessionWhereUniqueInput = {
  id: Scalars['String']['input'];
  revision?: InputMaybe<Scalars['Int']['input']>;
};

export type PaymentSource = {
  __typename?: 'PaymentSource';
  category: PaymentSourceCategory;
  id: Scalars['String']['output'];
  isDigital: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  paymentMethod?: Maybe<PaymentMethod>;
  paymentTypeCategory: PaymentTypeCategory;
  sort: Scalars['Int']['output'];
};

export enum PaymentSourceCategory {
  Other = 'other',
  Wallet = 'wallet'
}

export type PaymentSourceDetail = {
  __typename?: 'PaymentSourceDetail';
  amount: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  paymentDate?: Maybe<Scalars['Date']['output']>;
  paymentId: Scalars['String']['output'];
  paymentNumber?: Maybe<Scalars['String']['output']>;
};

export type PaymentSourceWhereInput = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
};

export enum PaymentStatus {
  Failed = 'failed',
  Processing = 'processing',
  Refunded = 'refunded',
  Succeeded = 'succeeded',
  Voided = 'voided'
}

export type PaymentType = {
  __typename?: 'PaymentType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum PaymentTypeCategory {
  BadDebt = 'bad_debt',
  Cash = 'cash',
  Discount = 'discount',
  Memo = 'memo'
}

export type PeggedPriceConfig = {
  __typename?: 'PeggedPriceConfig';
  createdAt: Scalars['DateTime']['output'];
  floor?: Maybe<Scalars['Decimal']['output']>;
  index: PeggedPriceIndex;
  indexId: Scalars['Int']['output'];
  isManual: Scalars['Boolean']['output'];
  rate?: Maybe<Scalars['Decimal']['output']>;
  startingRate: Scalars['Decimal']['output'];
  step?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PeggedPriceConfigUpsertInput = {
  floor?: InputMaybe<Scalars['Decimal']['input']>;
  indexId: Scalars['Int']['input'];
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  rate?: InputMaybe<Scalars['Decimal']['input']>;
  startingRate?: InputMaybe<Scalars['Decimal']['input']>;
  step?: InputMaybe<Scalars['Decimal']['input']>;
};

export type PeggedPriceIndex = {
  __typename?: 'PeggedPriceIndex';
  category?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export enum PeriodGranularity {
  Custom = 'custom',
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Weekly = 'weekly',
  Yearly = 'yearly'
}

export type PermissionScope = {
  __typename?: 'PermissionScope';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Person = PersonInterface & {
  __typename?: 'Person';
  appFeatures: AppFeatures;
  createdAt: Scalars['DateTime']['output'];
  emails: Array<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** A single feature flag; null for keys not in the flag registry. */
  flag?: Maybe<Scalars['Boolean']['output']>;
  /** Viewer-scoped feature flags: the tenant bag with registry defaults applied for unset keys, plus viewer overlays. */
  flags: Scalars['Json']['output'];
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  messages: Array<Message>;
  organization: Organization;
  phones: Array<Phone>;
  updatedAt: Scalars['DateTime']['output'];
};


export type PersonFlagArgs = {
  key: Scalars['String']['input'];
};

export type PersonAvailability = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  locations: Array<PersonAvailabilityLocation>;
  note?: Maybe<Scalars['String']['output']>;
  person: Person;
  personId: Scalars['Int']['output'];
  status: PersonAvailabilityStatus;
  updatedAt: Scalars['DateTime']['output'];
  validFrom: Scalars['DateTime']['output'];
  validTo?: Maybe<Scalars['DateTime']['output']>;
};

export type PersonAvailabilityLocation = {
  __typename?: 'PersonAvailabilityLocation';
  address?: Maybe<Address>;
  branch: Branch;
  branchId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  yard?: Maybe<Yard>;
  yardId?: Maybe<Scalars['Int']['output']>;
};

export enum PersonAvailabilityStatus {
  Available = 'available',
  Unavailable = 'unavailable'
}

export type PersonCancelTimeOffWhereInput = {
  id: Scalars['Int']['input'];
};

export type PersonInterface = {
  appFeatures: AppFeatures;
  createdAt: Scalars['DateTime']['output'];
  emails: Array<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** A single feature flag; null for keys not in the flag registry. */
  flag?: Maybe<Scalars['Boolean']['output']>;
  /** Viewer-scoped feature flags: the tenant bag with registry defaults applied for unset keys, plus viewer overlays. */
  flags: Scalars['Json']['output'];
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  messages: Array<Message>;
  organization: Organization;
  phones: Array<Phone>;
  updatedAt: Scalars['DateTime']['output'];
};


export type PersonInterfaceFlagArgs = {
  key: Scalars['String']['input'];
};

export type PersonMutations = {
  __typename?: 'PersonMutations';
  merge: PersonMutationsMergeResponse;
};


export type PersonMutationsMergeArgs = {
  data: PersonMutationsMergeDataInput;
  where: PersonWhereUniqueInput;
};

export type PersonMutationsMergeDataInput = {
  with: Array<PersonWhereUniqueInput>;
};

export type PersonMutationsMergeResponse = {
  __typename?: 'PersonMutationsMergeResponse';
  deletedIds: Array<Scalars['Int']['output']>;
  person: PersonInterface;
};

export type PersonScheduleTimeOffDataInput = {
  allDay: Scalars['Boolean']['input'];
  approval?: InputMaybe<TimeOffApproval>;
  /** "HH:mm" per-occurrence end. Required when recurrence is recurring and allDay is false */
  dayEnd?: InputMaybe<Scalars['String']['input']>;
  /** "HH:mm" per-occurrence start. Required when recurrence is recurring and allDay is false */
  dayStart?: InputMaybe<Scalars['String']['input']>;
  /** Required when recurrence is one_time */
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Full-replace on update: omitting this clears the stored note */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Full-replace on update: omitting this clears the stored reason */
  reasonName?: InputMaybe<Scalars['String']['input']>;
  recurrence: TimeOffRecurrence;
  /** RFC 5545 RRULE, FREQ=WEEKLY subset. Required when recurrence is recurring */
  rrule?: InputMaybe<Scalars['String']['input']>;
  /** DTSTART anchor. Required when recurrence is recurring */
  rruleStart?: InputMaybe<Scalars['DateTime']['input']>;
  selectedTimezone: Scalars['String']['input'];
  /** Required when recurrence is one_time */
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PersonScheduleTimeOffWhereInput = {
  personId: Scalars['Int']['input'];
};

export type PersonTimeOff = {
  __typename?: 'PersonTimeOff';
  additionalInfo?: Maybe<Array<KeyValue>>;
  allDay: Scalars['Boolean']['output'];
  approval: TimeOffApproval;
  createdAt: Scalars['DateTime']['output'];
  dayEnd?: Maybe<Scalars['String']['output']>;
  dayStart?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  note?: Maybe<Scalars['String']['output']>;
  person: Person;
  personId: Scalars['Int']['output'];
  reason?: Maybe<PersonTimeOffReason>;
  recurrence: TimeOffRecurrence;
  rrule?: Maybe<Scalars['String']['output']>;
  rruleStart?: Maybe<Scalars['DateTime']['output']>;
  source: TimeOffSource;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PersonTimeOffReason = {
  __typename?: 'PersonTimeOffReason';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type PersonTimeSheetWhereInput = {
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type PersonUpdateTimeOffWhereInput = {
  id: Scalars['Int']['input'];
};

export type PersonWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type Phone = {
  __typename?: 'Phone';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  number: Scalars['String']['output'];
  sms: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  typeDetails: PhoneType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PhoneInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  number: Scalars['String']['input'];
  sms?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PhoneType = {
  __typename?: 'PhoneType';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** The current Terms of Use and whether the caller has accepted them */
export type PlatformTermsOfUseStatus = {
  __typename?: 'PlatformTermsOfUseStatus';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  consentText: Scalars['String']['output'];
  effectiveDate: Scalars['Date']['output'];
  presentation?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PourType = {
  __typename?: 'PourType';
  /** @deprecated Abbreviation on PourType is deprecated and will always return null */
  abbreviation?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  category?: Maybe<PourType>;
  categoryId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  durationMultiplier?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  isCategory: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pinned: Scalars['Boolean']['output'];
  /** @deprecated Sort on PourType is deprecated and will always return 0 */
  sort: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PourTypeInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  durationMultiplier?: InputMaybe<Scalars['Float']['input']>;
  isCategory?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<KeyValuesInput>;
  name: Scalars['String']['input'];
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PourTypeUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  durationMultiplier?: InputMaybe<Scalars['Float']['input']>;
  isCategory?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<KeyValuesInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PourTypeWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export enum PowerLineSource {
  Customer = 'customer',
  Dispatcher = 'dispatcher'
}

export type PreparedPayment = {
  __typename?: 'PreparedPayment';
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  customer: Customer;
  id: Scalars['String']['output'];
  invoices: Array<PreparedPaymentInvoice>;
  /** Lump request cap applied to open invoices at pay time; null for invoice-based templates */
  lumpSumAmount?: Maybe<Scalars['Decimal']['output']>;
};

export type PreparedPaymentInvoice = {
  __typename?: 'PreparedPaymentInvoice';
  /** Requested partial amount; null means pay the full balance */
  amount?: Maybe<Scalars['Decimal']['output']>;
  invoice: Invoice;
};

export type PreparedPaymentInvoiceInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  invoiceId: Scalars['String']['input'];
};

export type Price = {
  __typename?: 'Price';
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  inputMode?: Maybe<Scalars['String']['output']>;
  peggedConfig?: Maybe<PeggedPriceConfig>;
  rateDisplay?: Maybe<Scalars['String']['output']>;
  rates: Array<PriceRate>;
  ratesMode: PriceRatesMode;
  taxable: Scalars['Boolean']['output'];
};

export type PriceList = {
  __typename?: 'PriceList';
  active: Scalars['Boolean']['output'];
  attachments: Array<Attachment>;
  changelog?: Maybe<Changelog>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  entries: Array<PriceListEntry>;
  id: Scalars['Int']['output'];
  invoiceTerm?: Maybe<InvoiceTerm>;
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<PriceList>;
  revision: Scalars['Int']['output'];
  schedules: Array<PriceListSchedule>;
  tags: Array<Tag>;
  updatedAt: Scalars['DateTime']['output'];
};


export type PriceListEntriesArgs = {
  where: PriceListEntriesWhereInput;
};

export type PriceListCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  attachments?: InputMaybe<AttachmentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  invoiceTerm?: InputMaybe<InvoiceTermWhereUniqueInput>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  parent?: InputMaybe<PriceListWhereUniqueInput>;
  schedules?: InputMaybe<PriceListSchedulesInput>;
  tags?: InputMaybe<TagsInput>;
};

export type PriceListEntriesInput = {
  delete?: InputMaybe<Array<InvoiceItemWhereUniqueInput>>;
  set?: InputMaybe<Array<PriceListEntryUpsertInput>>;
  upsert?: InputMaybe<Array<PriceListEntryUpsertInput>>;
};

export type PriceListEntriesWhereInput = {
  date: Scalars['DateLike']['input'];
};

export type PriceListEntry = {
  __typename?: 'PriceListEntry';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  item: InvoiceItem;
  price: Price;
  revision: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PriceListEntryUpsertInput = {
  item: InvoiceItemWhereUniqueInput;
  price: PriceUpsertInput;
};

export type PriceListMutations = {
  __typename?: 'PriceListMutations';
  create: PriceListMutationsCreateResponse;
  update: PriceListMutationsUpdateResponse;
};


export type PriceListMutationsCreateArgs = {
  data: PriceListCreateInput;
};


export type PriceListMutationsUpdateArgs = {
  data: PriceListUpdateInput;
  where: PriceListWhereUniqueInput;
};

export type PriceListMutationsCreateResponse = {
  __typename?: 'PriceListMutationsCreateResponse';
  priceList: PriceList;
};

export type PriceListMutationsUpdateResponse = {
  __typename?: 'PriceListMutationsUpdateResponse';
  priceList: PriceList;
};

export type PriceListSchedule = {
  __typename?: 'PriceListSchedule';
  changelog?: Maybe<Changelog>;
  createdAt: Scalars['DateTime']['output'];
  entries: Array<PriceListEntry>;
  id: Scalars['Int']['output'];
  revision: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  validFrom: Scalars['Date']['output'];
  validTo?: Maybe<Scalars['Date']['output']>;
};

export type PriceListScheduleAvailabilityResponse = {
  __typename?: 'PriceListScheduleAvailabilityResponse';
  priceListSchedule: Array<PriceListSchedule>;
};

export type PriceListScheduleCreateInput = {
  entries?: InputMaybe<PriceListEntriesInput>;
  validFrom: Scalars['Date']['input'];
  validTo?: InputMaybe<Scalars['Date']['input']>;
};

export type PriceListScheduleMutations = {
  __typename?: 'PriceListScheduleMutations';
  scheduleAvailability: PriceListScheduleAvailabilityResponse;
};


export type PriceListScheduleMutationsScheduleAvailabilityArgs = {
  data: PriceListScheduleCreateInput;
  where: PriceListScheduleWhereUniqueInput;
};

export type PriceListScheduleUpdateArgs = {
  data: PriceListScheduleUpdateInput;
  where: PriceListScheduleWhereUniqueInput;
};

export type PriceListScheduleUpdateInput = {
  entries?: InputMaybe<PriceListEntriesInput>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
};

export type PriceListScheduleWhereUniqueInput = {
  id: Scalars['Int']['input'];
  revision?: InputMaybe<Scalars['Int']['input']>;
};

export type PriceListSchedulesInput = {
  create?: InputMaybe<Array<PriceListScheduleCreateInput>>;
  update?: InputMaybe<Array<PriceListScheduleUpdateArgs>>;
};

export type PriceListUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  attachments?: InputMaybe<AttachmentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  invoiceTerm?: InputMaybe<InvoiceTermWhereUniqueInput>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<PriceListWhereUniqueInput>;
  schedules?: InputMaybe<PriceListSchedulesInput>;
  tags?: InputMaybe<TagsInput>;
};

export type PriceListWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type PriceRate = {
  __typename?: 'PriceRate';
  amount: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  type: PriceRateType;
  upTo?: Maybe<Scalars['Decimal']['output']>;
};

export enum PriceRateType {
  Flat = 'flat',
  Unit = 'unit'
}

export type PriceRateUpsertInput = {
  amount: Scalars['Decimal']['input'];
  type: PriceRateType;
  upTo?: InputMaybe<Scalars['Decimal']['input']>;
};

export enum PriceRatesMode {
  Graduated = 'graduated',
  Pegged = 'pegged',
  Volume = 'volume'
}

export type PriceUpsertInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  inputMode?: InputMaybe<Scalars['String']['input']>;
  peggedConfig?: InputMaybe<PeggedPriceConfigUpsertInput>;
  rateDisplay?: InputMaybe<Scalars['String']['input']>;
  rates: Array<PriceRateUpsertInput>;
  ratesMode: PriceRatesMode;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PriceWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type ProcessingFeeExpenseSourceDetail = {
  __typename?: 'ProcessingFeeExpenseSourceDetail';
  currency: Scalars['String']['output'];
  feeAmount: Scalars['Decimal']['output'];
  grossAmount: Scalars['Decimal']['output'];
  linkedSourceId?: Maybe<Scalars['String']['output']>;
  linkedSourceType?: Maybe<ProcessingFeeLinkedSourceKind>;
  processingFeeExpenseId: Scalars['Int']['output'];
  stripeBalanceTransactionId: Scalars['String']['output'];
};

/** CreteSuite entity a ProcessingFeeExpense row is linked to. Null when the fee has no associated local entity. */
export enum ProcessingFeeLinkedSourceKind {
  Dispute = 'Dispute',
  Payment = 'Payment',
  Refund = 'Refund'
}

export enum ProcessingFeeType {
  Card = 'card',
  UsBankAccount = 'us_bank_account'
}

export type QuantityResolver = {
  __typename?: 'QuantityResolver';
  config?: Maybe<Scalars['Json']['output']>;
  createdAt: Scalars['DateTime']['output'];
  default?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['Int']['output'];
  maximum?: Maybe<Scalars['Decimal']['output']>;
  minimum?: Maybe<Scalars['Decimal']['output']>;
  rounding?: Maybe<Rounding>;
  step?: Maybe<Scalars['Decimal']['output']>;
  type: QuantityResolverType;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuantityResolverCreateInput = {
  config?: InputMaybe<Scalars['Json']['input']>;
  default?: InputMaybe<Scalars['Decimal']['input']>;
  maximum?: InputMaybe<Scalars['Decimal']['input']>;
  minimum?: InputMaybe<Scalars['Decimal']['input']>;
  rounding?: InputMaybe<Rounding>;
  step?: InputMaybe<Scalars['Decimal']['input']>;
  type: QuantityResolverType;
};

export enum QuantityResolverType {
  Function = 'function',
  Static = 'static'
}

export type QuantityResolverUpdateInput = {
  config?: InputMaybe<Scalars['Json']['input']>;
  default?: InputMaybe<Scalars['Decimal']['input']>;
  maximum?: InputMaybe<Scalars['Decimal']['input']>;
  minimum?: InputMaybe<Scalars['Decimal']['input']>;
  rounding?: InputMaybe<Rounding>;
  step?: InputMaybe<Scalars['Decimal']['input']>;
  type?: InputMaybe<QuantityResolverType>;
};

export type QuantityResolverUpdateRelationInput = {
  data: QuantityResolverUpdateInput;
  where: QuantityResolverWhereUniqueInput;
};

export type QuantityResolverWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type QuantityResolversItemInput = {
  create?: InputMaybe<QuantityResolverCreateInput>;
  disconnect?: InputMaybe<QuantityResolverWhereUniqueInput>;
  update?: InputMaybe<QuantityResolverUpdateRelationInput>;
};

export type Query = {
  __typename?: 'Query';
  accountCodesInUse: Array<Scalars['String']['output']>;
  accountingConfig?: Maybe<AccountingConfig>;
  accountingIntegration?: Maybe<AccountingIntegration>;
  accountingIntegrationGlAccounts: Array<GlAccount>;
  accountingIntegrationGlClasses: Array<GlDimension>;
  accountingIntegrationGlDepartments: Array<GlDimension>;
  accountingIntegrationGlLocations: Array<GlDimension>;
  accountingIntegrationNetsuiteConnection?: Maybe<NetsuiteConnection>;
  accountingIntegrationNetsuiteCustomers: Array<GlDimension>;
  accountingPeriod?: Maybe<AccountingPeriod>;
  accountingPeriods: Array<AccountingPeriod>;
  accountsReceivableReport?: Maybe<AccountsReceivableReport>;
  accountsReceivableReportTransactions: Array<AccountsReceivableReportTransaction>;
  activityAlerts: Array<ActivityAlert>;
  activityEvents: Array<ActivityEvent>;
  addresses: Array<Address>;
  assignment?: Maybe<Assignment>;
  assignmentRoles: Array<AssignmentRole>;
  assignments: Array<Assignment>;
  availableInsightsDashboard: InsightsDashboard;
  availableInsightsDashboards: Array<InsightsDashboard>;
  availableTeam: Array<TeamMemberAvailability>;
  bankAccounts: Array<BankAccount>;
  branches: Array<Branch>;
  calculatePaymentFees?: Maybe<PaymentFeesSummary>;
  changelog?: Maybe<Changelog>;
  checkOrdersFitInNewRoute: OrdersFitCheck;
  checkOrdersFitInRoute: OrdersFitCheck;
  contact?: Maybe<Contact>;
  contactRoles: Array<ContactRole>;
  contacts: Array<Contact>;
  credentialTypes: Array<CredentialType>;
  credentials: Array<Credential>;
  customer?: Maybe<Customer>;
  customers: Array<Customer>;
  dashboardPaymentSession?: Maybe<DashboardPaymentSessionQueries>;
  deposit?: Maybe<Deposit>;
  depositLine?: Maybe<DepositLine>;
  deposits: Array<Deposit>;
  depositsReport: DepositsReportResult;
  documentTypes: Array<DocumentType>;
  emailForwardingTarget?: Maybe<EmailForwardingTarget>;
  emailSuppressions: Array<EmailSuppression>;
  equipment: Array<Equipment>;
  /** Get a set of Availabilities for a equipment */
  equipmentAvailability: Array<EquipmentAvailabilitySnapshot>;
  equipmentAvailabilityReasons: Array<EquipmentAvailabilityReason>;
  /** Get one Equipment Availability by ID */
  equipmentAvailabilityRecord: EquipmentAvailability;
  equipmentGroup: EquipmentGroup;
  equipmentGroups: Array<EquipmentGroup>;
  equipmentMake: EquipmentMake;
  equipmentMakes: Array<EquipmentMake>;
  equipmentModel: EquipmentModel;
  equipmentModels: Array<EquipmentModel>;
  equipmentType: EquipmentType;
  equipmentTypes: Array<EquipmentType>;
  estimateInvoice?: Maybe<InvoiceEstimate>;
  events: Array<Event>;
  globalSearchAccess?: Maybe<GlobalSearchAccess>;
  insightsDashboards: Array<InsightsDashboardResult>;
  insightsUrl?: Maybe<InsightsUrl>;
  integrations?: Maybe<Integrations>;
  inventory: Array<InventoryItem>;
  invoice?: Maybe<Invoice>;
  invoiceByNumber?: Maybe<Invoice>;
  invoiceItem: InvoiceItem;
  invoiceItems: Array<InvoiceItem>;
  invoiceStatuses: Array<InvoiceStatus>;
  invoiceTemplateLineGroup: InvoiceTemplateLineGroup;
  invoiceTemplateLineGroups: Array<InvoiceTemplateLineGroup>;
  /** @deprecated use services instead */
  invoiceTemplates: Array<Service>;
  invoiceTerms: Array<InvoiceTerm>;
  invoices: Array<Invoice>;
  ledgerEntries: LedgerEntriesPage;
  ledgerEntryLineSources: LedgerEntryLineSourcesResult;
  ledgerExports: Array<LedgerExport>;
  ledgerReport?: Maybe<LedgerReport>;
  maintenanceEvent?: Maybe<MaintenanceEvent>;
  maintenanceEventTypes: Array<MaintenanceEventType>;
  me?: Maybe<PersonInterface>;
  myAccount?: Maybe<LinkedAccount>;
  /** All organizations the current user has access to */
  myOrganizations: Array<Organization>;
  notes: Array<Note>;
  notificationRuleConfigs: Array<NotificationRuleConfig>;
  openAccountingEraStart?: Maybe<Scalars['DateTime']['output']>;
  operator?: Maybe<Operator>;
  /** Get Availabilities for Operators */
  operatorAvailabilities: Array<OperatorAvailability>;
  /** Get a Operator Availability by ID */
  operatorAvailability: OperatorAvailability;
  operators: Array<Operator>;
  order?: Maybe<Order>;
  orderCancellationReasons: Array<OrderCancellationReason>;
  orderStatuses: Array<OrderStatus>;
  orders: Array<Order>;
  organization?: Maybe<Organization>;
  payment?: Maybe<Payment>;
  paymentDetails?: Maybe<PaymentDetails>;
  paymentRefundDetails?: Maybe<PaymentRefundDetails>;
  paymentRefundPreview?: Maybe<PaymentRefundPreview>;
  paymentSources: Array<PaymentSource>;
  paymentTypes: Array<PaymentType>;
  payments: Array<Payment>;
  payments_v2: Array<PaymentDetails>;
  peggedPriceIndexes: Array<PeggedPriceIndex>;
  /** Get a Person Time Off by ID */
  personTimeOff?: Maybe<PersonTimeOff>;
  /** Get the Time Off reasons of the tenant */
  personTimeOffReasons: Array<PersonTimeOffReason>;
  /** Get the Time Off records of a Person, or of every Person when personId is omitted */
  personTimeOffs: Array<PersonTimeOff>;
  phoneTypes: Array<PhoneType>;
  platformFeeItem?: Maybe<SubscriptionInvoiceUsageFee>;
  pourTypes: Array<PourType>;
  priceList?: Maybe<PriceList>;
  priceLists: Array<PriceList>;
  relevantBranches: Array<Branch>;
  relevantPriceLists: Array<PriceList>;
  reportingEntities: Array<ReportingEntity>;
  revenueMappingRules: Array<RevenueMappingRule>;
  route?: Maybe<Route>;
  routeWaypoint?: Maybe<RouteWaypoint>;
  routeWaypoints: Array<RouteWaypoint>;
  routes: Array<Route>;
  /** Custom locations saved for reuse as route departure/arrival overrides */
  savedCustomLocations: Array<Address>;
  scheduleSteps: Array<ScheduleStep>;
  /** @deprecated use services instead */
  serviceCategories?: Maybe<Array<Service>>;
  services: Array<Service>;
  shortLink?: Maybe<ShortLink>;
  site?: Maybe<Site>;
  sites: Array<Site>;
  statementBatch?: Maybe<StatementBatch>;
  stripe?: Maybe<Stripe>;
  subEntities: Array<SubEntity>;
  suppliers: Array<Supplier>;
  tag: Tag;
  tags: Array<Tag>;
  terms?: Maybe<Terms>;
  testMappingRule: TestMappingRuleResult;
  timeClock?: Maybe<TimeClock>;
  timeClockShift?: Maybe<TimeClockShift>;
  timeClockTasks: Array<TimeClockTask>;
  timeClockVoidReasons: Array<TimeClockVoidReason>;
  timeSheets: Array<TimeSheet>;
  unappliedPayments?: Maybe<UnappliedPayments>;
  undepositedPayments: Array<UndepositedPayment>;
  undepositedSummary: UndepositedSummary;
  user?: Maybe<User>;
  userPermissionScopes: Array<UserPermission>;
  userRole?: Maybe<UserRole>;
  userRoles: Array<UserRole>;
  users: Array<User>;
  validate?: Maybe<ValidateQuery>;
};


export type QueryAccountingIntegrationNetsuiteCustomersArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAccountingPeriodArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAccountingPeriodsArgs = {
  orderBy?: InputMaybe<AccountingPeriodOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<AccountingPeriodStatus>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAccountsReceivableReportArgs = {
  where?: InputMaybe<AccountsReceivableReportWhere>;
};


export type QueryAccountsReceivableReportTransactionsArgs = {
  customerId: Scalars['Int']['input'];
  where?: InputMaybe<AccountsReceivableReportTransactionsWhere>;
};


export type QueryActivityAlertsArgs = {
  where?: InputMaybe<ActivityAlertsFilterInput>;
};


export type QueryActivityEventsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActivityEventsFilterInput>;
};


export type QueryAddressesArgs = {
  orderBy?: InputMaybe<Array<QueryAddressesOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryAddressesWhereInput>;
};


export type QueryAssignmentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAssignmentRolesArgs = {
  where?: InputMaybe<QueryAssignmentRolesWhereInput>;
};


export type QueryAssignmentsArgs = {
  orderBy?: InputMaybe<Array<QueryAssignmentsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryAssignmentsWhereInput>;
};


export type QueryAvailableInsightsDashboardArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAvailableInsightsDashboardsArgs = {
  where?: InputMaybe<QueryInsightsDashboardsWhereInput>;
};


export type QueryAvailableTeamArgs = {
  where: AvailableTeamWhereInput;
};


export type QueryBranchesArgs = {
  where?: InputMaybe<QueryBranchesWhereInput>;
};


export type QueryCalculatePaymentFeesArgs = {
  data: CalculatePaymentFeesInput;
};


export type QueryChangelogArgs = {
  where: ChangelogWhereInput;
};


export type QueryCheckOrdersFitInNewRouteArgs = {
  where: CheckOrdersFitInNewRouteInput;
};


export type QueryCheckOrdersFitInRouteArgs = {
  where?: InputMaybe<CheckOrdersFitInRouteInput>;
};


export type QueryContactArgs = {
  id: Scalars['Int']['input'];
};


export type QueryContactRolesArgs = {
  where?: InputMaybe<QueryContactRolesWhereInput>;
};


export type QueryContactsArgs = {
  orderBy?: InputMaybe<Array<QueryContactsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryContactsWhereInput>;
};


export type QueryCredentialTypesArgs = {
  where?: InputMaybe<QueryCredentialTypesWhereInput>;
};


export type QueryCredentialsArgs = {
  orderBy?: InputMaybe<Array<QueryCredentialsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryCredentialsWhereInput>;
};


export type QueryCustomerArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCustomersArgs = {
  orderBy?: InputMaybe<Array<QueryCustomersOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryCustomersWhereInput>;
};


export type QueryDepositArgs = {
  depositId: Scalars['String']['input'];
};


export type QueryDepositLineArgs = {
  id: Scalars['String']['input'];
};


export type QueryDepositsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DepositListWhereInput>;
};


export type QueryDepositsReportArgs = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};


export type QueryDocumentTypesArgs = {
  where?: InputMaybe<DocumentTypesWhereInput>;
};


export type QueryEmailForwardingTargetArgs = {
  token: Scalars['String']['input'];
};


export type QueryEmailSuppressionsArgs = {
  addresses: Array<Scalars['String']['input']>;
};


export type QueryEquipmentArgs = {
  orderBy?: InputMaybe<Array<QueryEquipmentOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryEquipmentWhereInput>;
};


export type QueryEquipmentAvailabilityArgs = {
  orderBy?: InputMaybe<Array<QueryEquipmentAvailabilitiesOrderByInput>>;
  where?: InputMaybe<QueryEquipmentAvailabilitiesWhereInput>;
};


export type QueryEquipmentAvailabilityReasonsArgs = {
  where?: InputMaybe<QueryEquipmentAvailabilityReasonsWhereInput>;
};


export type QueryEquipmentAvailabilityRecordArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEquipmentGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEquipmentGroupsArgs = {
  where?: InputMaybe<QueryEquipmentGroupsWhereInput>;
};


export type QueryEquipmentMakeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEquipmentMakesArgs = {
  where?: InputMaybe<QueryEquipmentMakesWhereInput>;
};


export type QueryEquipmentModelArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEquipmentModelsArgs = {
  where?: InputMaybe<QueryEquipmentModelsWhereInput>;
};


export type QueryEquipmentTypeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEquipmentTypesArgs = {
  where?: InputMaybe<QueryEquipmentTypesWhereInput>;
};


export type QueryEstimateInvoiceArgs = {
  where: OrderWhereUniqueInput;
};


export type QueryEventsArgs = {
  orderBy?: InputMaybe<Array<QueryEventsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryEventsWhereInput>;
};


export type QueryInsightsUrlArgs = {
  where?: InputMaybe<InsightsUrlInput>;
};


export type QueryInventoryArgs = {
  where?: InputMaybe<QueryInventoryItemsWhereInput>;
};


export type QueryInvoiceArgs = {
  id: Scalars['String']['input'];
};


export type QueryInvoiceByNumberArgs = {
  invoiceNumber: Scalars['String']['input'];
};


export type QueryInvoiceItemArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvoiceItemsArgs = {
  orderBy?: InputMaybe<Array<QueryInvoiceItemsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryInvoiceItemsWhereInput>;
};


export type QueryInvoiceStatusesArgs = {
  where?: InputMaybe<QueryInvoiceStatusesWhereInput>;
};


export type QueryInvoiceTemplateLineGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvoiceTemplateLineGroupsArgs = {
  orderBy?: InputMaybe<Array<QueryInvoiceTemplateLineGroupsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryInvoiceTemplateLineGroupsWhereInput>;
};


export type QueryInvoiceTemplatesArgs = {
  orderBy?: InputMaybe<Array<QueryInvoiceTemplatesOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryInvoiceTemplatesWhereInput>;
};


export type QueryInvoicesArgs = {
  orderBy?: InputMaybe<Array<QueryInvoicesOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryInvoicesWhereInput>;
};


export type QueryLedgerEntriesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LedgerEntriesFilterInput>;
  periodId: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLedgerEntryLineSourcesArgs = {
  lineId: Scalars['Int']['input'];
};


export type QueryLedgerExportsArgs = {
  periodId?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLedgerReportArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMaintenanceEventArgs = {
  where: MaintenanceEventQueryWhereInput;
};


export type QueryMaintenanceEventTypesArgs = {
  orderBy?: InputMaybe<Array<QueryMaintenanceEventTypesOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryMaintenanceEventTypesWhereInput>;
};


export type QueryNotesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryNotesWhereInput>;
};


export type QueryOperatorArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOperatorAvailabilitiesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryPersonAvailabilitiesWhereInput>;
};


export type QueryOperatorAvailabilityArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOperatorsArgs = {
  orderBy?: InputMaybe<Array<QueryOperatorsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryOperatorsWhereInput>;
};


export type QueryOrderArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrderCancellationReasonsArgs = {
  where?: InputMaybe<QueryOrderCancellationReasonsWhereInput>;
};


export type QueryOrderStatusesArgs = {
  where?: InputMaybe<QueryOrderStatusesWhereInput>;
};


export type QueryOrdersArgs = {
  orderBy?: InputMaybe<Array<QueryOrdersOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryOrdersWhereInput>;
};


export type QueryPaymentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPaymentDetailsArgs = {
  paymentId: Scalars['String']['input'];
};


export type QueryPaymentRefundDetailsArgs = {
  refundId: Scalars['String']['input'];
};


export type QueryPaymentRefundPreviewArgs = {
  paymentId: Scalars['String']['input'];
};


export type QueryPaymentSourcesArgs = {
  where?: InputMaybe<PaymentSourceWhereInput>;
};


export type QueryPaymentTypesArgs = {
  where?: InputMaybe<QueryPaymentTypesWhereInput>;
};


export type QueryPaymentsArgs = {
  orderBy?: InputMaybe<Array<QueryPaymentsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryPaymentsWhereInput>;
};


export type QueryPayments_V2Args = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PaymentListWhereInput>;
};


export type QueryPersonTimeOffArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPersonTimeOffsArgs = {
  personId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPhoneTypesArgs = {
  where?: InputMaybe<QueryPhoneTypesWhereInput>;
};


export type QueryPlatformFeeItemArgs = {
  date: Scalars['DateLike']['input'];
};


export type QueryPourTypesArgs = {
  where?: InputMaybe<QueryPourTypesWhereInput>;
};


export type QueryPriceListArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPriceListsArgs = {
  orderBy?: InputMaybe<Array<QueryPriceListsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryPriceListsWhereInput>;
};


export type QueryRelevantPriceListsArgs = {
  where: RelevantPriceListWhereInput;
};


export type QueryRouteArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRouteWaypointArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRouteWaypointsArgs = {
  orderBy?: InputMaybe<Array<QueryRouteWaypointsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryRouteWaypointsWhereInput>;
};


export type QueryRoutesArgs = {
  orderBy?: InputMaybe<Array<QueryRoutesOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryRoutesWhereInput>;
};


export type QuerySavedCustomLocationsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryScheduleStepsArgs = {
  where?: InputMaybe<QueryScheduleStepsWhereInput>;
};


export type QueryServiceCategoriesArgs = {
  orderBy?: InputMaybe<Array<QueryServiceCategoriesOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryServiceCategoriesWhereInput>;
};


export type QueryServicesArgs = {
  orderBy?: InputMaybe<Array<QueryServicesOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryServicesWhereInput>;
};


export type QueryShortLinkArgs = {
  where: QueryShortLinkWhereInput;
};


export type QuerySiteArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySitesArgs = {
  orderBy?: InputMaybe<Array<QuerySitesOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuerySitesWhereInput>;
};


export type QueryStatementBatchArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySuppliersArgs = {
  where?: InputMaybe<QuerySuppliersWhereInput>;
};


export type QueryTagArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTagsArgs = {
  orderBy?: InputMaybe<Array<QueryTagsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryTagsWhereInput>;
};


export type QueryTestMappingRuleArgs = {
  input: MatchInput;
};


export type QueryTimeClockArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTimeClockShiftArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTimeClockTasksArgs = {
  orderBy?: InputMaybe<Array<QueryTimeClockTasksOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryTimeClockTasksWhereInput>;
};


export type QueryTimeClockVoidReasonsArgs = {
  where?: InputMaybe<QueryTimeClockVoidReasonsWhereInput>;
};


export type QueryTimeSheetsArgs = {
  includeVoided?: InputMaybe<Scalars['Boolean']['input']>;
  where: TimeSheetsWhereInput;
};


export type QueryUnappliedPaymentsArgs = {
  where: UnappliedPaymentsQueryWhereInput;
};


export type QueryUserArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserRoleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserRolesArgs = {
  orderBy?: InputMaybe<Array<QueryUserRolesOrderByInput>>;
  where?: InputMaybe<QueryUserRolesWhereInput>;
};


export type QueryUsersArgs = {
  orderBy?: InputMaybe<Array<QueryUsersOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryUsersWhereInput>;
};

export type QueryAddressesOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type QueryAddressesWhereInput = {
  id?: InputMaybe<IntFilter>;
};

export type QueryAssignmentRolesWhereInput = {
  active?: InputMaybe<BoolFilter>;
};

export type QueryAssignmentsOrderByInput = {
  id?: InputMaybe<SortOrder>;
};

export type QueryAssignmentsWhereInput = {
  active?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  visible?: InputMaybe<BoolFilter>;
};

export type QueryBranchesWhereInput = {
  id?: InputMaybe<IntFilter>;
};

export type QueryContactRolesWhereInput = {
  active?: InputMaybe<BoolFilter>;
};

export type QueryContactsOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type QueryContactsWhereInput = {
  active?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  phone?: InputMaybe<StringFilter>;
  tagId?: InputMaybe<IntFilter>;
};

export type QueryCredentialTypesWhereInput = {
  active?: InputMaybe<BoolFilter>;
};

export type QueryCredentialsOrderByInput = {
  expirationDate?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
};

export type QueryCredentialsWhereInput = {
  active?: InputMaybe<BoolFilter>;
  expirationDate?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
};

export type QueryCustomersOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type QueryCustomersWhereInput = {
  active?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  phone?: InputMaybe<StringFilter>;
  tagId?: InputMaybe<IntFilter>;
};

export type QueryEquipmentAvailabilitiesOrderByInput = {
  id?: InputMaybe<SortOrder>;
};

export type QueryEquipmentAvailabilitiesWhereInput = {
  branchId?: InputMaybe<IntFilter>;
  equipmentId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  validFrom?: InputMaybe<DateTimeFilter>;
  validTo?: InputMaybe<DateTimeNullableFilter>;
};

export type QueryEquipmentAvailabilityReasonsWhereInput = {
  active?: InputMaybe<BoolFilter>;
  status?: InputMaybe<EnumEquipmentAvailabilityStatusFilter>;
};

export type QueryEquipmentGroupsWhereInput = {
  name?: InputMaybe<StringFilter>;
};

export type QueryEquipmentMakesWhereInput = {
  active?: InputMaybe<BoolFilter>;
};

export type QueryEquipmentModelsWhereInput = {
  active?: InputMaybe<BoolFilter>;
};

export type QueryEquipmentOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  sort?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type QueryEquipmentTypesWhereInput = {
  active?: InputMaybe<BoolFilter>;
};

export type QueryEquipmentWhereInput = {
  active?: InputMaybe<BoolFilter>;
  branchId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  type?: InputMaybe<StringFilter>;
};

export type QueryEventsOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type QueryEventsWhereInput = {
  active?: InputMaybe<BoolFilter>;
  branchId: Scalars['Int']['input'];
  /** YYYY-MM-DD date string to view events on */
  date?: InputMaybe<Scalars['String']['input']>;
};

export type QueryInsightsDashboardsWhereInput = {
  hidden?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type QueryInventoryItemsWhereInput = {
  active?: InputMaybe<BoolFilter>;
  branchId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
};

export type QueryInvoiceItemsOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type QueryInvoiceItemsWhereInput = {
  active?: InputMaybe<BoolFilter>;
  category?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
};

export type QueryInvoiceStatusesWhereInput = {
  active?: InputMaybe<BoolFilter>;
};

export type QueryInvoiceTemplateLineGroupsOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type QueryInvoiceTemplateLineGroupsWhereInput = {
  id?: InputMaybe<IntFilter>;
};

export type QueryInvoiceTemplatesOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type QueryInvoiceTemplatesWhereInput = {
  active?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
};

export type QueryInvoicesOrderByInput = {
  amountDue?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dueDate?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  invoiceDate?: InputMaybe<SortOrder>;
};

export type QueryInvoicesWhereInput = {
  amountDue?: InputMaybe<DecimalFilter>;
  branchId?: InputMaybe<IntFilter>;
  customerId?: InputMaybe<IntNullableFilter>;
  dueDate?: InputMaybe<DateTimeNullableFilter>;
  excludeHoldPayment?: InputMaybe<Scalars['Boolean']['input']>;
  excludeUnmintable?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<StringFilter>;
  invoiceDate?: InputMaybe<DateTimeFilter>;
  notSent?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<StringFilter>;
  serviceId?: InputMaybe<IntFilter>;
  siteId?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<StringFilter>;
  tagId?: InputMaybe<IntFilter>;
};

export type QueryMaintenanceEventTypesOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type QueryMaintenanceEventTypesWhereInput = {
  active?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type QueryNotesWhereInput = {
  active?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
};

export type QueryOperatorsOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type QueryOperatorsWhereInput = {
  active?: InputMaybe<BoolFilter>;
  branchId?: InputMaybe<IntFilter>;
  excludeBranchIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<IntFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryOrderCancellationReasonsWhereInput = {
  active?: InputMaybe<BoolFilter>;
};

export type QueryOrderStatusesWhereInput = {
  active?: InputMaybe<BoolFilter>;
};

export type QueryOrdersOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  dateOfService?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type QueryOrdersWhereInput = {
  active?: InputMaybe<BoolFilter>;
  branchId?: InputMaybe<IntNullableFilter>;
  contactId?: InputMaybe<IntFilter>;
  customerId?: InputMaybe<IntNullableFilter>;
  dateOfService?: InputMaybe<DateTimeNullableFilter>;
  geo?: InputMaybe<GeoFilter>;
  id?: InputMaybe<IntFilter>;
  isUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId?: InputMaybe<IntNullableFilter>;
  siteId?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<StringFilter>;
  tagId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type QueryPaymentTypesWhereInput = {
  active?: InputMaybe<BoolFilter>;
};

export type QueryPaymentsOrderByInput = {
  amount?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type QueryPaymentsWhereInput = {
  amount?: InputMaybe<DecimalFilter>;
  customerId?: InputMaybe<IntFilter>;
  date?: InputMaybe<DateTimeFilter>;
  method?: InputMaybe<StringFilter>;
  reference?: InputMaybe<StringNullableFilter>;
};

export type QueryPersonAvailabilitiesWhereInput = {
  personId?: InputMaybe<IntFilter>;
  status?: InputMaybe<EnumPersonAvailabilityStatusFilter>;
  validFrom?: InputMaybe<DateTimeFilter>;
  validTo?: InputMaybe<DateTimeNullableFilter>;
};

export type QueryPhoneTypesWhereInput = {
  active?: InputMaybe<BoolFilter>;
};

export type QueryPourTypesWhereInput = {
  active?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  isCategory?: InputMaybe<BoolFilter>;
};

export type QueryPriceListsOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type QueryPriceListsWhereInput = {
  active?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
};

export type QueryRouteWaypointsOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  scheduledArrivalTime?: InputMaybe<SortOrderInput>;
  scheduledDepartureTime?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type QueryRouteWaypointsWhereInput = {
  addressId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
};

export type QueryRoutesOrderByInput = {
  startTime?: InputMaybe<SortOrder>;
};

export type QueryRoutesWhereInput = {
  OR?: InputMaybe<Array<QueryRoutesWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  branchId?: InputMaybe<IntFilter>;
  endTime?: InputMaybe<DateTimeFilter>;
  equipmentId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  occursNearTime?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<DateTimeFilter>;
};

export type QueryScheduleStepsWhereInput = {
  active?: InputMaybe<BoolFilter>;
};

export type QueryServiceCategoriesOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type QueryServiceCategoriesWhereInput = {
  active?: InputMaybe<BoolFilter>;
  branchId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
};

export type QueryServicesOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type QueryServicesWhereInput = {
  active?: InputMaybe<BoolFilter>;
  branchId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
};

export type QueryShortLinkWhereInput = {
  slug: Scalars['String']['input'];
};

export type QuerySitesOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type QuerySitesWhereInput = {
  active?: InputMaybe<BoolFilter>;
  customerId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
};

export type QuerySuppliersWhereInput = {
  active?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
};

export type QueryTagsOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  path?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type QueryTagsWhereInput = {
  active?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  path?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
};

export type QueryTimeClockTasksOrderByInput = {
  id?: InputMaybe<SortOrder>;
};

export type QueryTimeClockTasksWhereInput = {
  active?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  scopes?: InputMaybe<EnumTimeClockTaskScopeNullableListFilter>;
};

export type QueryTimeClockVoidReasonsWhereInput = {
  active?: InputMaybe<BoolFilter>;
};

export type QueryUserRolesOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type QueryUserRolesWhereInput = {
  active?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
};

export type QueryUsersOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type QueryUsersWhereInput = {
  active?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
};

export type Quickbooks = {
  __typename?: 'Quickbooks';
  accounts?: Maybe<Array<QuickbooksAccount>>;
  customers?: Maybe<Array<QuickbooksCustomer>>;
  items?: Maybe<QuickbooksItems>;
  name?: Maybe<Scalars['String']['output']>;
  realmId?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<QuickbooksSettings>;
};

export type QuickbooksAccount = {
  __typename?: 'QuickbooksAccount';
  accountSubType?: Maybe<Scalars['String']['output']>;
  accountType?: Maybe<Scalars['String']['output']>;
  acctNum?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  classification?: Maybe<Scalars['String']['output']>;
  currentBalance?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  syncToken: Scalars['String']['output'];
};

export type QuickbooksCustomer = {
  __typename?: 'QuickbooksCustomer';
  active: Scalars['Boolean']['output'];
  address?: Maybe<Address>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  revision: Scalars['String']['output'];
};

export enum QuickbooksCustomerSyncMode {
  CreateOnly = 'CREATE_ONLY',
  Full = 'FULL',
  None = 'NONE'
}

export type QuickbooksInvoice = {
  __typename?: 'QuickbooksInvoice';
  id: Scalars['String']['output'];
};

export type QuickbooksItem = {
  __typename?: 'QuickbooksItem';
  active: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  revision: Scalars['String']['output'];
};

export type QuickbooksItems = {
  __typename?: 'QuickbooksItems';
  all: Array<QuickbooksItem>;
  linkable: Array<QuickbooksLinkableItem>;
};

export type QuickbooksLinkableItem = {
  __typename?: 'QuickbooksLinkableItem';
  itemId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type QuickbooksMutationNamespace = {
  __typename?: 'QuickbooksMutationNamespace';
  createCustomer?: Maybe<Customer>;
  createInvoice?: Maybe<GenericResponse>;
  generateInvoicePdfLink: Scalars['String']['output'];
  linkCustomer: Customer;
  linkItem?: Maybe<QuickbooksLinkableItem>;
  syncCustomer?: Maybe<GenericResponse>;
  syncStripeSeed?: Maybe<GenericResponse>;
};


export type QuickbooksMutationNamespaceCreateCustomerArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  where: CustomerWhereUniqueInput;
};


export type QuickbooksMutationNamespaceCreateInvoiceArgs = {
  forceRecreate?: InputMaybe<Scalars['Boolean']['input']>;
  where: OrderWhereUniqueInput;
};


export type QuickbooksMutationNamespaceGenerateInvoicePdfLinkArgs = {
  where: OrderWhereUniqueInput;
};


export type QuickbooksMutationNamespaceLinkCustomerArgs = {
  customer: CustomerWhereUniqueInput;
  quickbooksId?: InputMaybe<Scalars['String']['input']>;
};


export type QuickbooksMutationNamespaceLinkItemArgs = {
  itemId?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};


export type QuickbooksMutationNamespaceSyncCustomerArgs = {
  where: CustomerWhereUniqueInput;
};

export type QuickbooksSettings = {
  __typename?: 'QuickbooksSettings';
  customTxnNumberFormat?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  poNumberCustomField?: Maybe<Scalars['String']['output']>;
  syncCustomersMode: QuickbooksCustomerSyncMode;
  syncInvoices: Scalars['Boolean']['output'];
  vulcanOrderLinkCustomField?: Maybe<Scalars['String']['output']>;
};

export enum QuickbooksSettingsSyncCustomersMode {
  CreateOnly = 'CREATE_ONLY',
  Full = 'FULL',
  None = 'NONE'
}

export type ReceiveInvoicePaymentResponse = {
  __typename?: 'ReceiveInvoicePaymentResponse';
  payment: Payment;
};

export type ReceivePaymentInput = {
  amount: Scalars['Decimal']['input'];
  applyAdjustment?: Scalars['Boolean']['input'];
  currency: Scalars['String']['input'];
  customerId: Scalars['Int']['input'];
  date: Scalars['DateLike']['input'];
  distributions: Array<DistributedPaymentInput>;
  reference?: InputMaybe<Scalars['String']['input']>;
  txId?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type RecordExternalDepositRefInput = {
  depositId: Scalars['String']['input'];
  externalDepositRef?: InputMaybe<Scalars['String']['input']>;
};

/** additionaly security mode for refresh token CSRF: can be https (httpOnly, secure), csrf (fingerprint), none */
export enum RefreshTokenCookieMode {
  Csrf = 'csrf',
  Https = 'https',
  None = 'none'
}

export enum RefundOption {
  FullRefund = 'FULL_REFUND',
  ProcessingFeesOnly = 'PROCESSING_FEES_ONLY',
  RefundUnappliedAmount = 'REFUND_UNAPPLIED_AMOUNT'
}

export type RefundProcessingFeesInput = {
  paymentId: Scalars['String']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  refundDate?: InputMaybe<Scalars['DateLike']['input']>;
  /** Required for non-digital refund. Absent = digital (original payment method). */
  refundTypeId?: InputMaybe<Scalars['Int']['input']>;
};

export type RefundSourceDetail = {
  __typename?: 'RefundSourceDetail';
  amount: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  paymentId: Scalars['String']['output'];
  refundId: Scalars['String']['output'];
  refundNumber?: Maybe<Scalars['String']['output']>;
};

export enum RefundStatus {
  PartiallyRefunded = 'partially_refunded',
  Pending = 'pending',
  Processed = 'processed',
  Voided = 'voided'
}

export enum RefundTypeCategory {
  Cash = 'cash',
  Chargeback = 'chargeback',
  Memo = 'memo',
  NsfReturned = 'nsf_returned'
}

export type RefundUnappliedFundsInput = {
  paymentId: Scalars['String']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  refundDate?: InputMaybe<Scalars['DateLike']['input']>;
  /** Required for non-digital refund. Absent = digital (original payment method). */
  refundTypeId?: InputMaybe<Scalars['Int']['input']>;
};

export type RelevantPriceListWhereInput = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  datetime?: InputMaybe<Scalars['DateTime']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
};

export type ReportingEntity = {
  __typename?: 'ReportingEntity';
  active: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
};

export type ReportingEntityInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type ReportingEntityUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type ReportingEntityWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type RequestAccessToAllInput = {
  phoneNumber: Scalars['String']['input'];
};

export type RequestAccessToAllResponse = {
  __typename?: 'RequestAccessToAllResponse';
  link: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type RequestChangesResponse = {
  __typename?: 'RequestChangesResponse';
  order: Order;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RequestOrderChangeInput = {
  change: Scalars['String']['input'];
};

export type RequestSiteLocationInput = {
  forceResend?: InputMaybe<Scalars['Boolean']['input']>;
  personId?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type RespondToSharingRequestInput = {
  requestId: Scalars['Int']['input'];
  response: OrderSharingRequestStatusEnum;
};

export type RespondToSharingRequestResponse = {
  __typename?: 'RespondToSharingRequestResponse';
  message: Scalars['String']['output'];
};

export type RevenueMappingRule = {
  __typename?: 'RevenueMappingRule';
  accountCode: Scalars['String']['output'];
  allocationTargetType?: Maybe<Scalars['String']['output']>;
  branchId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerId?: Maybe<Scalars['Int']['output']>;
  effectiveFrom: Scalars['DateTime']['output'];
  effectiveTo?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  invoiceLineType?: Maybe<Scalars['String']['output']>;
  isLegacy?: Maybe<Scalars['Boolean']['output']>;
  itemId?: Maybe<Scalars['Int']['output']>;
  ledgerLegType?: Maybe<Scalars['String']['output']>;
  paymentTypeCategory?: Maybe<PaymentTypeCategory>;
  paymentTypeSlug?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
  processingFeeExpenseType?: Maybe<Scalars['String']['output']>;
  refundTypeCategory?: Maybe<RefundTypeCategory>;
  refundTypeSlug?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  supersededById?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RevenueMappingRuleInput = {
  accountCode: Scalars['String']['input'];
  allocationTargetType?: InputMaybe<Scalars['String']['input']>;
  branchId?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceLineType?: InputMaybe<Scalars['String']['input']>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  itemId?: InputMaybe<Scalars['Int']['input']>;
  ledgerLegType?: InputMaybe<Scalars['String']['input']>;
  paymentTypeCategory?: InputMaybe<PaymentTypeCategory>;
  paymentTypeSlug?: InputMaybe<Scalars['String']['input']>;
  priority: Scalars['Int']['input'];
  processingFeeExpenseType?: InputMaybe<Scalars['String']['input']>;
  refundTypeCategory?: InputMaybe<RefundTypeCategory>;
  refundTypeSlug?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type RevokeAccessToAllInput = {
  accessDirection: AccessDirection;
  linkedAccountId: Scalars['ID']['input'];
};

export type RevokeAccessToAllResponse = {
  __typename?: 'RevokeAccessToAllResponse';
  message: Scalars['String']['output'];
};

export enum Rounding {
  Ceil = 'ceil',
  Down = 'down',
  Floor = 'floor',
  HalfCeil = 'halfCeil',
  HalfDown = 'halfDown',
  HalfEven = 'halfEven',
  HalfFloor = 'halfFloor',
  HalfUp = 'halfUp',
  Up = 'up'
}

export type Route = {
  __typename?: 'Route';
  active: Scalars['Boolean']['output'];
  additionalIds?: Maybe<Array<KeyValue>>;
  arrivalAddress?: Maybe<Address>;
  assignments: Array<Assignment>;
  branch: Branch;
  branchId: Scalars['Int']['output'];
  changelog?: Maybe<Changelog>;
  createdAt: Scalars['DateTime']['output'];
  departureAddress?: Maybe<Address>;
  dispatched?: Maybe<Scalars['Boolean']['output']>;
  dispatchedAt?: Maybe<Scalars['DateTime']['output']>;
  endTime: Scalars['DateTime']['output'];
  endTimeLocal: Scalars['DateTime']['output'];
  endTimezone?: Maybe<Scalars['String']['output']>;
  equipment?: Maybe<Equipment>;
  equipmentId?: Maybe<Scalars['Int']['output']>;
  hasArrivalOverride: Scalars['Boolean']['output'];
  hasDepartureOverride: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  /** @deprecated use Order.instructions instead */
  instructions?: Maybe<Scalars['String']['output']>;
  integrations?: Maybe<RouteIntegrations>;
  overlaps: Array<OverlappingWaypoints>;
  revision: Scalars['Int']['output'];
  startTime: Scalars['DateTime']['output'];
  startTimeLocal: Scalars['DateTime']['output'];
  startTimezone?: Maybe<Scalars['String']['output']>;
  status: RouteStatus;
  updatedAt: Scalars['DateTime']['output'];
  waypoints: Array<RouteWaypoint>;
};

export type RouteDispatchInput = {
  id: Array<Scalars['Int']['input']>;
};

/** Select an existing address by id or provide a named freeform address. addressId and address are mutually exclusive. */
export type RouteEndpointInput = {
  /** A freeform address. Requires name when provided. */
  address?: InputMaybe<AddressInput>;
  /** The id of an existing tenant address. */
  addressId?: InputMaybe<Scalars['Int']['input']>;
  /** The display name required for a freeform address. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Whether to save a freeform address for reuse. Defaults to true. */
  saveForReuse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RouteIntegrations = {
  __typename?: 'RouteIntegrations';
  samsara?: Maybe<RouteSamsaraIntegration>;
};

export type RouteMutations = {
  __typename?: 'RouteMutations';
  dispatchMany?: Maybe<RouteMutationsDispatchResponse>;
  /** Rebuilds a route, re-querying drive times. An inactive or empty route, or one Mapbox still has no drive time for, is returned unchanged with `skippedReason`. */
  recalculate?: Maybe<RouteMutationsRecalculateResponse>;
  stagingPush?: Maybe<RouteMutationsStagingPushResponse>;
  updateMany?: Maybe<RouteMutationsUpdateResponse>;
};


export type RouteMutationsDispatchManyArgs = {
  where: RouteDispatchInput;
};


export type RouteMutationsRecalculateArgs = {
  id: Scalars['Int']['input'];
};


export type RouteMutationsStagingPushArgs = {
  input: StagingPushInput;
};


export type RouteMutationsUpdateManyArgs = {
  input: Array<RouteUpdateManyInput>;
};

export type RouteMutationsDispatchResponse = {
  __typename?: 'RouteMutationsDispatchResponse';
  routes: Array<Route>;
};

export type RouteMutationsRecalculateResponse = {
  __typename?: 'RouteMutationsRecalculateResponse';
  route: Route;
  /** Why the route was left unchanged; null when it was recalculated. */
  skippedReason?: Maybe<Scalars['String']['output']>;
};

export type RouteMutationsStagingPushResponse = {
  __typename?: 'RouteMutationsStagingPushResponse';
  lanes: Array<StagingPushLaneResult>;
};

export type RouteMutationsUpdateResponse = {
  __typename?: 'RouteMutationsUpdateResponse';
  routes: Array<Route>;
};

export type RouteSamsaraIntegration = {
  __typename?: 'RouteSamsaraIntegration';
  route?: Maybe<SamsaraRoute>;
};

export enum RouteStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  InProgress = 'inProgress',
  Scheduled = 'scheduled'
}

export type RouteTimelineItem = {
  __typename?: 'RouteTimelineItem';
  duration: Scalars['Int']['output'];
  endTime: Scalars['DateTime']['output'];
  order?: Maybe<Order>;
  originalEndTime?: Maybe<Scalars['DateTime']['output']>;
  originalStartTime?: Maybe<Scalars['DateTime']['output']>;
  scheduleChanged?: Maybe<Scalars['Boolean']['output']>;
  sort: Scalars['Int']['output'];
  startTime: Scalars['DateTime']['output'];
  type: Scalars['String']['output'];
};

export type RouteUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  /** Arrival override. Omit to leave unchanged or provide null to clear it. */
  arrival?: InputMaybe<RouteEndpointInput>;
  assignments?: InputMaybe<AssignmentsInput>;
  branchId?: InputMaybe<Scalars['Int']['input']>;
  /** Departure override. Omit to leave unchanged or provide null to clear it. */
  departure?: InputMaybe<RouteEndpointInput>;
  dispatched?: InputMaybe<Scalars['Boolean']['input']>;
  equipmentId?: InputMaybe<Scalars['Int']['input']>;
  revision?: InputMaybe<Scalars['Int']['input']>;
  waypoints?: InputMaybe<RouteWaypointsInput>;
};

export type RouteUpdateManyInput = {
  data: RouteUpdateInput;
  where: RouteWhereUniqueInput;
};

export type RouteWaypoint = {
  __typename?: 'RouteWaypoint';
  actualArrivalTime?: Maybe<Scalars['DateTime']['output']>;
  actualArrivalTimeLocal?: Maybe<Scalars['DateTime']['output']>;
  actualDepartureTime?: Maybe<Scalars['DateTime']['output']>;
  actualDepartureTimeLocal?: Maybe<Scalars['DateTime']['output']>;
  address: Address;
  addressId: Scalars['Int']['output'];
  arrivalPerformance?: Maybe<RouteWaypointPerformance>;
  conflictArrivalTime?: Maybe<Scalars['DateTime']['output']>;
  conflictArrivalTimeLocal?: Maybe<Scalars['DateTime']['output']>;
  conflictDepartureTime?: Maybe<Scalars['DateTime']['output']>;
  conflictDepartureTimeLocal?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  departurePerformance?: Maybe<RouteWaypointPerformance>;
  estimatedArrivalTime?: Maybe<Scalars['DateTime']['output']>;
  estimatedArrivalTimeLocal?: Maybe<Scalars['DateTime']['output']>;
  estimatedDepartureTime?: Maybe<Scalars['DateTime']['output']>;
  estimatedDepartureTimeLocal?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  metadata?: Maybe<Array<KeyValue>>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  route: Route;
  routeId: Scalars['Int']['output'];
  scheduledArrivalTime?: Maybe<Scalars['DateTime']['output']>;
  scheduledArrivalTimeLocal?: Maybe<Scalars['DateTime']['output']>;
  scheduledDepartureTime?: Maybe<Scalars['DateTime']['output']>;
  scheduledDepartureTimeLocal?: Maybe<Scalars['DateTime']['output']>;
  status: RouteWaypointStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type RouteWaypointInput = {
  actualArrivalTime?: InputMaybe<Scalars['DateTime']['input']>;
  actualDepartureTime?: InputMaybe<Scalars['DateTime']['input']>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  estimatedArrivalTime?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<KeyValuesInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  scheduledArrivalTime?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDepartureTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum RouteWaypointPerformance {
  Late = 'late',
  OnTime = 'onTime',
  VeryLate = 'veryLate'
}

export enum RouteWaypointStatus {
  Completed = 'completed',
  EnRoute = 'enRoute',
  InProgress = 'inProgress',
  Scheduled = 'scheduled'
}

export type RouteWaypointUpsertInput = {
  data?: InputMaybe<RouteWaypointInput>;
  where?: InputMaybe<RouteWaypointWhereUniqueInput>;
};

export type RouteWaypointWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type RouteWaypointsInput = {
  set?: InputMaybe<Array<RouteWaypointInput>>;
  upsert?: InputMaybe<Array<RouteWaypointUpsertInput>>;
};

export type RouteWhereUniqueInput = {
  id: Scalars['Int']['input'];
  revision?: InputMaybe<Scalars['Int']['input']>;
};

export type Samsara = {
  __typename?: 'Samsara';
  accessToken?: Maybe<IntegrationToken>;
  drivers: Array<SamsaraDriver>;
  settings?: Maybe<SamsaraSettings>;
  vehicles: Array<SamsaraVehicle>;
};

export type SamsaraDriver = {
  __typename?: 'SamsaraDriver';
  driverActivationStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type SamsaraMutationNamespace = {
  __typename?: 'SamsaraMutationNamespace';
  connect: GenericResponse;
  linkDriver: Operator;
  linkRoute: Route;
  linkVehicle: Equipment;
};


export type SamsaraMutationNamespaceConnectArgs = {
  token: Scalars['String']['input'];
};


export type SamsaraMutationNamespaceLinkDriverArgs = {
  driverId?: InputMaybe<Scalars['String']['input']>;
  operator: OperatorWhereUniqueInput;
};


export type SamsaraMutationNamespaceLinkRouteArgs = {
  route: RouteWhereUniqueInput;
  samsaraRouteId?: InputMaybe<Scalars['String']['input']>;
};


export type SamsaraMutationNamespaceLinkVehicleArgs = {
  equipment: EquipmentWhereUniqueInput;
  vehicleId?: InputMaybe<Scalars['String']['input']>;
};

export type SamsaraRoute = {
  __typename?: 'SamsaraRoute';
  id: Scalars['String']['output'];
};

export enum SamsaraRouteAssignmentTarget {
  Driver = 'driver',
  Vehicle = 'vehicle'
}

export type SamsaraSettings = {
  __typename?: 'SamsaraSettings';
  autoAssignDriversToVehicles: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  organizationId: Scalars['String']['output'];
  routeAssignmentTarget: SamsaraRouteAssignmentTarget;
};

export type SamsaraVehicle = {
  __typename?: 'SamsaraVehicle';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
};

export type ScheduleStep = {
  __typename?: 'ScheduleStep';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum SegmentType {
  Idle = 'IDLE',
  Travel = 'TRAVEL',
  Waypoint = 'WAYPOINT'
}

export type SendEmailInput = {
  forceResend?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  url: Scalars['String']['input'];
  urlWorkTicket?: InputMaybe<Scalars['String']['input']>;
};

export type SendEmailResponse = {
  __typename?: 'SendEmailResponse';
  success: Scalars['Boolean']['output'];
};

export type SendOrderMessageInput = {
  forceResend?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
};

export type SendPaymentMethodRequestInput = {
  customerId: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type SendPaymentMethodRequestResponse = {
  __typename?: 'SendPaymentMethodRequestResponse';
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SendPaymentReceiptInput = {
  forceResend?: InputMaybe<Scalars['Boolean']['input']>;
  paymentId: Scalars['String']['input'];
};

export type SendPreparedPaymentByEmailInput = {
  email: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type SendPreparedPaymentBySmsInput = {
  id: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type SendPreparedPaymentResponse = {
  __typename?: 'SendPreparedPaymentResponse';
  success: Scalars['Boolean']['output'];
};

export type SendSmsInput = {
  forceResend?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type SendSmsResponse = {
  __typename?: 'SendSmsResponse';
  success: Scalars['Boolean']['output'];
};

export type Service = {
  __typename?: 'Service';
  active: Scalars['Boolean']['output'];
  additionalIds?: Maybe<Array<KeyValue>>;
  branches: Array<Branch>;
  category?: Maybe<Scalars['String']['output']>;
  changelog?: Maybe<Changelog>;
  createdAt: Scalars['DateTime']['output'];
  defaultTaxCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invoiceTemplate?: Maybe<InvoiceTemplate>;
  metadata?: Maybe<Array<KeyValue>>;
  name: Scalars['String']['output'];
  revision: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ServiceCategoryWhereUniqueInput = {
  id: Scalars['Int']['input'];
  revision?: InputMaybe<Scalars['Int']['input']>;
};

export type ServiceCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  branches?: InputMaybe<Array<BranchWhereUniqueInput>>;
  category?: InputMaybe<Scalars['String']['input']>;
  defaultTaxCode?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  invoiceTemplate: InvoiceTemplateRelationInput;
  metadata?: InputMaybe<KeyValuesInput>;
  name: Scalars['String']['input'];
};

export type ServiceMutations = {
  __typename?: 'ServiceMutations';
  create: ServiceMutationsCreateResponse;
  update: ServiceMutationsUpdateResponse;
};


export type ServiceMutationsCreateArgs = {
  data: ServiceCreateInput;
};


export type ServiceMutationsUpdateArgs = {
  data: ServiceUpdateInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceMutationsCreateResponse = {
  __typename?: 'ServiceMutationsCreateResponse';
  service: Service;
};

export type ServiceMutationsUpdateResponse = {
  __typename?: 'ServiceMutationsUpdateResponse';
  service: Service;
};

export type ServiceUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  branches?: InputMaybe<Array<BranchWhereUniqueInput>>;
  category?: InputMaybe<Scalars['String']['input']>;
  defaultTaxCode?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  invoiceTemplate?: InputMaybe<InvoiceTemplateRelationInput>;
  metadata?: InputMaybe<KeyValuesInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceWhereUniqueInput = {
  id: Scalars['Int']['input'];
  revision?: InputMaybe<Scalars['Int']['input']>;
};

export type SetupIntent = {
  __typename?: 'SetupIntent';
  clientSecret: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  livemode: Scalars['Boolean']['output'];
  paymentMethodTypes?: Maybe<Array<PaymentMethodType>>;
  publishableKey: Scalars['String']['output'];
  status: Scalars['String']['output'];
  stripeId: Scalars['String']['output'];
};

export type ShareAccessToAllInput = {
  phoneNumber: Scalars['String']['input'];
};

export type ShareAccessToAllResponse = {
  __typename?: 'ShareAccessToAllResponse';
  link: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum SharingDirection {
  Offer = 'offer',
  Request = 'request'
}

export enum SharingDirectionEnum {
  Offer = 'offer',
  Request = 'request'
}

export enum SharingRequestStatus {
  Accepted = 'accepted',
  Pending = 'pending',
  Rejected = 'rejected',
  Withdrawn = 'withdrawn'
}

export enum SharingType {
  All = 'all',
  Collection = 'collection'
}

export type ShortLink = {
  __typename?: 'ShortLink';
  active: Scalars['Boolean']['output'];
  authorization?: Maybe<Authorization>;
  createdAt: Scalars['DateTime']['output'];
  expires?: Maybe<Scalars['DateTime']['output']>;
  redirect: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sub?: Maybe<Scalars['Int']['output']>;
  tid: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Signature = {
  __typename?: 'Signature';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  image: Scalars['String']['output'];
  metadata?: Maybe<Array<KeyValue>>;
  person?: Maybe<Person>;
  personId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SimpleBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Site = {
  __typename?: 'Site';
  active: Scalars['Boolean']['output'];
  additionalIds?: Maybe<Array<KeyValue>>;
  address: Address;
  addressId: Scalars['Int']['output'];
  changelog?: Maybe<Changelog>;
  comments: Array<Comment>;
  commentsCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerId: Scalars['Int']['output'];
  defaultPriceList?: Maybe<PriceList>;
  emails: Array<Scalars['String']['output']>;
  hasInstructions: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
  linesOnSite: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  name2?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  phones: Array<Phone>;
  priceLists: Array<PriceList>;
  reportingEntities: Array<ReportingEntity>;
  requestLocation?: Maybe<Message>;
  status: SiteStatus;
  tags: Array<Tag>;
  updatedAt: Scalars['DateTime']['output'];
  verified: Scalars['Boolean']['output'];
};

export type SiteInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  address: NavigableAddressInput;
  comments?: InputMaybe<CommentsInput>;
  customerId: Scalars['Int']['input'];
  defaultPriceList?: InputMaybe<PriceListWhereUniqueInput>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  geoArea?: InputMaybe<GeoAreaCreateInput>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  linesOnSite?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name2?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phones?: InputMaybe<Array<PhoneInput>>;
  priceLists?: InputMaybe<Array<PriceListWhereUniqueInput>>;
  reportingEntityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<SiteStatus>;
  tags?: InputMaybe<TagsInput>;
};

export type SiteMutations = {
  __typename?: 'SiteMutations';
  merge: SiteMutationsMergeResponse;
};


export type SiteMutationsMergeArgs = {
  data: SiteMutationsMergeDataInput;
  where: SiteWhereUniqueInput;
};

export type SiteMutationsMergeDataInput = {
  with: Array<SiteWhereUniqueInput>;
};

export type SiteMutationsMergeResponse = {
  __typename?: 'SiteMutationsMergeResponse';
  deletedIds: Array<Scalars['Int']['output']>;
  site: Site;
};

export enum SiteStatus {
  AwaitingLocation = 'AWAITING_LOCATION',
  ExtensiveArea = 'EXTENSIVE_AREA',
  Valid = 'VALID'
}

export type SiteUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  address?: InputMaybe<AddressInput>;
  comments?: InputMaybe<CommentsInput>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceList?: InputMaybe<PriceListWhereUniqueInput>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  geoArea?: InputMaybe<GeoAreaUpdateInput>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  linesOnSite?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name2?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phones?: InputMaybe<Array<PhoneInput>>;
  priceLists?: InputMaybe<Array<PriceListWhereUniqueInput>>;
  reportingEntityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<SiteStatus>;
  tags?: InputMaybe<TagsInput>;
};

export type SiteWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SortOrderInput {
  Asc = 'asc',
  Desc = 'desc'
}

/** Type-specific detail for a LedgerEntrySource row. */
export type SourceDetail = InvoiceSourceDetail | ManualLedgerEntrySourceDetail | PaymentAllocationSourceDetail | PaymentSourceDetail | ProcessingFeeExpenseSourceDetail | RefundSourceDetail;

export enum StagingPlacementSource {
  Backlog = 'backlog',
  Live = 'live'
}

export type StagingPushInput = {
  autoAssignDefaultOperators?: InputMaybe<Scalars['Boolean']['input']>;
  branchId: Scalars['Int']['input'];
  lanes: Array<StagingPushLaneInput>;
};

export type StagingPushLaneInput = {
  equipmentId?: InputMaybe<Scalars['Int']['input']>;
  laneKey: Scalars['String']['input'];
  operatorId?: InputMaybe<Scalars['Int']['input']>;
  placements: Array<StagingPushPlacementInput>;
  routeId?: InputMaybe<Scalars['Int']['input']>;
  routeRevision?: InputMaybe<Scalars['Int']['input']>;
  writeOperator?: Scalars['Boolean']['input'];
};

export type StagingPushLaneResult = {
  __typename?: 'StagingPushLaneResult';
  laneKey: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
  operatorWritten: Scalars['Boolean']['output'];
  orders: Array<StagingPushOrderResult>;
  rolledBack: Scalars['Boolean']['output'];
  routeId?: Maybe<Scalars['Int']['output']>;
};

export type StagingPushOrderResult = {
  __typename?: 'StagingPushOrderResult';
  message?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  orderId: Scalars['Int']['output'];
};

export type StagingPushPlacementInput = {
  ignoreOverlaps?: InputMaybe<Scalars['Boolean']['input']>;
  orderId: Scalars['Int']['input'];
  revision: Scalars['Int']['input'];
  source: StagingPlacementSource;
};

export type Statement = {
  __typename?: 'Statement';
  amountDue?: Maybe<Scalars['Decimal']['output']>;
  batch: StatementBatch;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  customer: Customer;
  date: Scalars['Date']['output'];
  emails: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invoices: Array<Invoice>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Deprecated, use `date` */
  statementDate: Scalars['Date']['output'];
  status: StatementStatus;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type StatementBatch = {
  __typename?: 'StatementBatch';
  changelog?: Maybe<Changelog>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  statements: Array<Statement>;
  updatedAt: Scalars['DateTime']['output'];
};


export type StatementBatchStatementsArgs = {
  cursor?: InputMaybe<StatementWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type StatementMutations = {
  __typename?: 'StatementMutations';
  generate?: Maybe<StatementMutationsGenerateResponse>;
  sendEmail?: Maybe<StatementMutationsSendEmailResponse>;
};


export type StatementMutationsGenerateArgs = {
  where: StatementWhereUniqueInput;
};


export type StatementMutationsSendEmailArgs = {
  where: StatementWhereUniqueInput;
};

export type StatementMutationsGenerateResponse = {
  __typename?: 'StatementMutationsGenerateResponse';
  statement: Statement;
};

export type StatementMutationsSendEmailResponse = {
  __typename?: 'StatementMutationsSendEmailResponse';
  statement: Statement;
  success: Scalars['Boolean']['output'];
};

export enum StatementStatus {
  Generated = 'generated',
  Queued = 'queued',
  Sent = 'sent'
}

export type StatementWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type StatementsBatchInput = {
  customerIds: Array<Scalars['Int']['input']>;
  date: Scalars['Date']['input'];
};

export type StatementsMutations = {
  __typename?: 'StatementsMutations';
  batch?: Maybe<StatementsMutationsBatchResponse>;
};


export type StatementsMutationsBatchArgs = {
  data: StatementsBatchInput;
};

export type StatementsMutationsBatchResponse = {
  __typename?: 'StatementsMutationsBatchResponse';
  batch: StatementBatch;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Stripe = {
  __typename?: 'Stripe';
  account?: Maybe<StripeAccount>;
  payout?: Maybe<StripePayoutDetail>;
  payoutSummary?: Maybe<StripePayoutSummary>;
  payouts: StripePayoutsPage;
};


export type StripePayoutArgs = {
  id: Scalars['String']['input'];
  transactionsCursor?: InputMaybe<Scalars['String']['input']>;
  transactionsTake?: InputMaybe<Scalars['Int']['input']>;
};


export type StripePayoutsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type StripeAccount = {
  __typename?: 'StripeAccount';
  id: Scalars['String']['output'];
  publishableKey: Scalars['String']['output'];
};

export type StripeAccountSession = {
  __typename?: 'StripeAccountSession';
  account: StripeAccount;
  clientSecret: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  hasOnboarded: Scalars['Boolean']['output'];
  livemode: Scalars['Boolean']['output'];
};

export type StripeMutations = {
  __typename?: 'StripeMutations';
  createSession?: Maybe<StripeMutationsCreateSessionResponse>;
};

export type StripeMutationsCreateSessionResponse = {
  __typename?: 'StripeMutationsCreateSessionResponse';
  session: StripeAccountSession;
};

export type StripePayout = {
  __typename?: 'StripePayout';
  amount: Scalars['Decimal']['output'];
  arrivalDate: Scalars['DateTime']['output'];
  created: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  method: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type StripePayoutDetail = {
  __typename?: 'StripePayoutDetail';
  amount: Scalars['Decimal']['output'];
  arrivalDate: Scalars['DateTime']['output'];
  created: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  method: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transactions: Array<StripePayoutTransaction>;
  transactionsHasMore: Scalars['Boolean']['output'];
  transactionsNextCursor?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type StripePayoutSummary = {
  __typename?: 'StripePayoutSummary';
  currency: Scalars['String']['output'];
  onTheWayAmount: Scalars['Decimal']['output'];
  totalBalance: Scalars['Decimal']['output'];
  /** @deprecated Use onTheWayAmount. */
  upcomingPayoutAmount?: Maybe<Scalars['Decimal']['output']>;
};

export type StripePayoutTransaction = {
  __typename?: 'StripePayoutTransaction';
  amount: Scalars['Decimal']['output'];
  created: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fee: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  net: Scalars['Decimal']['output'];
  payment?: Maybe<StripePayoutTransactionPayment>;
  type: Scalars['String']['output'];
};

export type StripePayoutTransactionInvoice = {
  __typename?: 'StripePayoutTransactionInvoice';
  id: Scalars['String']['output'];
  number: Scalars['String']['output'];
};

export type StripePayoutTransactionPayment = {
  __typename?: 'StripePayoutTransactionPayment';
  customerName?: Maybe<Scalars['String']['output']>;
  invoices: Array<StripePayoutTransactionInvoice>;
  number?: Maybe<Scalars['String']['output']>;
  paymentDate?: Maybe<Scalars['Date']['output']>;
  paymentId: Scalars['String']['output'];
};

export type StripePayoutsPage = {
  __typename?: 'StripePayoutsPage';
  hasMore: Scalars['Boolean']['output'];
  items: Array<StripePayout>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type SubEntity = {
  __typename?: 'SubEntity';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SubRequest = {
  __typename?: 'SubRequest';
  bookingBranch: Branch;
  bookingOrder: Order;
  bookingPerson: Person;
  changelog?: Maybe<Changelog>;
  createdAt: Scalars['DateTime']['output'];
  fulfillmentBranch: Branch;
  fulfillmentPerson?: Maybe<Person>;
  id: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  proposedChanges?: Maybe<Scalars['Json']['output']>;
  status: SubRequestStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type SubRequestAcceptDataInput = {
  equipmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type SubRequestCancelAllWhereInput = {
  orderId: Scalars['Int']['input'];
};

export type SubRequestCreateDataInput = {
  orderId: Scalars['Int']['input'];
  sendTo: Array<SubRequestCreateDataSendToInput>;
};

export type SubRequestCreateDataSendToInput = {
  subEntityId: Scalars['String']['input'];
};

export type SubRequestMutations = {
  __typename?: 'SubRequestMutations';
  accept: SubRequestMutationsAcceptResponse;
  /** Cancel all pending subs */
  cancelAll: SubRequestMutationsCancelAllResponse;
  create: SubRequestMutationsCreateResponse;
  decline: SubRequestMutationsDeclineResponse;
  /** Recover a previously subbed order */
  withdraw: SubRequestMutationsWithdrawResponse;
};


export type SubRequestMutationsAcceptArgs = {
  data?: InputMaybe<SubRequestAcceptDataInput>;
  where: SubRequestWhereUniqueInput;
};


export type SubRequestMutationsCancelAllArgs = {
  where: SubRequestCancelAllWhereInput;
};


export type SubRequestMutationsCreateArgs = {
  data: SubRequestCreateDataInput;
};


export type SubRequestMutationsDeclineArgs = {
  where: SubRequestWhereUniqueInput;
};


export type SubRequestMutationsWithdrawArgs = {
  where: SubRequestWhereUniqueInput;
};

export type SubRequestMutationsAcceptResponse = {
  __typename?: 'SubRequestMutationsAcceptResponse';
  subRequest: SubRequest;
};

export type SubRequestMutationsCancelAllResponse = {
  __typename?: 'SubRequestMutationsCancelAllResponse';
  subRequests: Array<SubRequest>;
};

export type SubRequestMutationsCreateResponse = {
  __typename?: 'SubRequestMutationsCreateResponse';
  subRequests: Array<SubRequest>;
};

export type SubRequestMutationsDeclineResponse = {
  __typename?: 'SubRequestMutationsDeclineResponse';
  subRequest: SubRequest;
};

export type SubRequestMutationsWithdrawResponse = {
  __typename?: 'SubRequestMutationsWithdrawResponse';
  subRequest: SubRequest;
};

export enum SubRequestStatus {
  Accepted = 'accepted',
  Cancelled = 'cancelled',
  ChangesRequested = 'changes_requested',
  Declined = 'declined',
  Pending = 'pending',
  Withdrawn = 'withdrawn'
}

export type SubRequestWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  currentPeriodStart?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: SubscriptionStatus;
  trialEnd?: Maybe<Scalars['DateTime']['output']>;
};

export type SubscriptionInvoiceUsageFee = {
  __typename?: 'SubscriptionInvoiceUsageFee';
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  flatCost: Scalars['Decimal']['output'];
  id: Scalars['Int']['output'];
  invoiceItem: InvoiceItem;
  invoiceItemId: Scalars['Int']['output'];
  listPrice: Scalars['Decimal']['output'];
  percentageCost: Scalars['Decimal']['output'];
  updatedAt: Scalars['DateTime']['output'];
  validFrom: Scalars['Date']['output'];
  validTo?: Maybe<Scalars['Date']['output']>;
};

export enum SubscriptionStatus {
  Active = 'active',
  Canceled = 'canceled',
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  PastDue = 'past_due',
  Paused = 'paused',
  Trialing = 'trialing',
  Unpaid = 'unpaid'
}

export type Supplier = {
  __typename?: 'Supplier';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  name2?: Maybe<Scalars['String']['output']>;
  phones: Array<Phone>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SupplierInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  metadata?: InputMaybe<KeyValuesInput>;
  name: Scalars['String']['input'];
  name2?: InputMaybe<Scalars['String']['input']>;
  phones?: InputMaybe<Array<PhoneInput>>;
};

export type SupplierUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  metadata?: InputMaybe<KeyValuesInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  name2?: InputMaybe<Scalars['String']['input']>;
  phones?: InputMaybe<Array<PhoneInput>>;
};

export type SupplierWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type SweepScheduledMessagesResult = {
  __typename?: 'SweepScheduledMessagesResult';
  cancelled: Scalars['Int']['output'];
  promoted: Scalars['Int']['output'];
};

export type Tag = {
  __typename?: 'Tag';
  active: Scalars['Boolean']['output'];
  callout?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  pinned: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TagDataUpdateInput = {
  active: Scalars['Boolean']['input'];
  callout?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  path: Scalars['String']['input'];
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['String']['input'];
  sort: Scalars['Int']['input'];
};

export type TagMutations = {
  __typename?: 'TagMutations';
  create: TagMutationsCreateResponse;
  update: TagMutationsUpdateResponse;
};


export type TagMutationsCreateArgs = {
  data: TagDataUpdateInput;
};


export type TagMutationsUpdateArgs = {
  data: TagDataUpdateInput;
  where: TagWhereUpdateUniqueInput;
};

export type TagMutationsCreateResponse = {
  __typename?: 'TagMutationsCreateResponse';
  tag: Tag;
};

export type TagMutationsUpdateResponse = {
  __typename?: 'TagMutationsUpdateResponse';
  tag: Tag;
};

export type TagWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type TagWhereUpdateUniqueInput = {
  id: Scalars['Int']['input'];
};

export type TagsInput = {
  connect?: InputMaybe<Array<TagWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<TagWhereUniqueInput>>;
};

export type TeamMemberAvailability = {
  __typename?: 'TeamMemberAvailability';
  assignments: Array<Assignment>;
  availabilities: Array<PersonAvailability>;
  id: Scalars['String']['output'];
  person: PersonInterface;
};

export type TelematicsGps = {
  __typename?: 'TelematicsGPS';
  enabled: Scalars['Boolean']['output'];
};

export type TelematicsStats = {
  __typename?: 'TelematicsStats';
  enabled: Scalars['Boolean']['output'];
};

export type Terms = {
  __typename?: 'Terms';
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  format: TermsFormat;
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  validFrom: Scalars['DateTime']['output'];
  validTo?: Maybe<Scalars['DateTime']['output']>;
};

export enum TermsFormat {
  Markdown = 'markdown',
  Text = 'text'
}

export type TermsUpdateInput = {
  body: Scalars['String']['input'];
  format?: InputMaybe<TermsFormat>;
  title: Scalars['String']['input'];
};

export type TestMappingRuleResult = {
  __typename?: 'TestMappingRuleResult';
  accountCode?: Maybe<Scalars['String']['output']>;
  alternativeRules: Array<RevenueMappingRule>;
  matchedCriteria: Array<Scalars['String']['output']>;
  matchedRule?: Maybe<RevenueMappingRule>;
};

export type TimeClock = {
  __typename?: 'TimeClock';
  changelog?: Maybe<Changelog>;
  createdAt: Scalars['DateTime']['output'];
  endTime?: Maybe<Scalars['DateTime']['output']>;
  hours?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  note?: Maybe<Scalars['String']['output']>;
  punchIn?: Maybe<TimeClockPunch>;
  punchOut?: Maybe<TimeClockPunch>;
  shift: TimeClockShift;
  startTime: Scalars['DateTime']['output'];
  task?: Maybe<TimeClockTask>;
  updatedAt: Scalars['DateTime']['output'];
  voidReason?: Maybe<Scalars['String']['output']>;
  voidReasonDetails?: Maybe<TimeClockVoidReason>;
  voided: Scalars['Boolean']['output'];
  voidedAt?: Maybe<Scalars['DateTime']['output']>;
  voidedBy?: Maybe<Person>;
};

export type TimeClockIsGeoRequiredWhereInput = {
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  personId?: InputMaybe<Scalars['Int']['input']>;
};

export type TimeClockIsNotRequiredWhereInput = {
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  personId?: InputMaybe<Scalars['Int']['input']>;
};

export type TimeClockMutations = {
  __typename?: 'TimeClockMutations';
  changeTask?: Maybe<TimeClockMutationsChangeTaskResponse>;
  clockIn?: Maybe<TimeClockMutationsClockInResponse>;
  clockOut?: Maybe<TimeClockMutationsClockOutResponse>;
  unvoid: TimeClockMutationsUnvoidResponse;
  update: TimeClockMutationsUpdateResponse;
  void: TimeClockMutationsVoidResponse;
};


export type TimeClockMutationsChangeTaskArgs = {
  data: TimesheetChangeTaskInput;
};


export type TimeClockMutationsClockInArgs = {
  data?: InputMaybe<TimesheetClockInInput>;
};


export type TimeClockMutationsClockOutArgs = {
  data?: InputMaybe<TimesheetClockOutInput>;
};


export type TimeClockMutationsUnvoidArgs = {
  data: TimeClockUnvoidInput;
};


export type TimeClockMutationsUpdateArgs = {
  data: TimeClockUpdateInput;
  where: TimeClockWhereUniqueInput;
};


export type TimeClockMutationsVoidArgs = {
  data: TimeClockVoidInput;
};

export type TimeClockMutationsChangeTaskResponse = {
  __typename?: 'TimeClockMutationsChangeTaskResponse';
  timeClock: TimeClock;
};

export type TimeClockMutationsClockInResponse = {
  __typename?: 'TimeClockMutationsClockInResponse';
  timeClock: TimeClock;
};

export type TimeClockMutationsClockOutResponse = {
  __typename?: 'TimeClockMutationsClockOutResponse';
  timeClock: TimeClock;
};

export type TimeClockMutationsUnvoidResponse = {
  __typename?: 'TimeClockMutationsUnvoidResponse';
  timeClock: TimeClock;
};

export type TimeClockMutationsUpdateResponse = {
  __typename?: 'TimeClockMutationsUpdateResponse';
  timeClock: TimeClock;
};

export type TimeClockMutationsVoidResponse = {
  __typename?: 'TimeClockMutationsVoidResponse';
  timeClock: TimeClock;
};

export type TimeClockPunch = {
  __typename?: 'TimeClockPunch';
  createdAt: Scalars['DateTime']['output'];
  geolocation?: Maybe<Geolocation>;
  id: Scalars['Int']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  time: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  violations: Array<TimeClockViolation>;
};

export type TimeClockShift = {
  __typename?: 'TimeClockShift';
  comments: Array<Comment>;
  createdAt: Scalars['DateTime']['output'];
  endTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  person: Person;
  startTime: Scalars['DateTime']['output'];
  timeClocks: Array<TimeClock>;
  updatedAt: Scalars['DateTime']['output'];
};


export type TimeClockShiftTimeClocksArgs = {
  includeVoided?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TimeClockShiftMutations = {
  __typename?: 'TimeClockShiftMutations';
  upsert: TimeClockShiftMutationsUpsertResponse;
};


export type TimeClockShiftMutationsUpsertArgs = {
  data: TimeClockShiftUpdateInput;
  where?: InputMaybe<TimeClockShiftWhereUniqueInput>;
};

export type TimeClockShiftMutationsUpsertResponse = {
  __typename?: 'TimeClockShiftMutationsUpsertResponse';
  shift: TimeClockShift;
};

export type TimeClockShiftUpdateInput = {
  comments?: InputMaybe<CommentsInput>;
  person?: InputMaybe<PersonWhereUniqueInput>;
  timeClocks?: InputMaybe<TimeClocksInput>;
};

export type TimeClockShiftWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type TimeClockTask = {
  __typename?: 'TimeClockTask';
  active: Scalars['Boolean']['output'];
  color: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  geoRequired?: Maybe<TimeClockTaskRequireGeolocation>;
  id: Scalars['Int']['output'];
  isGeoRequired: Scalars['Boolean']['output'];
  isNoteRequired: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  noteRequired?: Maybe<TimeClockTaskNoteRequired>;
  payable: Scalars['Boolean']['output'];
  sort: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type TimeClockTaskIsGeoRequiredArgs = {
  where?: InputMaybe<TimeClockIsGeoRequiredWhereInput>;
};


export type TimeClockTaskIsNoteRequiredArgs = {
  where?: InputMaybe<TimeClockIsNotRequiredWhereInput>;
};

export enum TimeClockTaskNoteRequired {
  IfOffAssignment = 'ifOffAssignment',
  Required = 'required'
}

export enum TimeClockTaskRequireGeolocation {
  IfOffAssignment = 'ifOffAssignment',
  Required = 'required'
}

export enum TimeClockTaskScope {
  Operator = 'operator',
  User = 'user'
}

export type TimeClockTaskWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type TimeClockUnvoidInput = {
  id: Scalars['Int']['input'];
};

export type TimeClockUpdateInput = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  task?: InputMaybe<TimeClockTaskWhereUniqueInput>;
};

export type TimeClockUpsertInput = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  task?: InputMaybe<TimeClockTaskWhereUniqueInput>;
};

export enum TimeClockViolation {
  OutsideGeofence = 'outsideGeofence'
}

export type TimeClockVoidInput = {
  id: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
};

export type TimeClockVoidReason = {
  __typename?: 'TimeClockVoidReason';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TimeClockWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type TimeClocksInput = {
  set?: InputMaybe<Array<TimeClockUpsertInput>>;
};

export enum TimeOffApproval {
  Approved = 'approved',
  Denied = 'denied',
  Requested = 'requested'
}

export enum TimeOffRecurrence {
  OneTime = 'one_time',
  Recurring = 'recurring'
}

export enum TimeOffSource {
  Admin = 'admin',
  Self = 'self'
}

export type TimeSheet = {
  __typename?: 'TimeSheet';
  endTime: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  person: PersonInterface;
  shifts: Array<TimeClockShift>;
  startTime: Scalars['DateTime']['output'];
  timeClocks: Array<TimeClock>;
};


export type TimeSheetShiftsArgs = {
  includeVoided?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TimeSheetTimeClocksArgs = {
  includeVoided?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TimeSheetsWhereInput = {
  endTime: Scalars['DateTime']['input'];
  personId?: InputMaybe<IntFilter>;
  startTime: Scalars['DateTime']['input'];
};

export type TimesheetChangeTaskInput = {
  geolocation?: InputMaybe<GeolocationInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  person?: InputMaybe<PersonWhereUniqueInput>;
  task: TimeClockTaskWhereUniqueInput;
};

export type TimesheetClockInInput = {
  geolocation?: InputMaybe<GeolocationInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  person?: InputMaybe<PersonWhereUniqueInput>;
  task?: InputMaybe<TimeClockTaskWhereUniqueInput>;
};

export type TimesheetClockOutInput = {
  geolocation?: InputMaybe<GeolocationInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  person?: InputMaybe<PersonWhereUniqueInput>;
};

export type TransactionHistory = {
  __typename?: 'TransactionHistory';
  amount: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  transactionDate: Scalars['DateTime']['output'];
  transactionType: Scalars['String']['output'];
};

export enum Transmission {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL'
}

export type TravelEstimate = {
  __typename?: 'TravelEstimate';
  distance?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  fromAddressId?: Maybe<Scalars['Int']['output']>;
  toAddressId?: Maybe<Scalars['Int']['output']>;
};

export type UnappliedPaymentItem = {
  __typename?: 'UnappliedPaymentItem';
  currency: Scalars['String']['output'];
  paymentDate: Scalars['Date']['output'];
  paymentId: Scalars['String']['output'];
  paymentNumber: Scalars['String']['output'];
  paymentTypeName?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  totalReceived: Scalars['Decimal']['output'];
  unappliedAmount: Scalars['Decimal']['output'];
};

export type UnappliedPayments = {
  __typename?: 'UnappliedPayments';
  currency: Scalars['String']['output'];
  customer: PaymentDetailsCustomer;
  payments: Array<UnappliedPaymentItem>;
  totalUnappliedAmount: Scalars['Decimal']['output'];
};

export type UnappliedPaymentsQueryWhereInput = {
  customerId: Scalars['Int']['input'];
};

export type UndepositedPayment = {
  __typename?: 'UndepositedPayment';
  amount: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  paymentDate: Scalars['Date']['output'];
  paymentId: Scalars['String']['output'];
  paymentSourceName?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
};

export type UndepositedSummary = {
  __typename?: 'UndepositedSummary';
  count: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  totalAmount: Scalars['Decimal']['output'];
};

export type UpdateDepositDraftInput = {
  controlTotal?: InputMaybe<Scalars['Decimal']['input']>;
  depositDate: Scalars['DateLike']['input'];
  depositId: Scalars['String']['input'];
  externalDepositRef?: InputMaybe<Scalars['String']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  paymentIds: Array<Scalars['String']['input']>;
};

export type UpdateTagsRelationsDataInput = {
  contacts?: InputMaybe<Array<ContactWhereUniqueInput>>;
  customers?: InputMaybe<Array<CustomerWhereUniqueInput>>;
  invoices?: InputMaybe<Array<InvoiceWhereUniqueInput>>;
  orders?: InputMaybe<Array<OrderWhereUniqueInput>>;
  priceLists?: InputMaybe<Array<PriceListWhereUniqueInput>>;
  sites?: InputMaybe<Array<SiteWhereUniqueInput>>;
};

export type UpdateTagsRelationsResponse = {
  __typename?: 'UpdateTagsRelationsResponse';
  contacts?: Maybe<Array<Contact>>;
  customers?: Maybe<Array<Customer>>;
  invoices?: Maybe<Array<Invoice>>;
  orders?: Maybe<Array<Order>>;
  priceLists?: Maybe<Array<PriceList>>;
  sites?: Maybe<Array<Site>>;
};

export type UploadTypesWhereInput = {
  acl?: InputMaybe<VisibilityEnum>;
  customKeyName?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertNotificationOverrideInput = {
  contactId?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  enabled: Scalars['Boolean']['input'];
  params?: InputMaybe<Scalars['Json']['input']>;
  ruleSlug: NotificationRuleSlug;
};

export type UpsertNotificationRuleConfigInput = {
  defaultEnabled: Scalars['Boolean']['input'];
  params?: InputMaybe<Scalars['Json']['input']>;
  ruleSlug: NotificationRuleSlug;
};

export type UseCreditBalanceResponse = {
  __typename?: 'UseCreditBalanceResponse';
  invoices: Array<Invoice>;
};

export type User = PersonInterface & {
  __typename?: 'User';
  active: Scalars['Boolean']['output'];
  additionalIds?: Maybe<Array<KeyValue>>;
  appFeatures: AppFeatures;
  changelog?: Maybe<Changelog>;
  createdAt: Scalars['DateTime']['output'];
  crispToken?: Maybe<Scalars['String']['output']>;
  emails: Array<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** A single feature flag; null for keys not in the flag registry. */
  flag?: Maybe<Scalars['Boolean']['output']>;
  /** Viewer-scoped feature flags: the tenant bag with registry defaults applied for unset keys, plus viewer overlays. */
  flags: Scalars['Json']['output'];
  id: Scalars['Int']['output'];
  integrations?: Maybe<UserIntegrations>;
  isAdmin: Scalars['Boolean']['output'];
  isOperator?: Maybe<Scalars['Boolean']['output']>;
  isSupport: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  legacyRoles?: Maybe<Array<UserRoleLegacy>>;
  messages: Array<Message>;
  operator?: Maybe<Operator>;
  organization: Organization;
  phones: Array<Phone>;
  platformTermsOfUse?: Maybe<PlatformTermsOfUseStatus>;
  preferences: UserPreferences;
  roles: Array<UserRole>;
  timeClock?: Maybe<TimeClock>;
  updatedAt: Scalars['DateTime']['output'];
  username: Scalars['String']['output'];
};


export type UserFlagArgs = {
  key: Scalars['String']['input'];
};

export type UserInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  credentials?: InputMaybe<CredentialsInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isOperator?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  legacyRoles?: InputMaybe<Array<UserRoleLegacy>>;
  phones?: InputMaybe<Array<PhoneInput>>;
  roles?: InputMaybe<Array<UserRoleWhereUniqueInput>>;
  username: Scalars['String']['input'];
};

export type UserIntegrations = {
  __typename?: 'UserIntegrations';
  all: Array<KeyValue>;
  paylocity?: Maybe<OperatorPaylocityIntegration>;
};

export type UserPermission = {
  __typename?: 'UserPermission';
  description?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
};

export type UserPreferences = {
  __typename?: 'UserPreferences';
  messages: Array<MessagePreference>;
};

export type UserRole = {
  __typename?: 'UserRole';
  active: Scalars['Boolean']['output'];
  changelog?: Maybe<Changelog>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  permissions: Array<UserPermission>;
  updatedAt: Scalars['DateTime']['output'];
};

export type UserRoleCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  permissionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum UserRoleLegacy {
  Admin = 'admin',
  Readonly = 'readonly'
}

export type UserRoleMutations = {
  __typename?: 'UserRoleMutations';
  create: UserRoleMutationsCreateResponse;
  update: UserRoleMutationsUpdateResponse;
};


export type UserRoleMutationsCreateArgs = {
  data: UserRoleCreateInput;
};


export type UserRoleMutationsUpdateArgs = {
  data: UserRoleUpdateInput;
  where: UserRoleWhereUniqueInput;
};

export type UserRoleMutationsCreateResponse = {
  __typename?: 'UserRoleMutationsCreateResponse';
  userRole: UserRole;
};

export type UserRoleMutationsUpdateResponse = {
  __typename?: 'UserRoleMutationsUpdateResponse';
  userRole: UserRole;
};

export type UserRoleUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserRoleWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type UserUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  credentials?: InputMaybe<CredentialsInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isOperator?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  legacyRoles?: InputMaybe<Array<UserRoleLegacy>>;
  phones?: InputMaybe<Array<PhoneInput>>;
  roles?: InputMaybe<Array<UserRoleWhereUniqueInput>>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type ValidateEmailInput = {
  email: Scalars['String']['input'];
};

export type ValidateQuery = {
  __typename?: 'ValidateQuery';
  email: EmailValidationResult;
};


export type ValidateQueryEmailArgs = {
  input: ValidateEmailInput;
};

export enum VisibilityEnum {
  Private = 'private',
  PublicRead = 'publicRead'
}

export type VoidInvoiceInput = {
  additionalIds?: InputMaybe<KeyValuesInput>;
  amountDue: Scalars['Decimal']['input'];
  billTo?: InputMaybe<InvoiceBillToInput>;
  branch: BranchWhereUniqueInput;
  comments?: InputMaybe<CommentsInput>;
  currency: Scalars['String']['input'];
  customer?: InputMaybe<CustomerWhereUniqueInput>;
  details?: InputMaybe<Array<InvoiceDetailInput>>;
  draftCreditMemo?: InputMaybe<Scalars['Decimal']['input']>;
  dueDate: Scalars['Date']['input'];
  emails: Array<Scalars['String']['input']>;
  invoiceDate: Scalars['Date']['input'];
  lines?: InputMaybe<InvoiceLinesInput>;
  memo?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<KeyValuesInput>;
  number: Scalars['String']['input'];
  orders?: InputMaybe<Array<OrderWhereUniqueInput>>;
  priceList?: InputMaybe<PriceListWhereUniqueInput>;
  purchaseOrder?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<SiteWhereUniqueInput>;
  status: Scalars['String']['input'];
  tags?: InputMaybe<TagsInput>;
  title?: InputMaybe<InvoiceTitleInput>;
};

export type VoidPaymentInput = {
  date?: InputMaybe<Scalars['DateLike']['input']>;
  paymentId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  txId?: InputMaybe<Scalars['String']['input']>;
};

export type VoidRefundInput = {
  paymentId: Scalars['String']['input'];
  refundId: Scalars['String']['input'];
  txId?: InputMaybe<Scalars['String']['input']>;
};

export type Wallet = {
  __typename?: 'Wallet';
  availablePaymentMethod?: Maybe<PaymentMethod>;
  availablePaymentMethods: Array<PaymentMethod>;
  paymentMethods: Array<PaymentMethod>;
};


export type WalletAvailablePaymentMethodArgs = {
  id: Scalars['String']['input'];
};


export type WalletAvailablePaymentMethodsArgs = {
  where: WalletAvailablePaymentMethodsWhereInput;
};


export type WalletPaymentMethodsArgs = {
  where?: InputMaybe<WalletPaymentMethodsWhereInput>;
};

export type WalletAvailablePaymentMethodsWhereInput = {
  active?: InputMaybe<SimpleBoolFilter>;
  customer: CustomerWhereUniqueInput;
};

export type WalletPaymentMethodsWhereInput = {
  active?: InputMaybe<SimpleBoolFilter>;
};

export type WithdrawnSharingRequestInput = {
  requestId: Scalars['Int']['input'];
};

export type WithdrawnSharingRequestResponse = {
  __typename?: 'WithdrawnSharingRequestResponse';
  message: Scalars['String']['output'];
};

export type Yard = {
  __typename?: 'Yard';
  active: Scalars['Boolean']['output'];
  additionalIds?: Maybe<Array<KeyValue>>;
  address: Address;
  branch: Branch;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  metadata?: Maybe<Array<KeyValue>>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type YardCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  address: NavigableAddressInput;
  metadata?: InputMaybe<KeyValuesInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type YardUpdateArgs = {
  data: YardUpdateInput;
  where: YardWhereUniqueInput;
};

export type YardUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalIds?: InputMaybe<KeyValuesInput>;
  address?: InputMaybe<AddressInput>;
  metadata?: InputMaybe<KeyValuesInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type YardWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type YardsInput = {
  create?: InputMaybe<Array<YardCreateInput>>;
  update?: InputMaybe<Array<YardUpdateArgs>>;
};

export type AssignmentCardSlimDataFragment = { __typename?: 'Assignment', id: number, acknowledged?: boolean | null, active: boolean, usesOnsiteTimes: boolean, route?: { __typename?: 'Route', id: number, status: RouteStatus, active: boolean, startTimeLocal: string, endTimeLocal: string, equipment?: { __typename?: 'Equipment', id: number, name: string } | null, waypoints: Array<{ __typename?: 'RouteWaypoint', id: number, scheduledArrivalTime?: string | null, scheduledArrivalTimeLocal?: string | null, order?: { __typename?: 'Order', id: number, status: string } | null }> } | null } & { ' $fragmentName'?: 'AssignmentCardSlimDataFragment' };

export type GetOperatorWithAssignmentsQueryVariables = Exact<{
  operatorId: Scalars['Int']['input'];
}>;


export type GetOperatorWithAssignmentsQuery = { __typename?: 'Query', operators: Array<{ __typename?: 'Operator', id: number, assignments: Array<(
      { __typename?: 'Assignment', id: number }
      & { ' $fragmentRefs'?: { 'AssignmentCardSlimDataFragment': AssignmentCardSlimDataFragment } }
    )> }> };

export type GetAssignmentQueryVariables = Exact<{
  assignmentId: Scalars['Int']['input'];
}>;


export type GetAssignmentQuery = { __typename?: 'Query', assignment?: { __typename?: 'Assignment', id: number, acknowledged?: boolean | null, acknowledgedAt?: string | null, active: boolean, usesOnsiteTimes: boolean, crewAddendumMarkdown?: string | null, roleDetails: { __typename?: 'AssignmentRole', slug: string, name: string, sort: number }, operator: { __typename?: 'Operator', id: number, firstName?: string | null, lastName?: string | null }, route?: { __typename?: 'Route', id: number, status: RouteStatus, active: boolean, startTimeLocal: string, endTimeLocal: string, equipment?: { __typename?: 'Equipment', id: number, name: string, telematics: { __typename?: 'EquipmentTelematics', gps?: { __typename?: 'TelematicsGPS', enabled: boolean } | null, stats?: { __typename?: 'TelematicsStats', enabled: boolean } | null } } | null, assignments: Array<{ __typename?: 'Assignment', id: number, roleDetails: { __typename?: 'AssignmentRole', slug: string, name: string, sort: number }, operator: { __typename?: 'Operator', id: number, firstName?: string | null, lastName?: string | null, phones: Array<{ __typename?: 'Phone', id: number, number: string }> } }>, waypoints: Array<{ __typename?: 'RouteWaypoint', id: number, status: RouteWaypointStatus, name?: string | null, scheduledArrivalTime?: string | null, scheduledDepartureTime?: string | null, scheduledArrivalTimeLocal?: string | null, scheduledDepartureTimeLocal?: string | null, conflictArrivalTimeLocal?: string | null, conflictDepartureTimeLocal?: string | null, actualArrivalTimeLocal?: string | null, actualDepartureTimeLocal?: string | null, address: { __typename?: 'Address', street?: string | null, city?: string | null, state?: string | null, zip?: string | null, lat?: number | null, lng?: number | null }, order?: { __typename?: 'Order', id: number, status: string, instructions?: string | null, linesOnSite: boolean, dateOfServiceLocal?: string | null, site?: { __typename?: 'Site', id: number, name?: string | null, address: { __typename?: 'Address', street?: string | null, city?: string | null, state?: string | null, zip?: string | null, lat?: number | null, lng?: number | null } } | null, customer?: { __typename?: 'Customer', id: number, name: string, nickname?: string | null } | null, planned?: { __typename?: 'OrderDetails', id: number, inventory: Array<{ __typename?: 'OrderInventoryItem', id: number, quantity?: number | null, item: { __typename?: 'InventoryItem', id: number, name: string, consumable: boolean, displayUnit?: string | null, visibility: { __typename?: 'InventoryItemVisibilities', operatorAssignment: InventoryItemVisibility } } }> } | null } | null }> } | null } | null };

export type AcknowledgeAssignmentMutationVariables = Exact<{
  where: AcknowledgeAssignmentInput;
}>;


export type AcknowledgeAssignmentMutation = { __typename?: 'Mutation', acknowledgeAssignment?: { __typename?: 'Assignment', id: number, acknowledged?: boolean | null, acknowledgedAt?: string | null } | null };

export type UpdateRouteWaypointMutationVariables = Exact<{
  data: RouteWaypointInput;
  where: RouteWaypointWhereUniqueInput;
}>;


export type UpdateRouteWaypointMutation = { __typename?: 'Mutation', updateRouteWaypoint?: { __typename?: 'RouteWaypoint', id: number, status: RouteWaypointStatus, actualArrivalTimeLocal?: string | null, actualDepartureTimeLocal?: string | null } | null };

export type CurrentUserQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQueryQuery = { __typename?: 'Query', me?: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, flags: any, organization: { __typename?: 'Organization', id: number, name: string, logo?: string | null, primaryColor?: string | null, billingProfile?: { __typename?: 'BillingProfile', currency: string, locale: string } | null, config: { __typename?: 'OrganizationConfig', customerApp: { __typename?: 'OrgConfigCustomerApp', requestPreWorkAuthorization: boolean }, crew: { __typename?: 'OrgConfigCrew', assignmentHideDetailsTillAck: boolean, assignmentReportAtDuration: number, orderAllowOperatorToCancel: boolean, workTicketRequireSignature: boolean }, modules: { __typename?: 'OrgConfigModules', timeclocks: boolean }, localization: { __typename?: 'OrgConfigLocalization', useCubicMeters: boolean } } } } | { __typename?: 'Operator', id: number, firstName?: string | null, lastName?: string | null, flags: any, organization: { __typename?: 'Organization', id: number, name: string, logo?: string | null, primaryColor?: string | null, billingProfile?: { __typename?: 'BillingProfile', currency: string, locale: string } | null, config: { __typename?: 'OrganizationConfig', customerApp: { __typename?: 'OrgConfigCustomerApp', requestPreWorkAuthorization: boolean }, crew: { __typename?: 'OrgConfigCrew', assignmentHideDetailsTillAck: boolean, assignmentReportAtDuration: number, orderAllowOperatorToCancel: boolean, workTicketRequireSignature: boolean }, modules: { __typename?: 'OrgConfigModules', timeclocks: boolean }, localization: { __typename?: 'OrgConfigLocalization', useCubicMeters: boolean } } } } | { __typename?: 'Person', id: number, firstName?: string | null, lastName?: string | null, flags: any, organization: { __typename?: 'Organization', id: number, name: string, logo?: string | null, primaryColor?: string | null, billingProfile?: { __typename?: 'BillingProfile', currency: string, locale: string } | null, config: { __typename?: 'OrganizationConfig', customerApp: { __typename?: 'OrgConfigCustomerApp', requestPreWorkAuthorization: boolean }, crew: { __typename?: 'OrgConfigCrew', assignmentHideDetailsTillAck: boolean, assignmentReportAtDuration: number, orderAllowOperatorToCancel: boolean, workTicketRequireSignature: boolean }, modules: { __typename?: 'OrgConfigModules', timeclocks: boolean }, localization: { __typename?: 'OrgConfigLocalization', useCubicMeters: boolean } } } } | { __typename?: 'User', id: number, firstName?: string | null, lastName?: string | null, flags: any, organization: { __typename?: 'Organization', id: number, name: string, logo?: string | null, primaryColor?: string | null, billingProfile?: { __typename?: 'BillingProfile', currency: string, locale: string } | null, config: { __typename?: 'OrganizationConfig', customerApp: { __typename?: 'OrgConfigCustomerApp', requestPreWorkAuthorization: boolean }, crew: { __typename?: 'OrgConfigCrew', assignmentHideDetailsTillAck: boolean, assignmentReportAtDuration: number, orderAllowOperatorToCancel: boolean, workTicketRequireSignature: boolean }, modules: { __typename?: 'OrgConfigModules', timeclocks: boolean }, localization: { __typename?: 'OrgConfigLocalization', useCubicMeters: boolean } } } } | null };

export type GetOrderCancellationReasonsQueryVariables = Exact<{
  where?: InputMaybe<QueryOrderCancellationReasonsWhereInput>;
}>;


export type GetOrderCancellationReasonsQuery = { __typename?: 'Query', orderCancellationReasons: Array<{ __typename?: 'OrderCancellationReason', name: string, slug: string, sort: number }> };

export type CancelOrderMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  comment: CommentInput;
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
}>;


export type CancelOrderMutation = { __typename?: 'Mutation', updateOrder?: { __typename?: 'Order', id: number, status: string, cancellationReason?: string | null, statusDetails: { __typename?: 'OrderStatus', slug: string, name: string } } | null };

export type GetOrderPhotosQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type GetOrderPhotosQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: number, photos: Array<{ __typename?: 'OrderPhoto', id: number, clientId: string, thumbUrl: string, url: string, takenAt?: string | null, createdAt: string, uploadedByName?: string | null }> } | null };

export type GetOrderPhotoCountQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type GetOrderPhotoCountQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: number, photos: Array<{ __typename?: 'OrderPhoto', id: number, clientId: string }> } | null };

export type PresignOrderPhotoUploadMutationVariables = Exact<{
  orderId: Scalars['Int']['input'];
  data: OrderPhotoPresignInput;
}>;


export type PresignOrderPhotoUploadMutation = { __typename?: 'Mutation', orderPhoto?: { __typename?: 'OrderPhotoMutations', presignUpload: { __typename?: 'OrderPhotoPresignResponse', photoUploadUrl: string, thumbUploadUrl: string } } | null };

export type CreateOrderPhotoMutationVariables = Exact<{
  orderId: Scalars['Int']['input'];
  data: OrderPhotoCreateInput;
}>;


export type CreateOrderPhotoMutation = { __typename?: 'Mutation', orderPhoto?: { __typename?: 'OrderPhotoMutations', create: { __typename?: 'OrderPhoto', id: number, clientId: string, thumbUrl: string, url: string, width?: number | null, height?: number | null, takenAt?: string | null, createdAt: string, uploadedByName?: string | null } } | null };

export type GetOrderDetailQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type GetOrderDetailQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: number, name: string, dateOfServiceLocal?: string | null, purchaseOrder?: string | null, instructions?: string | null, linesOnSite: boolean, cashOnDelivery: boolean, status: string, cancellationReason?: string | null, statusDetails: { __typename?: 'OrderStatus', slug: string, name: string }, service?: { __typename?: 'Service', id: number, name: string } | null, planned?: { __typename?: 'OrderDetails', id: number, inventory: Array<{ __typename?: 'OrderInventoryItem', id: number, quantity?: number | null, item: { __typename?: 'InventoryItem', id: number, name: string, consumable: boolean, displayUnit?: string | null, visibility: { __typename?: 'InventoryItemVisibilities', operatorAssignment: InventoryItemVisibility } } }>, schedule: Array<{ __typename?: 'OrderScheduleEntry', id: number, scheduleIndex: number, startTime?: string | null, endTime?: string | null, duration?: number | null, step: string, pour?: { __typename?: 'OrderPour', id: number, name?: string | null, type?: { __typename?: 'PourType', id: number, name: string } | null } | null, metrics: Array<{ __typename?: 'OrderMetric', key: string, value?: number | string | null }> }> } | null, supplier?: { __typename?: 'Supplier', id: number, name: string, name2?: string | null, phones: Array<{ __typename?: 'Phone', id: number, number: string }> } | null, customer?: { __typename?: 'Customer', id: number, name: string } | null, site?: { __typename?: 'Site', id: number, name?: string | null, name2?: string | null, instructions?: string | null, address: { __typename?: 'Address', street?: string | null, city?: string | null, state?: string | null, zip?: string | null, lat?: number | null, lng?: number | null, timezone?: string | null } } | null, contacts: Array<{ __typename?: 'OrderContact', id: number, default: boolean, contact: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null, phones: Array<{ __typename?: 'Phone', id: number, number: string }> }, role?: { __typename?: 'ContactRole', id: number, name: string, slug: string } | null }>, terms: { __typename?: 'OrderTerms', needsAcceptance: boolean, accepted: boolean, content: { __typename?: 'Terms', title: string, body: string, format: TermsFormat } } } | null };

export type MyOrganizationsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type MyOrganizationsQueryQuery = { __typename?: 'Query', myOrganizations: Array<{ __typename?: 'Organization', id: number, name: string, logo?: string | null, primaryColor?: string | null }> };

export type GetPreWorkAuthorizationQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type GetPreWorkAuthorizationQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: number, signatures: Array<{ __typename?: 'OrderSignatureStatus', purpose: OrderSignaturePurpose, signed: boolean }> } | null };

export type TriggerPreWorkAuthorizationMutationVariables = Exact<{
  input: NotificationTrigger;
}>;


export type TriggerPreWorkAuthorizationMutation = { __typename?: 'Mutation', notification?: { __typename?: 'NotificationMutations', trigger: { __typename?: 'NotificationMutationsTriggerResponse', ok: boolean } } | null };

export type GetShortLinkQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetShortLinkQuery = { __typename?: 'Query', shortLink?: { __typename?: 'ShortLink', slug: string, sub?: number | null, redirect: string, expires?: string | null, authorization?: { __typename?: 'Authorization', token?: string | null } | null } | null };

export type GetOrderDataForSignatureQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type GetOrderDataForSignatureQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: number, customer?: { __typename?: 'Customer', id: number } | null, contacts: Array<{ __typename?: 'OrderContact', id: number, default: boolean, contact: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null }, role?: { __typename?: 'ContactRole', name: string, slug: string, sort: number } | null }>, terms: { __typename?: 'OrderTerms', id: number, accepted: boolean, needsAcceptance: boolean, content: { __typename?: 'Terms', id: number, title: string, body: string, format: TermsFormat } } } | null };

export type GetCustomerContactsQueryVariables = Exact<{
  customerId: Scalars['Int']['input'];
}>;


export type GetCustomerContactsQuery = { __typename?: 'Query', customers: Array<{ __typename?: 'Customer', id: number, contacts: Array<{ __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null }> }> };

export type GetWorkTicketDataForSignatureQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type GetWorkTicketDataForSignatureQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: number, dateOfServiceLocal?: string | null, status: string, branchId?: number | null, customer?: { __typename?: 'Customer', id: number } | null, contacts: Array<{ __typename?: 'OrderContact', id: number, default: boolean, contact: { __typename?: 'Contact', id: number, firstName?: string | null, lastName?: string | null }, role?: { __typename?: 'ContactRole', name: string, slug: string, sort: number } | null }>, terms: { __typename?: 'OrderTerms', id: number, accepted: boolean, needsAcceptance: boolean, content: { __typename?: 'Terms', id: number, title: string, body: string, format: TermsFormat } }, statusDetails: { __typename?: 'OrderStatus', slug: string, name: string }, site?: { __typename?: 'Site', id: number, address: { __typename?: 'Address', id: number, timezone?: string | null } } | null, signature?: { __typename?: 'Signature', id: number, metadata?: Array<{ __typename?: 'KeyValue', key?: string | null, value?: any | null }> | null } | null, assignments?: Array<{ __typename?: 'Assignment', id: number, roleDetails: { __typename?: 'AssignmentRole', slug: string, sort: number }, operator: { __typename?: 'Operator', id: number, firstName?: string | null, lastName?: string | null } }> | null, planned?: { __typename?: 'OrderDetails', id: number, equipment?: { __typename?: 'Equipment', id: number, name: string, displayName?: string | null } | null, inventory: Array<{ __typename?: 'OrderInventoryItem', id: number, quantity?: number | null, item: { __typename?: 'InventoryItem', id: number, name: string, category?: string | null, displayUnit?: string | null, visibility: { __typename?: 'InventoryItemVisibilities', operatorWorkTicket: InventoryItemVisibility, customerWorkTicket: InventoryItemVisibility } } }>, schedule: Array<{ __typename?: 'OrderScheduleEntry', id: number, scheduleIndex: number, startTime?: string | null, endTime?: string | null, step: string, stepDetails: { __typename?: 'ScheduleStep', slug: string, name: string }, metrics: Array<{ __typename?: 'OrderMetric', key: string, value?: number | string | null }> }> } | null, billable?: { __typename?: 'OrderDetails', equipment?: { __typename?: 'Equipment', id: number, name: string, displayName?: string | null } | null } | null, actuals: Array<{ __typename?: 'OrderDetails', id: number, subType?: string | null, inventory: Array<{ __typename?: 'OrderInventoryItem', id: number, quantity?: number | null, item: { __typename?: 'InventoryItem', id: number, name: string, category?: string | null, displayUnit?: string | null, visibility: { __typename?: 'InventoryItemVisibilities', operatorWorkTicket: InventoryItemVisibility, customerWorkTicket: InventoryItemVisibility } } }>, schedule: Array<{ __typename?: 'OrderScheduleEntry', id: number, scheduleIndex: number, startTime?: string | null, endTime?: string | null, step: string, stepDetails: { __typename?: 'ScheduleStep', slug: string, name: string }, metrics: Array<{ __typename?: 'OrderMetric', key: string, value?: number | string | null }> }> }> } | null };

export type CollectOrderSignatureMutationVariables = Exact<{
  data: CollectSignatureInput;
  where: OrderWhereUniqueInput;
}>;


export type CollectOrderSignatureMutation = { __typename?: 'Mutation', collectOrderSignature?: { __typename?: 'Signature', id: number } | null };

export type TimeClockDataFragment = { __typename?: 'TimeClock', id: number, startTime: string, endTime?: string | null, task?: { __typename?: 'TimeClockTask', id: number, name: string, payable: boolean } | null, shift: { __typename?: 'TimeClockShift', id: number, startTime: string, endTime?: string | null } } & { ' $fragmentName'?: 'TimeClockDataFragment' };

export type GetTimeClockQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTimeClockQuery = { __typename?: 'Query', me?: { __typename?: 'Contact', id: number } | { __typename?: 'Operator', id: number, timeClock?: (
      { __typename?: 'TimeClock' }
      & { ' $fragmentRefs'?: { 'TimeClockDataFragment': TimeClockDataFragment } }
    ) | null } | { __typename?: 'Person', id: number } | { __typename?: 'User', id: number } | null };

export type GetTimeClockTasksQueryVariables = Exact<{
  where?: InputMaybe<QueryTimeClockTasksWhereInput>;
  noteRequired?: InputMaybe<TimeClockIsNotRequiredWhereInput>;
  geoRequired?: InputMaybe<TimeClockIsGeoRequiredWhereInput>;
}>;


export type GetTimeClockTasksQuery = { __typename?: 'Query', timeClockTasks: Array<{ __typename?: 'TimeClockTask', id: number, name: string, isNoteRequired: boolean, noteRequired?: TimeClockTaskNoteRequired | null, isGeoRequired: boolean, geoRequired?: TimeClockTaskRequireGeolocation | null, payable: boolean, sort: number }> };

export type ClockInMutationVariables = Exact<{
  data: TimesheetClockInInput;
}>;


export type ClockInMutation = { __typename?: 'Mutation', timeClock?: { __typename?: 'TimeClockMutations', clockIn?: { __typename?: 'TimeClockMutationsClockInResponse', timeClock: (
        { __typename?: 'TimeClock' }
        & { ' $fragmentRefs'?: { 'TimeClockDataFragment': TimeClockDataFragment } }
      ) } | null } | null };

export type ClockOutMutationVariables = Exact<{
  data: TimesheetClockOutInput;
}>;


export type ClockOutMutation = { __typename?: 'Mutation', timeClock?: { __typename?: 'TimeClockMutations', clockOut?: { __typename?: 'TimeClockMutationsClockOutResponse', timeClock: (
        { __typename?: 'TimeClock' }
        & { ' $fragmentRefs'?: { 'TimeClockDataFragment': TimeClockDataFragment } }
      ) } | null } | null };

export type ChangeTaskMutationVariables = Exact<{
  data: TimesheetChangeTaskInput;
}>;


export type ChangeTaskMutation = { __typename?: 'Mutation', timeClock?: { __typename?: 'TimeClockMutations', changeTask?: { __typename?: 'TimeClockMutationsChangeTaskResponse', timeClock: (
        { __typename?: 'TimeClock' }
        & { ' $fragmentRefs'?: { 'TimeClockDataFragment': TimeClockDataFragment } }
      ) } | null } | null };

export type GetTimeSheetQueryVariables = Exact<{
  where?: InputMaybe<PersonTimeSheetWhereInput>;
}>;


export type GetTimeSheetQuery = { __typename?: 'Query', me?: { __typename?: 'Contact', id: number } | { __typename?: 'Operator', id: number, timeSheet?: { __typename?: 'TimeSheet', id: string, startTime: string, endTime: string, shifts: Array<{ __typename?: 'TimeClockShift', id: number, startTime: string, endTime?: string | null, timeClocks: Array<{ __typename?: 'TimeClock', id: number, startTime: string, endTime?: string | null, voided: boolean, voidReason?: string | null, voidReasonDetails?: { __typename?: 'TimeClockVoidReason', name: string } | null, task?: { __typename?: 'TimeClockTask', id: number, name: string, sort: number, color: string } | null }> }> } | null } | { __typename?: 'Person', id: number } | { __typename?: 'User', id: number } | null };

export type GetOrderWorkTicketDataQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type GetOrderWorkTicketDataQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: number, dateOfServiceLocal?: string | null, status: string, branchId?: number | null, statusDetails: { __typename?: 'OrderStatus', slug: string, name: string }, comments: Array<{ __typename?: 'Comment', id: number, personId?: number | null, text: string, metadata: Array<{ __typename?: 'KeyValue', key?: string | null, value?: any | null }> }>, site?: { __typename?: 'Site', id: number, address: { __typename?: 'Address', id: number, timezone?: string | null } } | null, signature?: { __typename?: 'Signature', id: number, metadata?: Array<{ __typename?: 'KeyValue', key?: string | null, value?: any | null }> | null } | null, planned?: { __typename?: 'OrderDetails', id: number, inventory: Array<{ __typename?: 'OrderInventoryItem', id: number, quantity?: number | null, item: { __typename?: 'InventoryItem', id: number, name: string, branchId: number, category?: string | null, displayUnit?: string | null, visibility: { __typename?: 'InventoryItemVisibilities', operatorWorkTicket: InventoryItemVisibility, operatorAssignment: InventoryItemVisibility, customerWorkTicket: InventoryItemVisibility } } }>, schedule: Array<{ __typename?: 'OrderScheduleEntry', id: number, scheduleIndex: number, startTime?: string | null, endTime?: string | null, step: string, stepDetails: { __typename?: 'ScheduleStep', slug: string, name: string }, metrics: Array<{ __typename?: 'OrderMetric', key: string, value?: number | string | null }> }> } | null, actuals: Array<{ __typename?: 'OrderDetails', id: number, subType?: string | null, inventory: Array<{ __typename?: 'OrderInventoryItem', id: number, quantity?: number | null, item: { __typename?: 'InventoryItem', id: number, name: string, branchId: number, category?: string | null, displayUnit?: string | null, visibility: { __typename?: 'InventoryItemVisibilities', operatorWorkTicket: InventoryItemVisibility, operatorAssignment: InventoryItemVisibility, customerWorkTicket: InventoryItemVisibility } } }>, schedule: Array<{ __typename?: 'OrderScheduleEntry', id: number, scheduleIndex: number, startTime?: string | null, endTime?: string | null, step: string, stepDetails: { __typename?: 'ScheduleStep', slug: string, name: string }, metrics: Array<{ __typename?: 'OrderMetric', key: string, value?: number | string | null }> }> }> } | null };

export type GetWorkTicketInventoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorkTicketInventoryQuery = { __typename?: 'Query', inventory: Array<{ __typename?: 'InventoryItem', id: number, name: string, branchId: number, category?: string | null, displayUnit?: string | null, visibility: { __typename?: 'InventoryItemVisibilities', operatorWorkTicket: InventoryItemVisibility, operatorAssignment: InventoryItemVisibility, customerWorkTicket: InventoryItemVisibility } }> };

export type SubmitWorkTicketMutationVariables = Exact<{
  data: OrderUpdateInput;
  where: OrderWhereUniqueInput;
}>;


export type SubmitWorkTicketMutation = { __typename?: 'Mutation', updateOrder?: { __typename?: 'Order', id: number, status: string, statusDetails: { __typename?: 'OrderStatus', slug: string, name: string } } | null };

export const AssignmentCardSlimDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssignmentCardSlimData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"acknowledged"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"usesOnsiteTimes"}},{"kind":"Field","name":{"kind":"Name","value":"route"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"startTimeLocal"}},{"kind":"Field","name":{"kind":"Name","value":"endTimeLocal"}},{"kind":"Field","name":{"kind":"Name","value":"equipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"waypoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledArrivalTime"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledArrivalTimeLocal"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AssignmentCardSlimDataFragment, unknown>;
export const TimeClockDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeClockData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TimeClock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"payable"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shift"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}}]}}]} as unknown as DocumentNode<TimeClockDataFragment, unknown>;
export const GetOperatorWithAssignmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOperatorWithAssignments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"operatorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operatorId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"visible"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssignmentCardSlimData"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssignmentCardSlimData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"acknowledged"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"usesOnsiteTimes"}},{"kind":"Field","name":{"kind":"Name","value":"route"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"startTimeLocal"}},{"kind":"Field","name":{"kind":"Name","value":"endTimeLocal"}},{"kind":"Field","name":{"kind":"Name","value":"equipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"waypoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledArrivalTime"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledArrivalTimeLocal"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOperatorWithAssignmentsQuery, GetOperatorWithAssignmentsQueryVariables>;
export const GetAssignmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssignment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assignmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assignmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"acknowledged"}},{"kind":"Field","name":{"kind":"Name","value":"acknowledgedAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"usesOnsiteTimes"}},{"kind":"Field","name":{"kind":"Name","value":"crewAddendumMarkdown"}},{"kind":"Field","name":{"kind":"Name","value":"roleDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}}]}},{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"route"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"startTimeLocal"}},{"kind":"Field","name":{"kind":"Name","value":"endTimeLocal"}},{"kind":"Field","name":{"kind":"Name","value":"equipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"telematics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roleDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}}]}},{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"waypoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledArrivalTime"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledDepartureTime"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledArrivalTimeLocal"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledDepartureTimeLocal"}},{"kind":"Field","name":{"kind":"Name","value":"conflictArrivalTimeLocal"}},{"kind":"Field","name":{"kind":"Name","value":"conflictDepartureTimeLocal"}},{"kind":"Field","name":{"kind":"Name","value":"actualArrivalTimeLocal"}},{"kind":"Field","name":{"kind":"Name","value":"actualDepartureTimeLocal"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"linesOnSite"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfServiceLocal"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"planned"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"consumable"}},{"kind":"Field","name":{"kind":"Name","value":"displayUnit"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operatorAssignment"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAssignmentQuery, GetAssignmentQueryVariables>;
export const AcknowledgeAssignmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcknowledgeAssignment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AcknowledgeAssignmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acknowledgeAssignment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"acknowledged"}},{"kind":"Field","name":{"kind":"Name","value":"acknowledgedAt"}}]}}]}}]} as unknown as DocumentNode<AcknowledgeAssignmentMutation, AcknowledgeAssignmentMutationVariables>;
export const UpdateRouteWaypointDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRouteWaypoint"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RouteWaypointInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RouteWaypointWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRouteWaypoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"actualArrivalTimeLocal"}},{"kind":"Field","name":{"kind":"Name","value":"actualDepartureTimeLocal"}}]}}]}}]} as unknown as DocumentNode<UpdateRouteWaypointMutation, UpdateRouteWaypointMutationVariables>;
export const CurrentUserQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentUserQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"primaryColor"}},{"kind":"Field","name":{"kind":"Name","value":"billingProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}},{"kind":"Field","name":{"kind":"Name","value":"config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerApp"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestPreWorkAuthorization"}}]}},{"kind":"Field","name":{"kind":"Name","value":"crew"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentHideDetailsTillAck"}},{"kind":"Field","name":{"kind":"Name","value":"assignmentReportAtDuration"}},{"kind":"Field","name":{"kind":"Name","value":"orderAllowOperatorToCancel"}},{"kind":"Field","name":{"kind":"Name","value":"workTicketRequireSignature"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeclocks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"localization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"useCubicMeters"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CurrentUserQueryQuery, CurrentUserQueryQueryVariables>;
export const GetOrderCancellationReasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrderCancellationReasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryOrderCancellationReasonsWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderCancellationReasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}}]}}]}}]} as unknown as DocumentNode<GetOrderCancellationReasonsQuery, GetOrderCancellationReasonsQueryVariables>;
export const CancelOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CommentInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cancellationReason"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"revision"},"value":{"kind":"IntValue","value":"-42"}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"StringValue","value":"cancelled","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"cancellationReason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cancellationReason"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"comments"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"comment"}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cancellationReason"}}]}}]}}]} as unknown as DocumentNode<CancelOrderMutation, CancelOrderMutationVariables>;
export const GetOrderPhotosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrderPhotos"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"thumbUrl"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"takenAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedByName"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrderPhotosQuery, GetOrderPhotosQueryVariables>;
export const GetOrderPhotoCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrderPhotoCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrderPhotoCountQuery, GetOrderPhotoCountQueryVariables>;
export const PresignOrderPhotoUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PresignOrderPhotoUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPhotoPresignInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"presignUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoUploadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"thumbUploadUrl"}}]}}]}}]}}]} as unknown as DocumentNode<PresignOrderPhotoUploadMutation, PresignOrderPhotoUploadMutationVariables>;
export const CreateOrderPhotoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrderPhoto"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPhotoCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"thumbUrl"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"takenAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedByName"}}]}}]}}]}}]} as unknown as DocumentNode<CreateOrderPhotoMutation, CreateOrderPhotoMutationVariables>;
export const GetOrderDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrderDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfServiceLocal"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseOrder"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"linesOnSite"}},{"kind":"Field","name":{"kind":"Name","value":"cashOnDelivery"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"planned"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"consumable"}},{"kind":"Field","name":{"kind":"Name","value":"displayUnit"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operatorAssignment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleIndex"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"pour"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"step"}},{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"name2"}},{"kind":"Field","name":{"kind":"Name","value":"phones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"name2"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"terms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"needsAcceptance"}},{"kind":"Field","name":{"kind":"Name","value":"accepted"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"format"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cancellationReason"}}]}}]}}]} as unknown as DocumentNode<GetOrderDetailQuery, GetOrderDetailQueryVariables>;
export const MyOrganizationsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyOrganizationsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myOrganizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"primaryColor"}}]}}]}}]} as unknown as DocumentNode<MyOrganizationsQueryQuery, MyOrganizationsQueryQueryVariables>;
export const GetPreWorkAuthorizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPreWorkAuthorization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purpose"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}}]}}]}}]}}]} as unknown as DocumentNode<GetPreWorkAuthorizationQuery, GetPreWorkAuthorizationQueryVariables>;
export const TriggerPreWorkAuthorizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TriggerPreWorkAuthorization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationTrigger"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trigger"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]}}]} as unknown as DocumentNode<TriggerPreWorkAuthorizationMutation, TriggerPreWorkAuthorizationMutationVariables>;
export const GetShortLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetShortLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sub"}},{"kind":"Field","name":{"kind":"Name","value":"redirect"}},{"kind":"Field","name":{"kind":"Name","value":"expires"}},{"kind":"Field","name":{"kind":"Name","value":"authorization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}}]}}]}}]}}]} as unknown as DocumentNode<GetShortLinkQuery, GetShortLinkQueryVariables>;
export const GetOrderDataForSignatureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrderDataForSignature"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"terms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accepted"}},{"kind":"Field","name":{"kind":"Name","value":"needsAcceptance"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"format"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOrderDataForSignatureQuery, GetOrderDataForSignatureQueryVariables>;
export const GetCustomerContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCustomerContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<GetCustomerContactsQuery, GetCustomerContactsQueryVariables>;
export const GetWorkTicketDataForSignatureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkTicketDataForSignature"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"terms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accepted"}},{"kind":"Field","name":{"kind":"Name","value":"needsAcceptance"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"format"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dateOfServiceLocal"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"branchId"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"signature"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roleDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}}]}},{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"planned"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"equipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"displayUnit"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operatorWorkTicket"}},{"kind":"Field","name":{"kind":"Name","value":"customerWorkTicket"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleIndex"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"step"}},{"kind":"Field","name":{"kind":"Name","value":"stepDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"billable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actuals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subType"}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"displayUnit"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operatorWorkTicket"}},{"kind":"Field","name":{"kind":"Name","value":"customerWorkTicket"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleIndex"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"step"}},{"kind":"Field","name":{"kind":"Name","value":"stepDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetWorkTicketDataForSignatureQuery, GetWorkTicketDataForSignatureQueryVariables>;
export const CollectOrderSignatureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CollectOrderSignature"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectSignatureInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectOrderSignature"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CollectOrderSignatureMutation, CollectOrderSignatureMutationVariables>;
export const GetTimeClockDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTimeClock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Operator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeClock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeClockData"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeClockData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TimeClock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"payable"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shift"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}}]}}]} as unknown as DocumentNode<GetTimeClockQuery, GetTimeClockQueryVariables>;
export const GetTimeClockTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTimeClockTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryTimeClockTasksWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"noteRequired"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TimeClockIsNotRequiredWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"geoRequired"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TimeClockIsGeoRequiredWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeClockTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isNoteRequired"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"noteRequired"}}}]},{"kind":"Field","name":{"kind":"Name","value":"noteRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isGeoRequired"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"geoRequired"}}}]},{"kind":"Field","name":{"kind":"Name","value":"geoRequired"}},{"kind":"Field","name":{"kind":"Name","value":"payable"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}}]}}]}}]} as unknown as DocumentNode<GetTimeClockTasksQuery, GetTimeClockTasksQueryVariables>;
export const ClockInDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClockIn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimesheetClockInInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeClock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clockIn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeClock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeClockData"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeClockData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TimeClock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"payable"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shift"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}}]}}]} as unknown as DocumentNode<ClockInMutation, ClockInMutationVariables>;
export const ClockOutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClockOut"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimesheetClockOutInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeClock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clockOut"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeClock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeClockData"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeClockData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TimeClock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"payable"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shift"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}}]}}]} as unknown as DocumentNode<ClockOutMutation, ClockOutMutationVariables>;
export const ChangeTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimesheetChangeTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeClock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeClock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeClockData"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeClockData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TimeClock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"payable"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shift"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}}]}}]} as unknown as DocumentNode<ChangeTaskMutation, ChangeTaskMutationVariables>;
export const GetTimeSheetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTimeSheet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PersonTimeSheetWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Operator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeSheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeVoided"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"shifts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeVoided"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeClocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeVoided"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"voided"}},{"kind":"Field","name":{"kind":"Name","value":"voidReason"}},{"kind":"Field","name":{"kind":"Name","value":"voidReasonDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTimeSheetQuery, GetTimeSheetQueryVariables>;
export const GetOrderWorkTicketDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrderWorkTicketData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfServiceLocal"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"branchId"}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"personId"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"signature"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"planned"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"branchId"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"displayUnit"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operatorWorkTicket"}},{"kind":"Field","name":{"kind":"Name","value":"operatorAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"customerWorkTicket"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleIndex"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"step"}},{"kind":"Field","name":{"kind":"Name","value":"stepDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actuals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subType"}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"branchId"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"displayUnit"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operatorWorkTicket"}},{"kind":"Field","name":{"kind":"Name","value":"operatorAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"customerWorkTicket"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleIndex"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"step"}},{"kind":"Field","name":{"kind":"Name","value":"stepDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOrderWorkTicketDataQuery, GetOrderWorkTicketDataQueryVariables>;
export const GetWorkTicketInventoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkTicketInventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inventory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"branchId"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"displayUnit"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operatorWorkTicket"}},{"kind":"Field","name":{"kind":"Name","value":"operatorAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"customerWorkTicket"}}]}}]}}]}}]} as unknown as DocumentNode<GetWorkTicketInventoryQuery, GetWorkTicketInventoryQueryVariables>;
export const SubmitWorkTicketDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitWorkTicket"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<SubmitWorkTicketMutation, SubmitWorkTicketMutationVariables>;